// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders, PartialBy } from '../types';
import type {
  FilesFileSchemaWithId,
  FilesFileSchemaWithIdNullable,
  FilesFormatSchemaWithIdNullable,
  FilesKeyframeSchemaWithId,
  FilesKeyframeSchemaWithIdNullable,
  FilesProxySchemaWithId,
} from './files';

export const AssetsHttpPostApprovalsBulk =
  'AssetsHttpPostApprovalsBulk' as const;
export const AssetsHttpPostApprovalsBulkRemove =
  'AssetsHttpPostApprovalsBulkRemove' as const;
export const AssetsHttpGetAssets = 'AssetsHttpGetAssets' as const;
export const AssetsHttpPatchAssets = 'AssetsHttpPatchAssets' as const;
export const AssetsHttpPostAssets = 'AssetsHttpPostAssets' as const;
export const AssetsHttpPutAssets = 'AssetsHttpPutAssets' as const;
export const AssetsHttpGetAssetsRecent = 'AssetsHttpGetAssetsRecent' as const;
export const AssetsHttpPostAssetsReindex =
  'AssetsHttpPostAssetsReindex' as const;
export const AssetsHttpGetAssetsRelationTypes =
  'AssetsHttpGetAssetsRelationTypes' as const;
export const AssetsHttpPostAssetsRelationTypes =
  'AssetsHttpPostAssetsRelationTypes' as const;
export const AssetsHttpDeleteAssetsRelationTypesByRelationType =
  'AssetsHttpDeleteAssetsRelationTypesByRelationType' as const;
export const AssetsHttpGetAssetsRelationTypesByRelationType =
  'AssetsHttpGetAssetsRelationTypesByRelationType' as const;
export const AssetsHttpPatchAssetsRelationTypesByRelationType =
  'AssetsHttpPatchAssetsRelationTypesByRelationType' as const;
export const AssetsHttpPutAssetsRelationTypesByRelationType =
  'AssetsHttpPutAssetsRelationTypesByRelationType' as const;
export const AssetsHttpPostAssetsSegmentsReindex =
  'AssetsHttpPostAssetsSegmentsReindex' as const;
export const AssetsHttpDeleteAssetsByAssetId =
  'AssetsHttpDeleteAssetsByAssetId' as const;
export const AssetsHttpGetAssetsByAssetId =
  'AssetsHttpGetAssetsByAssetId' as const;
export const AssetsHttpPatchAssetsByAssetId =
  'AssetsHttpPatchAssetsByAssetId' as const;
export const AssetsHttpPutAssetsByAssetId =
  'AssetsHttpPutAssetsByAssetId' as const;
export const AssetsHttpGetAssetsByAssetIdHistory =
  'AssetsHttpGetAssetsByAssetIdHistory' as const;
export const AssetsHttpPostAssetsByAssetIdHistory =
  'AssetsHttpPostAssetsByAssetIdHistory' as const;
export const AssetsHttpDeleteAssetsByAssetIdHistoryByHistoryEntityId =
  'AssetsHttpDeleteAssetsByAssetIdHistoryByHistoryEntityId' as const;
export const AssetsHttpGetAssetsByAssetIdHistoryByHistoryEntityId =
  'AssetsHttpGetAssetsByAssetIdHistoryByHistoryEntityId' as const;
export const AssetsHttpPostAssetsByAssetIdHistoryByHistoryEntityIdReindex =
  'AssetsHttpPostAssetsByAssetIdHistoryByHistoryEntityIdReindex' as const;
export const AssetsHttpDeleteAssetsByAssetIdPurge =
  'AssetsHttpDeleteAssetsByAssetIdPurge' as const;
export const AssetsHttpPostAssetsByAssetIdReindex =
  'AssetsHttpPostAssetsByAssetIdReindex' as const;
export const AssetsHttpGetAssetsByAssetIdRelations =
  'AssetsHttpGetAssetsByAssetIdRelations' as const;
export const AssetsHttpPostAssetsByAssetIdRelations =
  'AssetsHttpPostAssetsByAssetIdRelations' as const;
export const AssetsHttpGetAssetsByAssetIdRelationsByRelationType =
  'AssetsHttpGetAssetsByAssetIdRelationsByRelationType' as const;
export const AssetsHttpDeleteAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId =
  'AssetsHttpDeleteAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId' as const;
export const AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId =
  'AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId' as const;
export const AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetIdReverse =
  'AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetIdReverse' as const;
export const AssetsHttpPutAssetsByAssetIdRestore =
  'AssetsHttpPutAssetsByAssetIdRestore' as const;
export const AssetsHttpPutAssetsByAssetIdSearchDocument =
  'AssetsHttpPutAssetsByAssetIdSearchDocument' as const;
export const AssetsHttpGetAssetsByAssetIdSegments =
  'AssetsHttpGetAssetsByAssetIdSegments' as const;
export const AssetsHttpPostAssetsByAssetIdSegments =
  'AssetsHttpPostAssetsByAssetIdSegments' as const;
export const AssetsHttpDeleteAssetsByAssetIdSegmentsBulk =
  'AssetsHttpDeleteAssetsByAssetIdSegmentsBulk' as const;
export const AssetsHttpPostAssetsByAssetIdSegmentsBulk =
  'AssetsHttpPostAssetsByAssetIdSegmentsBulk' as const;
export const AssetsHttpPutAssetsByAssetIdSegmentsBulk =
  'AssetsHttpPutAssetsByAssetIdSegmentsBulk' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsCsv =
  'AssetsHttpGetAssetsByAssetIdSegmentsCsv' as const;
export const AssetsHttpPostAssetsByAssetIdSegmentsReindex =
  'AssetsHttpPostAssetsByAssetIdSegmentsReindex' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsSrt =
  'AssetsHttpGetAssetsByAssetIdSegmentsSrt' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsText =
  'AssetsHttpGetAssetsByAssetIdSegmentsText' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsVtt =
  'AssetsHttpGetAssetsByAssetIdSegmentsVtt' as const;
export const AssetsHttpDeleteAssetsByAssetIdSegmentsBySegmentId =
  'AssetsHttpDeleteAssetsByAssetIdSegmentsBySegmentId' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsBySegmentId =
  'AssetsHttpGetAssetsByAssetIdSegmentsBySegmentId' as const;
export const AssetsHttpPatchAssetsByAssetIdSegmentsBySegmentId =
  'AssetsHttpPatchAssetsByAssetIdSegmentsBySegmentId' as const;
export const AssetsHttpPutAssetsByAssetIdSegmentsBySegmentId =
  'AssetsHttpPutAssetsByAssetIdSegmentsBySegmentId' as const;
export const AssetsHttpPostAssetsByAssetIdSegmentsBySegmentIdReindex =
  'AssetsHttpPostAssetsByAssetIdSegmentsBySegmentIdReindex' as const;
export const AssetsHttpGetAssetsByAssetIdSegmentsBySegmentType =
  'AssetsHttpGetAssetsByAssetIdSegmentsBySegmentType' as const;
export const AssetsHttpGetAssetsByAssetIdSharesAll =
  'AssetsHttpGetAssetsByAssetIdSharesAll' as const;
export const AssetsHttpDeleteAssetsByAssetIdUploads =
  'AssetsHttpDeleteAssetsByAssetIdUploads' as const;
export const AssetsHttpPostAssetsByAssetIdVersions =
  'AssetsHttpPostAssetsByAssetIdVersions' as const;
export const AssetsHttpPostAssetsByAssetIdVersionsFromAssetsBySourceAssetId =
  'AssetsHttpPostAssetsByAssetIdVersionsFromAssetsBySourceAssetId' as const;
export const AssetsHttpPostAssetsByAssetIdVersionsFromVersionsBySourceVersionId =
  'AssetsHttpPostAssetsByAssetIdVersionsFromVersionsBySourceVersionId' as const;
export const AssetsHttpDeleteAssetsByAssetIdVersionsOld =
  'AssetsHttpDeleteAssetsByAssetIdVersionsOld' as const;
export const AssetsHttpDeleteAssetsByAssetIdVersionsByVersionId =
  'AssetsHttpDeleteAssetsByAssetIdVersionsByVersionId' as const;
export const AssetsHttpPatchAssetsByAssetIdVersionsByVersionId =
  'AssetsHttpPatchAssetsByAssetIdVersionsByVersionId' as const;
export const AssetsHttpPutAssetsByAssetIdVersionsByVersionId =
  'AssetsHttpPutAssetsByAssetIdVersionsByVersionId' as const;
export const AssetsHttpPutAssetsByAssetIdVersionsByVersionIdPromote =
  'AssetsHttpPutAssetsByAssetIdVersionsByVersionIdPromote' as const;
export const AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties =
  'AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties' as const;
export const AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties =
  'AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties' as const;
export const AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsSubtitles =
  'AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsSubtitles' as const;
export const AssetsHttpDeleteAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  'AssetsHttpDeleteAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties' as const;
export const AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  'AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties' as const;
export const AssetsHttpPatchAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  'AssetsHttpPatchAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties' as const;
export const AssetsHttpPutAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  'AssetsHttpPutAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties' as const;
export const AssetsHttpPostAssetsByAssetIdViews =
  'AssetsHttpPostAssetsByAssetIdViews' as const;
export const AssetsHttpGetCollections = 'AssetsHttpGetCollections' as const;
export const AssetsHttpPostCollections = 'AssetsHttpPostCollections' as const;
export const AssetsHttpGetCollectionsRecent =
  'AssetsHttpGetCollectionsRecent' as const;
export const AssetsHttpPostCollectionsReindex =
  'AssetsHttpPostCollectionsReindex' as const;
export const AssetsHttpDeleteCollectionsByCollectionId =
  'AssetsHttpDeleteCollectionsByCollectionId' as const;
export const AssetsHttpGetCollectionsByCollectionId =
  'AssetsHttpGetCollectionsByCollectionId' as const;
export const AssetsHttpPatchCollectionsByCollectionId =
  'AssetsHttpPatchCollectionsByCollectionId' as const;
export const AssetsHttpPutCollectionsByCollectionId =
  'AssetsHttpPutCollectionsByCollectionId' as const;
export const AssetsHttpGetCollectionsByCollectionIdAncestors =
  'AssetsHttpGetCollectionsByCollectionIdAncestors' as const;
export const AssetsHttpGetCollectionsByCollectionIdContentInfo =
  'AssetsHttpGetCollectionsByCollectionIdContentInfo' as const;
export const AssetsHttpGetCollectionsByCollectionIdContents =
  'AssetsHttpGetCollectionsByCollectionIdContents' as const;
export const AssetsHttpPostCollectionsByCollectionIdContents =
  'AssetsHttpPostCollectionsByCollectionIdContents' as const;
export const AssetsHttpDeleteCollectionsByCollectionIdContentsOrderingCustom =
  'AssetsHttpDeleteCollectionsByCollectionIdContentsOrderingCustom' as const;
export const AssetsHttpPostCollectionsByCollectionIdContentsOrderingCustom =
  'AssetsHttpPostCollectionsByCollectionIdContentsOrderingCustom' as const;
export const AssetsHttpDeleteCollectionsByCollectionIdContentsByObjectTypeByObjectId =
  'AssetsHttpDeleteCollectionsByCollectionIdContentsByObjectTypeByObjectId' as const;
export const AssetsHttpPutCollectionsByCollectionIdContentsByObjectTypeByObjectId =
  'AssetsHttpPutCollectionsByCollectionIdContentsByObjectTypeByObjectId' as const;
export const AssetsHttpPostCollectionsByCollectionIdContentsByObjectTypeByObjectIdReindex =
  'AssetsHttpPostCollectionsByCollectionIdContentsByObjectTypeByObjectIdReindex' as const;
export const AssetsHttpGetCollectionsByCollectionIdFullPath =
  'AssetsHttpGetCollectionsByCollectionIdFullPath' as const;
export const AssetsHttpPostCollectionsByCollectionIdKeyframes =
  'AssetsHttpPostCollectionsByCollectionIdKeyframes' as const;
export const AssetsHttpDeleteCollectionsByCollectionIdPurge =
  'AssetsHttpDeleteCollectionsByCollectionIdPurge' as const;
export const AssetsHttpPostCollectionsByCollectionIdReindex =
  'AssetsHttpPostCollectionsByCollectionIdReindex' as const;
export const AssetsHttpPostCollectionsByCollectionIdReindexContents =
  'AssetsHttpPostCollectionsByCollectionIdReindexContents' as const;
export const AssetsHttpPutCollectionsByCollectionIdRestore =
  'AssetsHttpPutCollectionsByCollectionIdRestore' as const;
export const AssetsHttpPutCollectionsByCollectionIdSearchDocument =
  'AssetsHttpPutCollectionsByCollectionIdSearchDocument' as const;
export const AssetsHttpGetCollectionsByCollectionIdSharesAll =
  'AssetsHttpGetCollectionsByCollectionIdSharesAll' as const;
export const AssetsHttpGetCollectionsByCollectionIdSize =
  'AssetsHttpGetCollectionsByCollectionIdSize' as const;
export const AssetsHttpPostCollectionsByCollectionIdSubcollections =
  'AssetsHttpPostCollectionsByCollectionIdSubcollections' as const;
export const AssetsHttpPostCollectionsByCollectionIdViews =
  'AssetsHttpPostCollectionsByCollectionIdViews' as const;
export const AssetsHttpGetCustomActions = 'AssetsHttpGetCustomActions' as const;
export const AssetsHttpPostCustomActionsSharedByContextByActionIdCallback =
  'AssetsHttpPostCustomActionsSharedByContextByActionIdCallback' as const;
export const AssetsHttpGetCustomActionsByContext =
  'AssetsHttpGetCustomActionsByContext' as const;
export const AssetsHttpPostCustomActionsByContext =
  'AssetsHttpPostCustomActionsByContext' as const;
export const AssetsHttpDeleteCustomActionsByContextByActionId =
  'AssetsHttpDeleteCustomActionsByContextByActionId' as const;
export const AssetsHttpGetCustomActionsByContextByActionId =
  'AssetsHttpGetCustomActionsByContextByActionId' as const;
export const AssetsHttpPatchCustomActionsByContextByActionId =
  'AssetsHttpPatchCustomActionsByContextByActionId' as const;
export const AssetsHttpPutCustomActionsByContextByActionId =
  'AssetsHttpPutCustomActionsByContextByActionId' as const;
export const AssetsHttpPostCustomActionsByContextByActionIdCallback =
  'AssetsHttpPostCustomActionsByContextByActionIdCallback' as const;
export const AssetsHttpDeleteDeleteQueueAssets =
  'AssetsHttpDeleteDeleteQueueAssets' as const;
export const AssetsHttpGetDeleteQueueAssets =
  'AssetsHttpGetDeleteQueueAssets' as const;
export const AssetsHttpPostDeleteQueueAssets =
  'AssetsHttpPostDeleteQueueAssets' as const;
export const AssetsHttpPostDeleteQueueAssetsPurge =
  'AssetsHttpPostDeleteQueueAssetsPurge' as const;
export const AssetsHttpPostDeleteQueueAssetsPurgeAll =
  'AssetsHttpPostDeleteQueueAssetsPurgeAll' as const;
export const AssetsHttpPostDeleteQueueAssetsRestoreAll =
  'AssetsHttpPostDeleteQueueAssetsRestoreAll' as const;
export const AssetsHttpPostDeleteQueueBulk =
  'AssetsHttpPostDeleteQueueBulk' as const;
export const AssetsHttpDeleteDeleteQueueCollections =
  'AssetsHttpDeleteDeleteQueueCollections' as const;
export const AssetsHttpGetDeleteQueueCollections =
  'AssetsHttpGetDeleteQueueCollections' as const;
export const AssetsHttpPostDeleteQueueCollections =
  'AssetsHttpPostDeleteQueueCollections' as const;
export const AssetsHttpPostDeleteQueueCollectionsPurge =
  'AssetsHttpPostDeleteQueueCollectionsPurge' as const;
export const AssetsHttpPostDeleteQueueCollectionsPurgeAll =
  'AssetsHttpPostDeleteQueueCollectionsPurgeAll' as const;
export const AssetsHttpPostDeleteQueueCollectionsRestoreAll =
  'AssetsHttpPostDeleteQueueCollectionsRestoreAll' as const;
export const AssetsHttpPostDeleteQueuePurgeAll =
  'AssetsHttpPostDeleteQueuePurgeAll' as const;
export const AssetsHttpDeleteFavorites = 'AssetsHttpDeleteFavorites' as const;
export const AssetsHttpGetFavorites = 'AssetsHttpGetFavorites' as const;
export const AssetsHttpPostFavorites = 'AssetsHttpPostFavorites' as const;
export const AssetsHttpDeleteFavoritesAll =
  'AssetsHttpDeleteFavoritesAll' as const;
export const AssetsHttpDeleteFavouritesAll =
  'AssetsHttpDeleteFavouritesAll' as const;
export const AssetsHttpGetPersonsByPersonId =
  'AssetsHttpGetPersonsByPersonId' as const;
export const AssetsHttpGetPlaylists = 'AssetsHttpGetPlaylists' as const;
export const AssetsHttpPostPlaylists = 'AssetsHttpPostPlaylists' as const;
export const AssetsHttpDeletePlaylistsByPlaylistId =
  'AssetsHttpDeletePlaylistsByPlaylistId' as const;
export const AssetsHttpGetPlaylistsByPlaylistId =
  'AssetsHttpGetPlaylistsByPlaylistId' as const;
export const AssetsHttpPatchPlaylistsByPlaylistId =
  'AssetsHttpPatchPlaylistsByPlaylistId' as const;
export const AssetsHttpPutPlaylistsByPlaylistId =
  'AssetsHttpPutPlaylistsByPlaylistId' as const;
export const AssetsHttpGetPlaylistsByPlaylistIdItems =
  'AssetsHttpGetPlaylistsByPlaylistIdItems' as const;
export const AssetsHttpPostPlaylistsByPlaylistIdItems =
  'AssetsHttpPostPlaylistsByPlaylistIdItems' as const;
export const AssetsHttpDeletePlaylistsByPlaylistIdItemsByItemId =
  'AssetsHttpDeletePlaylistsByPlaylistIdItemsByItemId' as const;
export const AssetsHttpPatchPlaylistsByPlaylistIdItemsByItemId =
  'AssetsHttpPatchPlaylistsByPlaylistIdItemsByItemId' as const;
export const AssetsHttpPutPlaylistsByPlaylistIdItemsByItemId =
  'AssetsHttpPutPlaylistsByPlaylistIdItemsByItemId' as const;
export const AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdPosition =
  'AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdPosition' as const;
export const AssetsHttpPostPlaylistsByPlaylistIdKeyframes =
  'AssetsHttpPostPlaylistsByPlaylistIdKeyframes' as const;
export const AssetsHttpPostPlaylistsByPlaylistIdReindex =
  'AssetsHttpPostPlaylistsByPlaylistIdReindex' as const;
export const AssetsHttpGetPortals = 'AssetsHttpGetPortals' as const;
export const AssetsHttpPostPortals = 'AssetsHttpPostPortals' as const;
export const AssetsHttpDeletePortalsByPortalId =
  'AssetsHttpDeletePortalsByPortalId' as const;
export const AssetsHttpGetPortalsByPortalId =
  'AssetsHttpGetPortalsByPortalId' as const;
export const AssetsHttpPatchPortalsByPortalId =
  'AssetsHttpPatchPortalsByPortalId' as const;
export const AssetsHttpPutPortalsByPortalId =
  'AssetsHttpPutPortalsByPortalId' as const;
export const AssetsHttpDeletePortalsByPortalIdLogo =
  'AssetsHttpDeletePortalsByPortalIdLogo' as const;
export const AssetsHttpPostPortalsByPortalIdLogo =
  'AssetsHttpPostPortalsByPortalIdLogo' as const;
export const AssetsHttpPostPortalsByPortalIdReindex =
  'AssetsHttpPostPortalsByPortalIdReindex' as const;
export const AssetsHttpGetProjects = 'AssetsHttpGetProjects' as const;
export const AssetsHttpPostProjects = 'AssetsHttpPostProjects' as const;
export const AssetsHttpDeleteProjectsByProjectId =
  'AssetsHttpDeleteProjectsByProjectId' as const;
export const AssetsHttpGetProjectsByProjectId =
  'AssetsHttpGetProjectsByProjectId' as const;
export const AssetsHttpPatchProjectsByProjectId =
  'AssetsHttpPatchProjectsByProjectId' as const;
export const AssetsHttpPutProjectsByProjectId =
  'AssetsHttpPutProjectsByProjectId' as const;
export const AssetsHttpGetProjectsByProjectIdMembers =
  'AssetsHttpGetProjectsByProjectIdMembers' as const;
export const AssetsHttpPostProjectsByProjectIdMembers =
  'AssetsHttpPostProjectsByProjectIdMembers' as const;
export const AssetsHttpDeleteProjectsByProjectIdMembersByMemberId =
  'AssetsHttpDeleteProjectsByProjectIdMembersByMemberId' as const;
export const AssetsHttpGetProjectsByProjectIdMembersByMemberId =
  'AssetsHttpGetProjectsByProjectIdMembersByMemberId' as const;
export const AssetsHttpPostProjectsByProjectIdReindex =
  'AssetsHttpPostProjectsByProjectIdReindex' as const;
export const AssetsHttpGetPublicationsDestinationsAccounts =
  'AssetsHttpGetPublicationsDestinationsAccounts' as const;
export const AssetsHttpGetPublicationsDestinationsPlatforms =
  'AssetsHttpGetPublicationsDestinationsPlatforms' as const;
export const AssetsHttpGetPublicationsDraftsByAssetId =
  'AssetsHttpGetPublicationsDraftsByAssetId' as const;
export const AssetsHttpPostPublicationsJobs =
  'AssetsHttpPostPublicationsJobs' as const;
export const AssetsHttpGetPublicationsTemplates =
  'AssetsHttpGetPublicationsTemplates' as const;
export const AssetsHttpGetPublicationsToken =
  'AssetsHttpGetPublicationsToken' as const;
export const AssetsHttpPostPublicationsByPublicationIdCancel =
  'AssetsHttpPostPublicationsByPublicationIdCancel' as const;
export const AssetsHttpPostReindexBulk = 'AssetsHttpPostReindexBulk' as const;
export const AssetsHttpPostSegmentsReindex =
  'AssetsHttpPostSegmentsReindex' as const;
export const AssetsHttpGetSequences = 'AssetsHttpGetSequences' as const;
export const AssetsHttpPostSequences = 'AssetsHttpPostSequences' as const;
export const AssetsHttpDeleteSequencesBySequenceId =
  'AssetsHttpDeleteSequencesBySequenceId' as const;
export const AssetsHttpGetSequencesBySequenceId =
  'AssetsHttpGetSequencesBySequenceId' as const;
export const AssetsHttpPatchSequencesBySequenceId =
  'AssetsHttpPatchSequencesBySequenceId' as const;
export const AssetsHttpPutSequencesBySequenceId =
  'AssetsHttpPutSequencesBySequenceId' as const;
export const AssetsHttpGetSequencesBySequenceIdItems =
  'AssetsHttpGetSequencesBySequenceIdItems' as const;
export const AssetsHttpPostSequencesBySequenceIdItems =
  'AssetsHttpPostSequencesBySequenceIdItems' as const;
export const AssetsHttpDeleteSequencesBySequenceIdItemsByItemId =
  'AssetsHttpDeleteSequencesBySequenceIdItemsByItemId' as const;
export const AssetsHttpPutSequencesBySequenceIdItemsByItemIdPosition =
  'AssetsHttpPutSequencesBySequenceIdItemsByItemIdPosition' as const;
export const AssetsHttpPostSequencesBySequenceIdReindex =
  'AssetsHttpPostSequencesBySequenceIdReindex' as const;
export const AssetsHttpPostShareByObjectType =
  'AssetsHttpPostShareByObjectType' as const;
export const AssetsHttpGetShares = 'AssetsHttpGetShares' as const;
export const AssetsHttpGetSharesAll = 'AssetsHttpGetSharesAll' as const;
export const AssetsHttpGetSharesAllowlistEntries =
  'AssetsHttpGetSharesAllowlistEntries' as const;
export const AssetsHttpPostSharesAllowlistEntries =
  'AssetsHttpPostSharesAllowlistEntries' as const;
export const AssetsHttpDeleteSharesAllowlistEntriesByEntryId =
  'AssetsHttpDeleteSharesAllowlistEntriesByEntryId' as const;
export const AssetsHttpGetSharesAllowlistEntriesByEntryId =
  'AssetsHttpGetSharesAllowlistEntriesByEntryId' as const;
export const AssetsHttpPutSharesAllowlistEntriesByEntryId =
  'AssetsHttpPutSharesAllowlistEntriesByEntryId' as const;
export const AssetsHttpPostSharesAuthLogin =
  'AssetsHttpPostSharesAuthLogin' as const;
export const AssetsHttpGetSharesAuthToken =
  'AssetsHttpGetSharesAuthToken' as const;
export const AssetsHttpPutSharesAuthToken =
  'AssetsHttpPutSharesAuthToken' as const;
export const AssetsHttpDeleteSharesBulk = 'AssetsHttpDeleteSharesBulk' as const;
export const AssetsHttpDeleteSharesBulkAll =
  'AssetsHttpDeleteSharesBulkAll' as const;
export const AssetsHttpPostSharesMagicLinkEnabled =
  'AssetsHttpPostSharesMagicLinkEnabled' as const;
export const AssetsHttpPostSharesByShareIdMagicLinkRequest =
  'AssetsHttpPostSharesByShareIdMagicLinkRequest' as const;
export const AssetsHttpPostSharesByShareIdMagicLinkValidate =
  'AssetsHttpPostSharesByShareIdMagicLinkValidate' as const;
export const AssetsHttpPostSyncSessions = 'AssetsHttpPostSyncSessions' as const;
export const AssetsHttpDeleteSyncSessionsBySyncSessionId =
  'AssetsHttpDeleteSyncSessionsBySyncSessionId' as const;
export const AssetsHttpGetSyncSessionsBySyncSessionId =
  'AssetsHttpGetSyncSessionsBySyncSessionId' as const;
export const AssetsHttpPatchSyncSessionsBySyncSessionId =
  'AssetsHttpPatchSyncSessionsBySyncSessionId' as const;
export const AssetsHttpPutSyncSessionsBySyncSessionId =
  'AssetsHttpPutSyncSessionsBySyncSessionId' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdApprovals =
  'AssetsHttpDeleteByObjectTypeByObjectIdApprovals' as const;
export const AssetsHttpGetByObjectTypeByObjectIdApprovals =
  'AssetsHttpGetByObjectTypeByObjectIdApprovals' as const;
export const AssetsHttpPutByObjectTypeByObjectIdApprovals =
  'AssetsHttpPutByObjectTypeByObjectIdApprovals' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdApprovalsExternalByEmail =
  'AssetsHttpDeleteByObjectTypeByObjectIdApprovalsExternalByEmail' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdApprovalsRequest =
  'AssetsHttpDeleteByObjectTypeByObjectIdApprovalsRequest' as const;
export const AssetsHttpGetByObjectTypeByObjectIdApprovalsRequest =
  'AssetsHttpGetByObjectTypeByObjectIdApprovalsRequest' as const;
export const AssetsHttpPatchByObjectTypeByObjectIdApprovalsRequest =
  'AssetsHttpPatchByObjectTypeByObjectIdApprovalsRequest' as const;
export const AssetsHttpPostByObjectTypeByObjectIdApprovalsRequest =
  'AssetsHttpPostByObjectTypeByObjectIdApprovalsRequest' as const;
export const AssetsHttpPutByObjectTypeByObjectIdApprovalsRequest =
  'AssetsHttpPutByObjectTypeByObjectIdApprovalsRequest' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdApprovalsUserByUserId =
  'AssetsHttpDeleteByObjectTypeByObjectIdApprovalsUserByUserId' as const;
export const AssetsHttpGetByObjectTypeByObjectIdShares =
  'AssetsHttpGetByObjectTypeByObjectIdShares' as const;
export const AssetsHttpPostByObjectTypeByObjectIdShares =
  'AssetsHttpPostByObjectTypeByObjectIdShares' as const;
export const AssetsHttpPostByObjectTypeByObjectIdSharesUrl =
  'AssetsHttpPostByObjectTypeByObjectIdSharesUrl' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareId =
  'AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareId' as const;
export const AssetsHttpGetByObjectTypeByObjectIdSharesByShareId =
  'AssetsHttpGetByObjectTypeByObjectIdSharesByShareId' as const;
export const AssetsHttpPutByObjectTypeByObjectIdSharesByShareId =
  'AssetsHttpPutByObjectTypeByObjectIdSharesByShareId' as const;
export const AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdReindex =
  'AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdReindex' as const;
export const AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsers =
  'AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsers' as const;
export const AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdUsers =
  'AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdUsers' as const;
export const AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  'AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId' as const;
export const AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  'AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId' as const;
export const AssetsHttpPatchByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  'AssetsHttpPatchByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId' as const;
export const AssetsHttpPutByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  'AssetsHttpPutByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId' as const;
export const AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovals =
  'AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovals' as const;
export const AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovalsRequest =
  'AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovalsRequest' as const;

/**
 * Original schema `AssetCreateSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetCreateSchemaTyped}
 */
export type AssetsAssetCreateSchemaTyped =
  | AssetsAssetCreateSchema
  | AssetsAssetPostCreate;
/**
 * Original schema `AssetEditSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetEditSchemaTyped}
 */
export type AssetsAssetEditSchemaTyped =
  | AssetsAssetEditSchema
  | AssetsAssetPostEdit;
/**
 * Original schema `AssetElasticSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchemaTyped}
 */
export type AssetsAssetElasticSchemaTyped =
  | AssetsAssetElasticSchema
  | AssetsAssetPostElastic;
/**
 * Original schema `AssetOrCollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetOrCollectionSchema}
 */
export type AssetsAssetOrCollectionSchema =
  | AssetsAssetElasticSchema
  | AssetsCollectionElastic;
/**
 * Original schema `AssetSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchemaTyped}
 */
export type AssetsAssetSchemaTyped = AssetsAssetSchema | AssetsAssetPostSchema;
/**
 * Original schema `AssetElasticSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchemaTyped}
 */
export type AssetsAssetElasticSchemaTypedWithIdNullable =
  | AssetsAssetElasticSchemaWithIdNullable
  | AssetsAssetPostElasticWithIdNullable;
/**
 * Original schema `AssetElasticSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchemaTyped}
 */
export type AssetsAssetElasticSchemaTypedWithId =
  | AssetsAssetElasticSchemaWithId
  | AssetsAssetPostElasticWithId;
/**
 * Original schema `AssetSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchemaTyped}
 */
export type AssetsAssetSchemaTypedWithId =
  | AssetsAssetSchemaWithId
  | AssetsAssetPostSchemaWithId;
/**
 * Original schema `AssetSchemaTyped`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchemaTyped}
 */
export type AssetsAssetSchemaTypedWithIdNullable =
  | AssetsAssetSchemaWithIdNullable
  | AssetsAssetPostSchemaWithIdNullable;

/**
 * Original schema `ApprovalBySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalBySchema}
 */
export interface AssetsApprovalBySchema {
  change_date?: string;
  external?: string;
  object_id?: string;
  object_type?: string;
  status?: 'N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED';
  user?: string;
  version_id?: string;
}
/**
 * Original schema `ApprovalJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalJobSchema}
 */
export interface AssetsApprovalJobSchema {
  job_id?: string;
}
/**
 * Original schema `ApprovalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalSchema}
 */
export interface AssetsApprovalSchema {
  approvals_by?: AssetsApprovalBySchema[] | null;
  change_date?: string;
  externals?: string[];
  groups?: string[];
  min_number?: number;
  object_id?: string;
  object_type?: string;
  request_date?: string;
  requested_by?: string;
  share_id?: string | null;
  status?: 'N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED';
  user_status?:
    | ('N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED')
    | null;
  users?: string[];
  users_info?: AssetsUser[];
  version_id?: string;
}
/**
 * Original schema `User`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-User}
 */
export interface AssetsUser {
  email?: string;
  first_name?: string;
  id?: string;
  last_name?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
}
/**
 * Original schema `ApprovalsBySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalsBySchema}
 */
export interface AssetsApprovalsBySchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsApprovalBySchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `AssetBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetBaseSchema}
 */
export interface AssetsAssetBaseSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  warning?: string | null;
}
/**
 * Original schema `AssetCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetCreateSchema}
 */
export interface AssetsAssetCreateSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  collection_id?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  warning?: string | null;
}
/**
 * Original schema `AssetPostCreate`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostCreate}
 */
export interface AssetsAssetPostCreate {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  collection_id?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetEditSchema}
 */
export interface AssetsAssetEditSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title?: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  warning?: string | null;
}
/**
 * Original schema `AssetPostEdit`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostEdit}
 */
export interface AssetsAssetPostEdit {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title?: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchema}
 */
export interface AssetsAssetElasticSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchemaNullable;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithIdNullable[];
  formats?: FilesFormatSchemaWithIdNullable[];
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  versions_number?: number;
  warning?: string | null;
  format?: string;
}
/**
 * Original schema `ApprovalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalSchema}
 */
export interface AssetsApprovalSchemaNullable {
  approvals_by?: AssetsApprovalBySchema[] | null;
  change_date?: string | null;
  externals?: string[] | null;
  groups?: string[] | null;
  min_number?: number | null;
  object_id?: string | null;
  object_type?: string | null;
  request_date?: string | null;
  requested_by?: string | null;
  share_id?: string | null;
  status?: ('N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED') | null;
  user_status?:
    | ('N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED')
    | null;
  users?: string[] | null;
  users_info?: AssetsUser[] | null;
  version_id?: string | null;
}
/**
 * Original schema `RelationElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationElastic}
 */
export interface AssetsRelationElastic {
  date_created?: string;
  date_modified?: string;
  description?: string;
  related_from_asset_id?: string;
  related_to_asset_id?: string;
  relation_type?: string;
}
/**
 * Original schema `AssetVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetVersion}
 */
export interface AssetsAssetVersion {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  date_created?: string;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_online?: boolean;
  person_ids?: string[];
  status?: 'ACTIVE' | 'IN_PROGRESS' | 'FAILED' | 'DELETING' | 'DELETED';
  transcribe_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  transcribed_languages?: string[];
  version_number?: number;
}
/**
 * Original schema `AssetPostElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostElastic}
 */
export interface AssetsAssetPostElastic {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchemaNullable;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithIdNullable[];
  formats?: FilesFormatSchemaWithIdNullable[];
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  versions_number?: number;
  views?: number | null;
  warning?: string | null;
  format?: string;
}
/**
 * Original schema `AssetHistoryBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryBaseSchema}
 */
export interface AssetsAssetHistoryBaseSchema {
  id?: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `AssetHistoryBulkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryBulkSchema}
 */
export interface AssetsAssetHistoryBulkSchema {
  asset_ids: string[];
  assets_jobs_map?: {
    [k: string]: unknown;
  };
  date_created?: string;
  date_modified?: string;
  id?: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `AssetHistoryElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryElasticSchema}
 */
export interface AssetsAssetHistoryElasticSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `AssetHistoryEntitiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryEntitiesSchema}
 */
export interface AssetsAssetHistoryEntitiesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsAssetHistoryElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `AssetHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistorySchema}
 */
export interface AssetsAssetHistorySchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `CollectionElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionElastic}
 */
export interface AssetsCollectionElastic {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id?: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type?: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `AssetPersonChangeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPersonChangeSchema}
 */
export interface AssetsAssetPersonChangeSchema {
  asset_id: string;
  delete_source_person_from_version?: boolean;
  destination_person_id: string;
  has_unconfirmed_persons: boolean;
  person_ids_after: string[];
  source_person_id: string;
  update_segments?: boolean;
  version_id: string;
}
/**
 * Original schema `AssetPostCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostCreateSchema}
 */
export interface AssetsAssetPostCreateSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  collection_id?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetPostEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostEditSchema}
 */
export interface AssetsAssetPostEditSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id: string;
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title?: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetPostElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostElasticSchema}
 */
export interface AssetsAssetPostElasticSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchema;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithId[];
  formats?: {
    [k: string]: unknown;
  }[];
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithId[];
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type?: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  versions_number?: number;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetPostSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostSchema}
 */
export interface AssetsAssetPostSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchema}
 */
export interface AssetsAssetSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  warning?: string | null;
}
/**
 * Original schema `AssetTranscriptionFromSubtitleSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionFromSubtitleSchema}
 */
export interface AssetsAssetTranscriptionFromSubtitleSchema {
  content?: string;
  delete_old_transcriptions?: boolean;
  format?: ('VTT' | 'WEBVTT' | 'SRT') | null;
  language?: string;
  /**
   * Set to source subtitle_id or do not set and use the content fields instead
   */
  source_subtitle_id?: string;
}
/**
 * Original schema `AssetTranscriptionPropertiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionPropertiesSchema}
 */
export interface AssetsAssetTranscriptionPropertiesSchema {
  asset_id?: string;
  engine_info?: AssetsTranscriptionEngineInfo | null;
  id?: string;
  language?: string;
  speaker_labels?: {
    [k: string]: string;
  };
  system_domain_id?: string;
  version_id?: string;
}
/**
 * Original schema `TranscriptionEngineInfo`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-TranscriptionEngineInfo}
 */
export interface AssetsTranscriptionEngineInfo {
  model?: string;
  name?: string;
  type?: 'INTERNAL' | 'EXTERNAL';
  version?: string;
}
/**
 * Original schema `AssetTranscriptionsPropertiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionsPropertiesSchema}
 */
export interface AssetsAssetTranscriptionsPropertiesSchema {
  objects?: AssetsAssetTranscriptionPropertiesSchema[];
}
/**
 * Original schema `AssetVersionLookupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetVersionLookupSchema}
 */
export interface AssetsAssetVersionLookupSchema {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `AssetVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetVersionSchema}
 */
export interface AssetsAssetVersionSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  date_created?: string;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  has_unconfirmed_persons?: boolean;
  id?: string;
  is_online?: boolean;
  person_ids?: string[];
  status?: 'ACTIVE' | 'IN_PROGRESS' | 'FAILED' | 'DELETING' | 'DELETED';
  transcribe_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  transcribed_languages?: string[];
  version_number?: number;
}
/**
 * Original schema `AssetVersionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetVersionsSchema}
 */
export interface AssetsAssetVersionsSchema {
  asset_id: string;
  system_domain_id?: string;
  /**
   * @minItems 1
   */
  versions?: AssetsEditAssetVersion[];
}
/**
 * Original schema `EditAssetVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditAssetVersion}
 */
export interface AssetsEditAssetVersion {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  date_created?: string;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  has_unconfirmed_persons?: boolean;
  id: string;
  is_online?: boolean;
  person_ids?: string[];
  status?: 'ACTIVE' | 'IN_PROGRESS' | 'FAILED' | 'DELETING' | 'DELETED';
  transcribe_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  transcribed_languages?: string[];
  version_number?: number;
}
/**
 * Original schema `AssetsHistoryQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetsHistoryQueryParamsSchema}
 */
export interface AssetsAssetsHistoryQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `AssetsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetsQueryParamsSchema}
 */
export interface AssetsAssetsQueryParamsSchema {
  /**
   * A user UUID who has favorited the assets
   */
  favoured_by?: string | null;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   */
  types?: (
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP'
    | 'POST'
  )[];
}
/**
 * Original schema `AssetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetsSchema}
 */
export interface AssetsAssetsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsAssetElasticSchemaTyped[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BaseQueryParamsSchema}
 */
export interface AssetsBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `BulkActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkActionSchema}
 */
export interface AssetsBulkActionSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
}
/**
 * Original schema `BulkAddToFavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkAddToFavoritesSchema}
 */
export interface AssetsBulkAddToFavoritesSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections';
}
/**
 * Original schema `BulkAssetEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkAssetEditSchema}
 */
export interface AssetsBulkAssetEditSchema {
  objects: AssetsAssetEditSchema[];
}
/**
 * Original schema `BulkAssetPersonChangeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkAssetPersonChangeSchema}
 */
export interface AssetsBulkAssetPersonChangeSchema {
  job_id: string;
  /**
   * @minItems 1
   * @maxItems 100
   */
  objects: AssetsAssetPersonChangeSchema[];
}
/**
 * Original schema `BulkAssetVersionEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkAssetVersionEditSchema}
 */
export interface AssetsBulkAssetVersionEditSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  objects: AssetsAssetVersionsSchema[];
}
/**
 * Original schema `BulkCollectionACLsUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionACLsUpdateSchema}
 */
export interface AssetsBulkCollectionACLsUpdateSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionActionSchema}
 */
export interface AssetsBulkCollectionActionSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionAnalyzeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionAnalyzeSchema}
 */
export interface AssetsBulkCollectionAnalyzeSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionDeleteSchema}
 */
export interface AssetsBulkCollectionDeleteSchema {
  collection_ids: string[];
  job_id: string;
  storage_id: string;
}
/**
 * Original schema `BulkCollectionFaceExtractionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionFaceExtractionSchema}
 */
export interface AssetsBulkCollectionFaceExtractionSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionMetadataFillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionMetadataFillingSchema}
 */
export interface AssetsBulkCollectionMetadataFillingSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionMetadataUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionMetadataUpdateSchema}
 */
export interface AssetsBulkCollectionMetadataUpdateSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionTranscodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionTranscodeSchema}
 */
export interface AssetsBulkCollectionTranscodeSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionTranscribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionTranscribeSchema}
 */
export interface AssetsBulkCollectionTranscribeSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
}
/**
 * Original schema `BulkCollectionTransferSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCollectionTransferSchema}
 */
export interface AssetsBulkCollectionTransferSchema {
  callback_chunk_size?: number;
  callback_data?: {
    [k: string]: unknown;
  } | null;
  callback_data_request?: {
    [k: string]: unknown;
  } | null;
  callback_url?: string;
  collection_ids: string[];
  destination_directory_path?: string;
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  keep_collection_structure?: boolean;
  keep_parent_collection_structure?: boolean;
}
/**
 * Original schema `BulkCreateSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkCreateSegmentsSchema}
 */
export interface AssetsBulkCreateSegmentsSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  objects: AssetsSegment[];
}
/**
 * Original schema `Segment`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Segment}
 */
export interface AssetsSegment {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawing | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  /**
   * Whether the comment has attachments in iconik_files
   */
  has_attachments?: boolean;
  has_drawing?: {
    [k: string]: unknown;
  };
  id?: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `Drawing`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Drawing}
 */
export interface AssetsDrawing {
  primitives?: AssetsDrawingPrimitive[];
  version?: number | null;
}
/**
 * Original schema `DrawingPrimitive`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DrawingPrimitive}
 */
export interface AssetsDrawingPrimitive {
  color?: string;
  opacity?: number;
  points?: AssetsDrawingPoint[];
  text?: string;
  type:
    | 'LINE'
    | 'RECTANGLE'
    | 'ARROW'
    | 'ELLIPSE'
    | 'PENCIL'
    | 'TEXT'
    | 'CROSS';
  width?: number;
}
/**
 * Original schema `DrawingPoint`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DrawingPoint}
 */
export interface AssetsDrawingPoint {
  x: number;
  y: number;
}
/**
 * Original schema `FaceBoundingBox`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FaceBoundingBox}
 */
export interface AssetsFaceBoundingBox {
  bounding_box?: number[];
  landmarks?: AssetsFaceLandmark[] | null;
  person_version_face_id: string;
  timestamp_ms?: number;
}
/**
 * Original schema `FaceLandmark`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FaceLandmark}
 */
export interface AssetsFaceLandmark {
  x: number;
  y: number;
}
/**
 * Original schema `SemanticTranscription`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SemanticTranscription}
 */
export interface AssetsSemanticTranscription {
  cut_reasons?: string[] | null;
  embedding?: string | null;
  embedding_dim?: number | null;
  embedding_encoding?: string | null;
  embedding_model?: string | null;
  embedding_model_version?: string | null;
  entities?: AssetsSemanticTranscriptionEntity[] | null;
  language?: string | null;
  speaker_count?: string | null;
  tone?: string | null;
  topics?: AssetsUnderstandingTag[] | null;
  track_id?: string | null;
  valence?: string | null;
}
/**
 * Original schema `SemanticTranscriptionEntity`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SemanticTranscriptionEntity}
 */
export interface AssetsSemanticTranscriptionEntity {
  label?: string | null;
  text: string;
}
/**
 * Original schema `UnderstandingTag`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-UnderstandingTag}
 */
export interface AssetsUnderstandingTag {
  label: string;
  level?: string | null;
  score?: number | null;
}
/**
 * Original schema `Shot`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Shot}
 */
export interface AssetsShot {
  actions?: AssetsUnderstandingTag[] | null;
  animal_species?: AssetsUnderstandingTag[] | null;
  brand_logo?: AssetsUnderstandingTag[] | null;
  camera_angle?: AssetsUnderstandingTag | null;
  caption?: string | null;
  color_palette?: AssetsUnderstandingTag[] | null;
  composition?: string | null;
  dog_breeds?: AssetsUnderstandingTag[] | null;
  dominant_hue?: string | null;
  embedding?: string | null;
  embedding_dim?: number | null;
  embedding_encoding?: string | null;
  embedding_model?: string | null;
  embedding_model_version?: string | null;
  facial_expression?: AssetsUnderstandingTag[] | null;
  keyframe_ts?: number;
  light_key?: string | null;
  light_side?: string | null;
  light_style?: string[] | null;
  light_time?: string | null;
  mood?: AssetsUnderstandingTag[] | null;
  mood_valence?: string | null;
  movement?: string[] | null;
  objects?: AssetsUnderstandingTag[] | null;
  ocr_text?: string | null;
  orientation?: string | null;
  people_age_range?: string[] | null;
  people_bucket?: string | null;
  people_count?: number | null;
  people_features?: AssetsUnderstandingTag[] | null;
  people_gender?: string[] | null;
  place?: AssetsUnderstandingTag | null;
  resolution?: string | null;
  scale_rank?: number | null;
  season?: AssetsUnderstandingTag | null;
  sensitive_content?: AssetsUnderstandingTag[] | null;
  setting?: AssetsUnderstandingTag | null;
  shot_scale?: AssetsUnderstandingTag | null;
  sport_type?: AssetsUnderstandingTag | null;
  subject_type?: AssetsUnderstandingTag[] | null;
  time_of_day?: string | null;
  track_id?: string | null;
  weather?: AssetsUnderstandingTag | null;
}
/**
 * Original schema `TranscriptionType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-TranscriptionType}
 */
export interface AssetsTranscriptionType {
  speaker?: number | null;
  /**
   * @minItems 1
   */
  words: AssetsTranscriptionElementType[];
}
/**
 * Original schema `TranscriptionElementType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-TranscriptionElementType}
 */
export interface AssetsTranscriptionElementType {
  end_ms: number;
  score?: number;
  start_ms: number;
  value: string;
}
/**
 * Original schema `BulkDeleteFromFavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkDeleteFromFavoritesSchema}
 */
export interface AssetsBulkDeleteFromFavoritesSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections';
}
/**
 * Original schema `BulkDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkDeleteSchema}
 */
export interface AssetsBulkDeleteSchema {
  /**
   * If set to `False`, will also delete entities of type `object_type` specified in `object_ids`.
   */
  content_only?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
}
/**
 * Original schema `BulkEditAssetSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkEditAssetSegmentsSchema}
 */
export interface AssetsBulkEditAssetSegmentsSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  objects: AssetsEditAssetSegment[];
}
/**
 * Original schema `EditAssetSegment`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditAssetSegment}
 */
export interface AssetsEditAssetSegment {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawing | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `BulkEditSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkEditSegmentsSchema}
 */
export interface AssetsBulkEditSegmentsSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  objects: AssetsEditSegmentForBulk[];
}
/**
 * Original schema `EditSegmentForBulk`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditSegmentForBulk}
 */
export interface AssetsEditSegmentForBulk {
  asset_id: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawing | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `BulkRemoveApprovalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkRemoveApprovalSchema}
 */
export interface AssetsBulkRemoveApprovalSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
}
/**
 * Original schema `BulkSetApprovalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkSetApprovalSchema}
 */
export interface AssetsBulkSetApprovalSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
  status: 'APPROVED' | 'NOT_APPROVED';
}
/**
 * Original schema `BulkShareCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkShareCreateSchema}
 */
export interface AssetsBulkShareCreateSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  emails?: string[];
  expires?: string;
  id?: string;
  is_approval?: boolean | null;
  message?: string;
  metadata_views?: string[] | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type?: 'assets';
  owner_id?: string;
  password?: string;
  review_experience_public_beta?: boolean | null;
  share_by_url?: boolean;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title: string;
  upload_storage_id?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `BulkShareDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-BulkShareDeleteSchema}
 */
export interface AssetsBulkShareDeleteSchema {
  share_ids: string[];
}
/**
 * Original schema `CollectionBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionBaseSchema}
 */
export interface AssetsCollectionBaseSchema {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id?: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type?: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionContentInfoSchema}
 */
export interface AssetsCollectionContentInfoSchema {
  assets_count?: number;
  collections_count?: number;
  storage_info?: AssetsStorageContentInfo[];
  title?: string;
  total_duration_milliseconds?: number;
  total_proxy_size?: number;
  total_size?: number;
}
/**
 * Original schema `StorageContentInfo`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-StorageContentInfo}
 */
export interface AssetsStorageContentInfo {
  assets_count?: number;
  file_count?: number;
  storage_id?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `CollectionContentOrderingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionContentOrderingSchema}
 */
export interface AssetsCollectionContentOrderingSchema {
  after_object_id?: string;
  before_object_id?: string;
  /**
   * Position the member will be moved to. To insert athe the end send -1
   */
  position?: number;
}
/**
 * Original schema `CollectionContentQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionContentQueryParamsSchema}
 */
export interface AssetsCollectionContentQueryParamsSchema {
  include_keyframes?: boolean;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   */
  types?: (
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP'
    | 'POST'
  )[];
}
/**
 * Original schema `CollectionContentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionContentSchema}
 */
export interface AssetsCollectionContentSchema {
  collection_id?: string;
  date_created?: string;
  object_id: string;
  object_type: string;
}
/**
 * Original schema `CollectionElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionElasticSchema}
 */
export interface AssetsCollectionElasticSchema {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id?: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionInputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionInputSchema}
 */
export interface AssetsCollectionInputSchema {
  category?: string | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  external_id?: string | null;
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  parent_id?: string | null;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSchema}
 */
export interface AssetsCollectionSchema {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id?: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionSizeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSizeSchema}
 */
export interface AssetsCollectionSizeSchema {
  id?: string;
  size?: number;
  title?: string;
}
/**
 * Original schema `CollectionsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionsQueryParamsSchema}
 */
export interface AssetsCollectionsQueryParamsSchema {
  /**
   * A user UUID who has favorited the collections
   */
  favoured_by?: string | null;
  include_keyframes?: boolean;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `CollectionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionsSchema}
 */
export interface AssetsCollectionsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsCollectionElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `CreateAssetVersionFromAssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateAssetVersionFromAssetSchema}
 */
export interface AssetsCreateAssetVersionFromAssetSchema {
  copy_previous_version_persons?: boolean;
  copy_previous_version_segments?: boolean;
  include_segment_types?: (
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION'
  )[];
  source_metadata_asset_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `CreateAssetVersionFromVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateAssetVersionFromVersionSchema}
 */
export interface AssetsCreateAssetVersionFromVersionSchema {
  copy_previous_version_persons?: boolean;
  copy_previous_version_segments?: boolean;
  exclude_format_ids?: string[] | null;
  include_segment_types?: (
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION'
  )[];
  source_metadata_asset_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `CreateAssetVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateAssetVersionSchema}
 */
export interface AssetsCreateAssetVersionSchema {
  copy_metadata?: boolean;
  copy_persons?: boolean;
  copy_segments?: boolean;
  include_segment_types?: (
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION'
  )[];
  source_version_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `CreateCollectionContentOrderingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateCollectionContentOrderingSchema}
 */
export interface AssetsCreateCollectionContentOrderingSchema {
  /**
   * Initial sort order for an ordered collection. Specified as a comma separated list of fieldnames with direction. For example - date_created,asc;status,desc
   */
  custom_order_sort?: string;
}
/**
 * Original schema `CreateCollectionFromSavedSearchResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateCollectionFromSavedSearchResponseSchema}
 */
export interface AssetsCreateCollectionFromSavedSearchResponseSchema {
  collection_title?: string;
}
/**
 * Original schema `CreateCollectionFromSavedSearchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateCollectionFromSavedSearchSchema}
 */
export interface AssetsCreateCollectionFromSavedSearchSchema {
  collection_id: string;
  job_id: string;
  saved_search_id: string;
}
/**
 * Original schema `CreateCollectionFromSearchResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateCollectionFromSearchResponseSchema}
 */
export interface AssetsCreateCollectionFromSearchResponseSchema {
  collection_title?: string;
}
/**
 * Original schema `CreateCollectionFromSearchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreateCollectionFromSearchSchema}
 */
export interface AssetsCreateCollectionFromSearchSchema {
  collection_id: string;
  job_id: string;
}
/**
 * Original schema `CreatePublicationJobSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreatePublicationJobSchema}
 */
export interface AssetsCreatePublicationJobSchema {
  allow_transfer?: boolean;
  asset_id: string;
  metadata_overrides?: {
    [k: string]: unknown;
  };
  /**
   * Schedule publishing at this date/time instead of immediately. Naive values are interpreted as UTC.
   */
  publish_at_time?: string | null;
  /**
   * Whether to immediately create a draft clip for this asset without waiting for ingestion. The clip is created right away and appears in clip management like any other clip, while the media is ingested in the background. This lets the asset be opened/edited before the media is available. This is mutually exclusive with publishing the clip when done.
   */
  save_clip_as_draft?: boolean;
  storage_id?: string | null;
  template?: AssetsCreatePublicationTemplate;
  thumbnail?: AssetsCreatePublicationJobThumbnailKeyframe;
  title?: string;
  video_source?: AssetsVideoSource | null;
}
/**
 * Original schema `CreatePublicationTemplate`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreatePublicationTemplate}
 */
export interface AssetsCreatePublicationTemplate {
  apply?:
    | boolean
    | {
        [k: string]: boolean;
      };
  data?: {
    [k: string]: unknown;
  };
  id: string;
}
/**
 * Original schema `CreatePublicationJobThumbnailKeyframe`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreatePublicationJobThumbnailKeyframe}
 */
export interface AssetsCreatePublicationJobThumbnailKeyframe {
  asset_id: string;
  keyframe_id: string;
  type: 'KEYFRAME';
}
/**
 * Original schema `VideoSource`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-VideoSource}
 */
export interface AssetsVideoSource {
  /**
   * The iconik file ID to use as the video source for the import.
   */
  file_id?: string;
  /**
   * The mode to use for the import. Only "as-is" is supported for now, which means the file will be used as-is without any transcoding or processing.
   */
  mode?: 'as-is';
}
/**
 * Original schema `CreatePublicationJobThumbnailKeyframeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreatePublicationJobThumbnailKeyframeSchema}
 */
export interface AssetsCreatePublicationJobThumbnailKeyframeSchema {
  asset_id: string;
  keyframe_id: string;
  type: 'KEYFRAME';
}
/**
 * Original schema `CreatePublicationTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CreatePublicationTemplateSchema}
 */
export interface AssetsCreatePublicationTemplateSchema {
  apply?:
    | boolean
    | {
        [k: string]: boolean;
      };
  data?: {
    [k: string]: unknown;
  };
  id: string;
}
/**
 * Original schema `CustomActionCallbackReplySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionCallbackReplySchema}
 */
export interface AssetsCustomActionCallbackReplySchema {
  redirect_url?: string;
}
/**
 * Original schema `CustomActionCallbackSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionCallbackSchema}
 */
export interface AssetsCustomActionCallbackSchema {
  asset_ids?: string[];
  collection_ids?: string[];
  /**
   * ID of a collection that the custom action was triggered from
   */
  from_collection_id?: string | null;
  metadata_values?: {
    [k: string]: AssetsMetadataFieldValueSchema;
  };
  metadata_view_id?: string | null;
  playlist_ids?: string[];
  saved_search_ids?: string[];
}
/**
 * Original schema `MetadataFieldValueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MetadataFieldValueSchema}
 */
export interface AssetsMetadataFieldValueSchema {
  date_created?: string;
  field_values?: {
    [k: string]: unknown;
  }[];
}
/**
 * Original schema `CustomActionCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionCreateSchema}
 */
export interface AssetsCustomActionCreateSchema {
  app_id?: string | null;
  color?: string | null;
  context:
    | 'ASSET'
    | 'ASSET_SUBCLIP'
    | 'SHARED_ASSET'
    | 'COLLECTION'
    | 'SHARED_COLLECTION'
    | 'BULK'
    | 'SAVED_SEARCH'
    | 'NONE'
    | 'PLAYLIST'
    | 'SHARED_PLAYLIST';
  date_created?: string;
  date_modified?: string;
  disabled?: boolean;
  headers?: {
    [k: string]: string;
  };
  id?: string;
  last_error?: string;
  last_error_date?: string;
  metadata_view?: string | null;
  publish_template_id?: string | null;
  read_access_for_everyone?: boolean;
  status?: 'FAILING' | 'HEALTHY';
  system_domain_id?: string;
  title: string;
  transcoder_id?: string | null;
  type?: 'OPEN' | 'POST' | 'PUBLISH';
  url: string;
}
/**
 * Original schema `CustomActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionSchema}
 */
export interface AssetsCustomActionSchema {
  app_id?: string | null;
  color?: string | null;
  context:
    | 'ASSET'
    | 'ASSET_SUBCLIP'
    | 'SHARED_ASSET'
    | 'COLLECTION'
    | 'SHARED_COLLECTION'
    | 'BULK'
    | 'SAVED_SEARCH'
    | 'NONE'
    | 'PLAYLIST'
    | 'SHARED_PLAYLIST';
  date_created?: string;
  date_modified?: string;
  disabled?: boolean;
  headers?: {
    [k: string]: string;
  };
  id?: string;
  last_error?: string;
  last_error_date?: string;
  metadata_view?: string | null;
  publish_template_id?: string | null;
  status?: 'FAILING' | 'HEALTHY';
  system_domain_id?: string;
  title: string;
  transcoder_id?: string | null;
  type?: 'OPEN' | 'POST' | 'PUBLISH';
  url: string;
}
/**
 * Original schema `CustomActionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionsSchema}
 */
export interface AssetsCustomActionsSchema {
  objects?: AssetsCustomActionSchema[];
}
/**
 * Original schema `DeleteQueueAssetsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DeleteQueueAssetsQueryParamsSchema}
 */
export interface AssetsDeleteQueueAssetsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `DeleteQueueCollectionsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DeleteQueueCollectionsQueryParamsSchema}
 */
export interface AssetsDeleteQueueCollectionsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `DeleteQueueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DeleteQueueSchema}
 */
export interface AssetsDeleteQueueSchema {
  ids: string[];
}
/**
 * Original schema `DeleteSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DeleteSegmentsSchema}
 */
export interface AssetsDeleteSegmentsSchema {
  /**
   * List of Segment attribute name/value pairs that must all match for a segment to be deleted. Can be combined with segment_ids or segment_type to further filter which segments are deleted.
   *
   * @minItems 1
   * @maxItems 50
   */
  attributes?: AssetsSegmentAttributeMatch[];
  /**
   * @minItems 1
   * @maxItems 500
   */
  segment_ids?: string[];
  segment_type?:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  version_id?: string | null;
}
/**
 * Original schema `SegmentAttributeMatch`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentAttributeMatch}
 */
export interface AssetsSegmentAttributeMatch {
  name: string;
  /**
   * Comparison operator used when matching the attribute. 'eq' works for any attribute, while 'lt' (less than) and 'gt' (greater than) are only valid for date and number attributes.
   */
  operator?: 'eq' | 'lt' | 'gt';
  value: unknown;
}
/**
 * Original schema `DestinationItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DestinationItemSchema}
 */
export interface AssetsDestinationItemSchema {
  label?: string;
  value?: string;
}
/**
 * Original schema `DestinationItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DestinationItemsSchema}
 */
export interface AssetsDestinationItemsSchema {
  objects?: AssetsDestinationItemSchema[];
}
/**
 * Original schema `DrawingPointSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DrawingPointSchema}
 */
export interface AssetsDrawingPointSchema {
  x: number;
  y: number;
}
/**
 * Original schema `DrawingPrimitiveSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DrawingPrimitiveSchema}
 */
export interface AssetsDrawingPrimitiveSchema {
  color?: string;
  opacity?: number;
  points?: AssetsDrawingPointSchema[];
  text?: string;
  type:
    | 'LINE'
    | 'RECTANGLE'
    | 'ARROW'
    | 'ELLIPSE'
    | 'PENCIL'
    | 'TEXT'
    | 'CROSS';
  width?: number;
}
/**
 * Original schema `DrawingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DrawingSchema}
 */
export interface AssetsDrawingSchema {
  primitives?: AssetsDrawingPrimitiveSchema[];
  version?: number | null;
}
/**
 * Original schema `EditAssetSegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditAssetSegmentSchema}
 */
export interface AssetsEditAssetSegmentSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `EditAssetVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditAssetVersionSchema}
 */
export interface AssetsEditAssetVersionSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  date_created?: string;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  has_unconfirmed_persons?: boolean;
  id: string;
  is_online?: boolean;
  person_ids?: string[];
  status?: 'ACTIVE' | 'IN_PROGRESS' | 'FAILED' | 'DELETING' | 'DELETED';
  transcribe_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  transcribed_languages?: string[];
  version_number?: number;
}
/**
 * Original schema `EditPersonAssetVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditPersonAssetVersionSchema}
 */
export interface AssetsEditPersonAssetVersionSchema {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `EditPersonStatusSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditPersonStatusSchema}
 */
export interface AssetsEditPersonStatusSchema {
  first_url?: string;
  has_unconfirmed_persons?: boolean;
  last_url?: string;
  next_url?: string;
  objects: AssetsEditPersonAssetVersionSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `EditSegmentForBulkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditSegmentForBulkSchema}
 */
export interface AssetsEditSegmentForBulkSchema {
  asset_id: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `EditSegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-EditSegmentSchema}
 */
export interface AssetsEditSegmentSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBox[] | null;
  has_attachments?: boolean;
  id?: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `FaceBoundingBoxSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FaceBoundingBoxSchema}
 */
export interface AssetsFaceBoundingBoxSchema {
  bounding_box?: number[];
  landmarks?: AssetsFaceLandmark[] | null;
  person_version_face_id: string;
  timestamp_ms?: number;
}
/**
 * Original schema `FaceLandmarkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FaceLandmarkSchema}
 */
export interface AssetsFaceLandmarkSchema {
  x: number;
  y: number;
}
/**
 * Original schema `FavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FavoritesSchema}
 */
export interface AssetsFavoritesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsAssetOrCollectionSchema;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `GetAssetsLatestVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-GetAssetsLatestVersionSchema}
 */
export interface AssetsGetAssetsLatestVersionSchema {
  include_in_progress?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type?: 'assets';
}
/**
 * Original schema `GetAssetsVersionsMetadataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-GetAssetsVersionsMetadataSchema}
 */
export interface AssetsGetAssetsVersionsMetadataSchema {
  /**
   * Optional list of fields to include in the response. If omitted, all fields are returned.
   */
  fields?: string[] | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  objects: AssetsAssetVersionLookupSchema[];
}
/**
 * Original schema `GetShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-GetShareSchema}
 */
export interface AssetsGetShareSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id?: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage?: AssetsUploadStorage;
  upload_storage_id?: string | null;
  upload_storage_presign_md5_checksum?: boolean;
  url?: string | null;
  users?: AssetsShareUser[];
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `UploadStorage`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-UploadStorage}
 */
export interface AssetsUploadStorage {
  add_uuid_to_filenames: boolean;
  id: string;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE';
  presign_md5_checksum?: boolean;
}
/**
 * Original schema `ShareUser`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUser}
 */
export interface AssetsShareUser {
  access_count?: number;
  download_count?: number;
  email: string;
  first_name?: string;
  id?: string;
  internal_user_id?: string;
  last_access_date?: string;
  last_name?: string;
  object_id?: string;
  object_type?: string;
  password?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  share_id?: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ListObjectsSchema}
 */
export interface AssetsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `MagicLinkAllowlistCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistCreateSchema}
 */
export interface AssetsMagicLinkAllowlistCreateSchema {
  entry_type: 'email' | 'domain';
  value: string;
}
/**
 * Original schema `MagicLinkAllowlistEntrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistEntrySchema}
 */
export interface AssetsMagicLinkAllowlistEntrySchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  /**
   * Type of allowlist entry: 'email' for specific addresses, 'domain' for domain wildcards
   */
  entry_type: 'email' | 'domain';
  id?: string;
  system_domain_id?: string;
  /**
   * The email address or domain to allowlist (e.g., 'user@example.com' or 'example.com')
   */
  value: string;
}
/**
 * Original schema `MagicLinkAllowlistListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistListSchema}
 */
export interface AssetsMagicLinkAllowlistListSchema {
  objects?: AssetsMagicLinkAllowlistEntrySchema[];
}
/**
 * Original schema `MagicLinkAllowlistUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistUpdateSchema}
 */
export interface AssetsMagicLinkAllowlistUpdateSchema {
  entry_type?: 'email' | 'domain';
  value?: string;
}
/**
 * Original schema `MagicLinkCheckSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkCheckSettingSchema}
 */
export interface AssetsMagicLinkCheckSettingSchema {
  hash: string;
}
/**
 * Original schema `MagicLinkRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkRequestSchema}
 */
export interface AssetsMagicLinkRequestSchema {
  email: string;
}
/**
 * Original schema `MagicLinkValidateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkValidateSchema}
 */
export interface AssetsMagicLinkValidateSchema {
  /**
   * App ID for session fallback authentication
   */
  app_id?: string;
  /**
   * The recipient email address
   */
  email: string;
  /**
   * The JWT magic link token
   */
  hash: string;
  /**
   * Password for password-protected shares
   */
  password?: string;
  /**
   * Auth token for session fallback authentication
   */
  token?: string;
}
/**
 * Original schema `Playlist`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Playlist}
 */
export interface AssetsPlaylist {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id?: string;
  item_count?: number;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistBaseSchema}
 */
export interface AssetsPlaylistBaseSchema {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id?: string;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistCreateSchema}
 */
export interface AssetsPlaylistCreateSchema {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id?: string;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  playlist_items?: AssetsPlaylistItem[];
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistItem`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItem}
 */
export interface AssetsPlaylistItem {
  id?: string;
  object_id: string;
  object_type: 'assets' | 'sequences';
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  /**
   * Version selector for this playlist item. Accepts: omitted/null/empty (all versions); "latest" (latest version only); a single UUID1; or a comma-separated list of UUID1s (e.g. "uuid1,uuid2,uuid3") with no whitespace and no duplicates.
   */
  version_id?: string | null;
}
/**
 * Original schema `PlaylistItemElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemElasticSchema}
 */
export interface AssetsPlaylistItemElasticSchema {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchema;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithId[];
  formats?: {
    [k: string]: unknown;
  }[];
  has_unconfirmed_persons?: boolean;
  id?: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithId[];
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type?: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersionSchema[];
  versions_number?: number;
  warning?: string | null;
}
/**
 * Original schema `PlaylistItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemSchema}
 */
export interface AssetsPlaylistItemSchema {
  id?: string;
  object_id: string;
  object_type: 'assets' | 'sequences';
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  /**
   * Version selector for this playlist item. Accepts: omitted/null/empty (all versions); "latest" (latest version only); a single UUID1; or a comma-separated list of UUID1s (e.g. "uuid1,uuid2,uuid3") with no whitespace and no duplicates.
   */
  version_id?: string | null;
}
/**
 * Original schema `PlaylistItemUpdatePositionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemUpdatePositionSchema}
 */
export interface AssetsPlaylistItemUpdatePositionSchema {
  /**
   * New position of the item in the playlist.If not provided, the item will be appended to the end of the playlist
   */
  position?: number;
}
/**
 * Original schema `PlaylistItemsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemsQueryParamsSchema}
 */
export interface AssetsPlaylistItemsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `PlaylistItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemsSchema}
 */
export interface AssetsPlaylistItemsSchema {
  objects?: AssetsPlaylistItemElasticSchema[];
}
/**
 * Original schema `PlaylistSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistSchema}
 */
export interface AssetsPlaylistSchema {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id?: string;
  item_count?: number;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  playlist_items?: AssetsPlaylistItemSchema[];
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistsQueryParamsSchema}
 */
export interface AssetsPlaylistsQueryParamsSchema {
  /**
   * A comma separated list of playlist IDs to filter by
   */
  ids?: string | null;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `PlaylistsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistsSchema}
 */
export interface AssetsPlaylistsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsPlaylist[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `PortalBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalBaseSchema}
 */
export interface AssetsPortalBaseSchema {
  config?: AssetsPortalConfig;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  keyframes?: FilesKeyframeSchemaWithId[];
  logo?: string;
  logo_storage_id?: string;
  name: string;
  playlist_id?: string;
  status?: 'ACTIVE';
  system_domain_id?: string;
}
/**
 * Original schema `PortalConfig`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalConfig}
 */
export interface AssetsPortalConfig {
  theme: AssetsTheme;
}
/**
 * Original schema `Theme`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Theme}
 */
export interface AssetsTheme {
  base?: ('light' | 'dark') | null;
  colors?: AssetsThemeColors | null;
  typography?: AssetsThemeTypography | null;
}
/**
 * Original schema `ThemeColors`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ThemeColors}
 */
export interface AssetsThemeColors {
  background?: string | null;
  primary?: string | null;
  secondary?: string | null;
  text?: string | null;
}
/**
 * Original schema `ThemeTypography`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ThemeTypography}
 */
export interface AssetsThemeTypography {
  font_family?: string | null;
  font_size_base?: string | null;
  heading_font_family?: string | null;
}
/**
 * Original schema `PortalConfigSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalConfigSchema}
 */
export interface AssetsPortalConfigSchema {
  theme: AssetsTheme;
}
/**
 * Original schema `PortalCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalCreateSchema}
 */
export interface AssetsPortalCreateSchema {
  config?: AssetsPortalConfigSchema;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  keyframes?: FilesKeyframeSchemaWithId[];
  logo?: string;
  logo_storage_id?: string;
  name: string;
  playlist_id: string;
  status?: 'ACTIVE';
  system_domain_id?: string;
}
/**
 * Original schema `PortalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalSchema}
 */
export interface AssetsPortalSchema {
  config?: AssetsPortalConfigSchema;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  keyframes?: FilesKeyframeSchemaWithId[];
  logo?: string;
  logo_storage_id?: string;
  name: string;
  playlist_id?: string;
  status?: 'ACTIVE';
  system_domain_id?: string;
}
/**
 * Original schema `PortalsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalsQueryParamsSchema}
 */
export interface AssetsPortalsQueryParamsSchema {
  /**
   * A comma separated list of portal IDs to filter by
   */
  ids?: string | null;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * Free text search over the portal name, with wildcard (`*`) support
   */
  query?: string | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `PortalsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalsSchema}
 */
export interface AssetsPortalsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsPortalSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `ProcessBulkPersonsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProcessBulkPersonsSchema}
 */
export interface AssetsProcessBulkPersonsSchema {
  job_id: string;
  new_person_id?: string | null;
  person_ids: string[];
  queue_name: string;
}
/**
 * Original schema `ProjectBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectBaseSchema}
 */
export interface AssetsProjectBaseSchema {
  collection_id: string;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  status?: 'ACTIVE';
  storage_id?: string | null;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectCreateSchema}
 */
export interface AssetsProjectCreateSchema {
  /**
   * ID of a collection that will become a project collection
   */
  collection_id?: string;
  /**
   * ID of a collection that the project should be a child of
   */
  collection_parent_id?: string;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  status?: 'ACTIVE';
  storage_id?: string | null;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectMemberBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMemberBaseSchema}
 */
export interface AssetsProjectMemberBaseSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  project_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectMemberCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMemberCreateSchema}
 */
export interface AssetsProjectMemberCreateSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  /**
   * User ID in iconik
   */
  id: string;
  project_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectMemberSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMemberSchema}
 */
export interface AssetsProjectMemberSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  /**
   * User ID in iconik
   */
  id?: string;
  project_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectMembersQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMembersQueryParamsSchema}
 */
export interface AssetsProjectMembersQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `ProjectMembersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMembersSchema}
 */
export interface AssetsProjectMembersSchema {
  objects?: AssetsProjectMemberSchema[];
}
/**
 * Original schema `ProjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectSchema}
 */
export interface AssetsProjectSchema {
  collection_id: string;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  status?: 'ACTIVE';
  storage_id?: string | null;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectsQueryParamsSchema}
 */
export interface AssetsProjectsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `ProjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectsSchema}
 */
export interface AssetsProjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsProjectSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `PublicationDraftSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationDraftSchema}
 */
export interface AssetsPublicationDraftSchema {
  asset_id?: string;
  metadata_overrides?: {
    [k: string]: unknown;
  };
  publish_at_time?: string | null;
  storage_id?: string | null;
  template?: AssetsPublicationTemplate;
  thumbnail?: AssetsCreatePublicationJobThumbnailKeyframeSchema;
  title?: string;
}
/**
 * Original schema `PublicationTemplate`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplate}
 */
export interface AssetsPublicationTemplate {
  id?: string;
  name?: string;
}
/**
 * Original schema `PublicationTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplateSchema}
 */
export interface AssetsPublicationTemplateSchema {
  id?: string;
  name?: string;
}
/**
 * Original schema `PublicationTemplatesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplatesSchema}
 */
export interface AssetsPublicationTemplatesSchema {
  objects?: AssetsPublicationTemplateSchema[];
}
/**
 * Original schema `PublicationTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTokenSchema}
 */
export interface AssetsPublicationTokenSchema {
  api_base_url?: string;
  token?: string;
  ui_base_url?: string;
}
/**
 * Original schema `RecentAssetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentAssetElasticSchema}
 */
export interface AssetsRecentAssetElasticSchema {
  date_viewed?: string;
  object_id?: string;
  object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `RecentAssetsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentAssetsQueryParamsSchema}
 */
export interface AssetsRecentAssetsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * This parameter is used for infinite scroll pagination instead of deprecatedscroll API. It accepts a list of sort keys that will be used for getting a next page and it can be obtained from `_sort` key of the last object of the previous response
   */
  search_after?: unknown[] | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `RecentAssetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentAssetsSchema}
 */
export interface AssetsRecentAssetsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsRecentAssetElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `RecentCollectionElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentCollectionElasticSchema}
 */
export interface AssetsRecentCollectionElasticSchema {
  date_viewed?: string;
  object_id?: string;
  object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `RecentCollectionsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentCollectionsQueryParamsSchema}
 */
export interface AssetsRecentCollectionsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * This parameter is used for infinite scroll pagination instead of deprecatedscroll API. It accepts a list of sort keys that will be used for getting a next page and it can be obtained from the `search_after` key of the previous response
   */
  search_after?: unknown[] | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `RecentCollectionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentCollectionsSchema}
 */
export interface AssetsRecentCollectionsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsRecentCollectionElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `ReindexAllAssetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexAllAssetsSchema}
 */
export interface AssetsReindexAllAssetsSchema {
  asset_ids?: string[] | null;
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexAllCollectionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexAllCollectionsSchema}
 */
export interface AssetsReindexAllCollectionsSchema {
  collection_ids: string[] | null;
  realms?: string[] | null;
}
/**
 * Original schema `ReindexAllSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexAllSegmentsSchema}
 */
export interface AssetsReindexAllSegmentsSchema {
  asset_ids: string[] | null;
  ignore_comments?: boolean;
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexAssetHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexAssetHistorySchema}
 */
export interface AssetsReindexAssetHistorySchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexAssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexAssetSchema}
 */
export interface AssetsReindexAssetSchema {
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexBulkActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexBulkActionSchema}
 */
export interface AssetsReindexBulkActionSchema {
  include_assets?: boolean;
  include_collections?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexCollectionContentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexCollectionContentSchema}
 */
export interface AssetsReindexCollectionContentSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexCollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexCollectionSchema}
 */
export interface AssetsReindexCollectionSchema {
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexInheritedCollectionsACLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexInheritedCollectionsACLSchema}
 */
export interface AssetsReindexInheritedCollectionsACLSchema {
  collection_ids: string[] | null;
  content?: boolean;
  recursive?: boolean;
}
/**
 * Original schema `ReindexPlaylistSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexPlaylistSchema}
 */
export interface AssetsReindexPlaylistSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexPortalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexPortalSchema}
 */
export interface AssetsReindexPortalSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexProjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexProjectSchema}
 */
export interface AssetsReindexProjectSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexSegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexSegmentSchema}
 */
export interface AssetsReindexSegmentSchema {
  ignore_comments?: boolean;
  realms?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexSegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexSegmentsSchema}
 */
export interface AssetsReindexSegmentsSchema {
  ignore_comments?: boolean;
  realms?: string[] | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  segment_ids: string[];
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexSequenceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexSequenceSchema}
 */
export interface AssetsReindexSequenceSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexShareSchema}
 */
export interface AssetsReindexShareSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexViewDateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ReindexViewDateSchema}
 */
export interface AssetsReindexViewDateSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `RelationElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationElasticSchema}
 */
export interface AssetsRelationElasticSchema {
  date_created?: string;
  date_modified?: string;
  description?: string;
  related_from_asset_id?: string;
  related_to_asset_id?: string;
  relation_type?: string;
}
/**
 * Original schema `RelationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationSchema}
 */
export interface AssetsRelationSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  related_to_asset_id: string;
  relation_type: string;
  related_from_asset_id?: string;
}
/**
 * Original schema `RelationTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationTypeSchema}
 */
export interface AssetsRelationTypeSchema {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  destination_label: string;
  is_directional?: boolean;
  is_system?: boolean;
  name: string;
  source_label: string;
}
/**
 * Original schema `RelationTypesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationTypesSchema}
 */
export interface AssetsRelationTypesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsRelationTypeSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `RelationsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationsQueryParamsSchema}
 */
export interface AssetsRelationsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * JSON-encoded list of sort values from the previous page's last hit
   */
  search_after?: string | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `RelationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationsSchema}
 */
export interface AssetsRelationsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsRelationSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `SchedulePersonActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SchedulePersonActionSchema}
 */
export interface AssetsSchedulePersonActionSchema {
  job_id: string;
  new_person_id?: string | null;
  queue_name: string;
}
/**
 * Original schema `ScheduleSyncPersonToVersionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ScheduleSyncPersonToVersionsSchema}
 */
export interface AssetsScheduleSyncPersonToVersionsSchema {
  finished?: boolean;
  has_unconfirmed_instances?: boolean;
  job_id?: string | null;
  /**
   * @maxItems 3000
   */
  objects: AssetsAssetVersionLookupSchema[];
  person_id?: string | null;
  sync_id: string;
}
/**
 * Original schema `SegmentAttributeMatchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentAttributeMatchSchema}
 */
export interface AssetsSegmentAttributeMatchSchema {
  name: string;
  /**
   * Comparison operator used when matching the attribute. 'eq' works for any attribute, while 'lt' (less than) and 'gt' (greater than) are only valid for date and number attributes.
   */
  operator?: 'eq' | 'lt' | 'gt';
  value: unknown;
}
/**
 * Original schema `SegmentBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentBaseSchema}
 */
export interface AssetsSegmentBaseSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  id?: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `SegmentElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentElasticSchema}
 */
export interface AssetsSegmentElasticSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  has_attachments?: boolean;
  has_drawing?: boolean;
  id?: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `SegmentQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentQueryParamsSchema}
 */
export interface AssetsSegmentQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `SegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentSchema}
 */
export interface AssetsSegmentSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  /**
   * Whether the comment has attachments in iconik_files
   */
  has_attachments?: boolean;
  has_drawing?: boolean;
  id?: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `SegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentsSchema}
 */
export interface AssetsSegmentsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsSegmentElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `SemanticTranscriptionEntitySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SemanticTranscriptionEntitySchema}
 */
export interface AssetsSemanticTranscriptionEntitySchema {
  label?: string | null;
  text: string;
}
/**
 * Original schema `SemanticTranscriptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SemanticTranscriptionSchema}
 */
export interface AssetsSemanticTranscriptionSchema {
  cut_reasons?: string[] | null;
  embedding?: string | null;
  embedding_dim?: number | null;
  embedding_encoding?: string | null;
  embedding_model?: string | null;
  embedding_model_version?: string | null;
  entities?: AssetsSemanticTranscriptionEntitySchema[] | null;
  language?: string | null;
  speaker_count?: string | null;
  tone?: string | null;
  topics?: AssetsUnderstandingTag[] | null;
  track_id?: string | null;
  valence?: string | null;
}
/**
 * Original schema `SequenceBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceBaseSchema}
 */
export interface AssetsSequenceBaseSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
}
/**
 * Original schema `SequenceCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceCreateSchema}
 */
export interface AssetsSequenceCreateSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
}
/**
 * Original schema `SequenceItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemSchema}
 */
export interface AssetsSequenceItemSchema {
  id?: string;
  object_id: string;
  object_type: 'assets' | 'collections';
  /**
   * Position of the item in the sequence.If not provided, the item will be appended to the end of the sequence
   */
  position?: number;
  version_id?: string;
}
/**
 * Original schema `SequenceItemUpdatePositionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemUpdatePositionSchema}
 */
export interface AssetsSequenceItemUpdatePositionSchema {
  /**
   * New position of the item in the sequence.If not provided, the item will be appended to the end of the sequence
   */
  position?: number;
}
/**
 * Original schema `SequenceItemsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemsQueryParamsSchema}
 */
export interface AssetsSequenceItemsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `SequenceItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemsSchema}
 */
export interface AssetsSequenceItemsSchema {
  objects?: AssetsSequenceItemSchema[];
}
/**
 * Original schema `SequenceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceSchema}
 */
export interface AssetsSequenceSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
}
/**
 * Original schema `SequencesQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequencesQueryParamsSchema}
 */
export interface AssetsSequencesQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `SequencesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequencesSchema}
 */
export interface AssetsSequencesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsSequenceSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `ShareBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareBaseSchema}
 */
export interface AssetsShareBaseSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id?: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareCreateSchema}
 */
export interface AssetsShareCreateSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  emails: string[];
  expires?: string;
  id?: string;
  is_approval?: boolean | null;
  message?: string;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  password?: string | null;
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string;
  upload_storage_id?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareElasticSchema}
 */
export interface AssetsShareElasticSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  approval?: {
    [k: string]: unknown;
  };
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id?: string;
  is_approval?: boolean;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_title?: string;
  object_type?: string;
  owner_id?: string;
  personal_url?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string;
  users?: AssetsShareUsersElastic[];
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareUsersElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUsersElastic}
 */
export interface AssetsShareUsersElastic {
  access_count?: number;
  download_count?: number;
  email?: string;
  id?: string;
  last_access_date?: string;
}
/**
 * Original schema `ShareLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareLoginSchema}
 */
export interface AssetsShareLoginSchema {
  app_id?: string;
  hash: string;
  object_id?: string;
  object_type?: string;
  password?: string;
  token?: string;
}
/**
 * Original schema `ShareOptionsBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareOptionsBaseSchema}
 */
export interface AssetsShareOptionsBaseSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  is_approval?: boolean | null;
  metadata_views?: string[] | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  upload_storage_id?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareRoles`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareRoles}
 */
export interface AssetsShareRoles {
  roles?: string[];
}
/**
 * Original schema `ShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareSchema}
 */
export interface AssetsShareSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id?: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareTokenSchema}
 */
export interface AssetsShareTokenSchema {
  app_id: string;
  /**
   * DRM information for the share token, if applicable
   */
  drm: 'none' | 'standard';
  email: string;
  expires: string;
  is_internal_user: boolean;
  object_id: string;
  object_type: string;
  roles: string[];
  share_id: string;
  share_session_id?: string | null;
  share_user_id: string;
  system_domain_id: string;
  token: string;
  user_id: string;
  /**
   * Watermark information for the share token, if applicable
   */
  watermark: 'none' | 'standard';
}
/**
 * Original schema `ShareURLCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareURLCreateSchema}
 */
export interface AssetsShareURLCreateSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  is_approval?: boolean | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  password?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareURLSchema}
 */
export interface AssetsShareURLSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id?: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUserSchema}
 */
export interface AssetsShareUserSchema {
  access_count?: number;
  download_count?: number;
  email: string;
  first_name?: string;
  id?: string;
  internal_user_id?: string;
  last_access_date?: string;
  last_name?: string;
  object_id?: string;
  object_type?: string;
  password?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  share_id?: string;
}
/**
 * Original schema `ShareUsersElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUsersElasticSchema}
 */
export interface AssetsShareUsersElasticSchema {
  access_count?: number;
  download_count?: number;
  email?: string;
  id?: string;
  last_access_date?: string;
}
/**
 * Original schema `ShareUsersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUsersSchema}
 */
export interface AssetsShareUsersSchema {
  objects?: AssetsShareUserSchema[];
}
/**
 * Original schema `SharesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SharesElasticSchema}
 */
export interface AssetsSharesElasticSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AssetsShareElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total?: number;
}
/**
 * Original schema `SharesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SharesSchema}
 */
export interface AssetsSharesSchema {
  objects?: AssetsShareSchema[];
}
/**
 * Original schema `ShotSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShotSchema}
 */
export interface AssetsShotSchema {
  actions?: AssetsUnderstandingTag[] | null;
  animal_species?: AssetsUnderstandingTag[] | null;
  brand_logo?: AssetsUnderstandingTag[] | null;
  camera_angle?: AssetsUnderstandingTag | null;
  caption?: string | null;
  color_palette?: AssetsUnderstandingTag[] | null;
  composition?: string | null;
  dog_breeds?: AssetsUnderstandingTag[] | null;
  dominant_hue?: string | null;
  embedding?: string | null;
  embedding_dim?: number | null;
  embedding_encoding?: string | null;
  embedding_model?: string | null;
  embedding_model_version?: string | null;
  facial_expression?: AssetsUnderstandingTag[] | null;
  keyframe_ts?: number;
  light_key?: string | null;
  light_side?: string | null;
  light_style?: string[] | null;
  light_time?: string | null;
  mood?: AssetsUnderstandingTag[] | null;
  mood_valence?: string | null;
  movement?: string[] | null;
  objects?: AssetsUnderstandingTag[] | null;
  ocr_text?: string | null;
  orientation?: string | null;
  people_age_range?: string[] | null;
  people_bucket?: string | null;
  people_count?: number | null;
  people_features?: AssetsUnderstandingTag[] | null;
  people_gender?: string[] | null;
  place?: AssetsUnderstandingTag | null;
  resolution?: string | null;
  scale_rank?: number | null;
  season?: AssetsUnderstandingTag | null;
  sensitive_content?: AssetsUnderstandingTag[] | null;
  setting?: AssetsUnderstandingTag | null;
  shot_scale?: AssetsUnderstandingTag | null;
  sport_type?: AssetsUnderstandingTag | null;
  subject_type?: AssetsUnderstandingTag[] | null;
  time_of_day?: string | null;
  track_id?: string | null;
  weather?: AssetsUnderstandingTag | null;
}
/**
 * Original schema `StorageContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-StorageContentInfoSchema}
 */
export interface AssetsStorageContentInfoSchema {
  assets_count?: number;
  file_count?: number;
  storage_id?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `SyncSessionCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SyncSessionCreateSchema}
 */
export interface AssetsSyncSessionCreateSchema {
  current_dc_url?: string;
  date_created?: string;
  date_modified?: string;
  dc_url?: string;
  id?: string;
  node?: string;
}
/**
 * Original schema `SyncSessionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SyncSessionSchema}
 */
export interface AssetsSyncSessionSchema {
  current_dc_url?: string;
  date_created?: string;
  date_modified?: string;
  dc_url?: string;
  id?: string;
  node?: string;
}
/**
 * Original schema `SynchronizeCollectionKeyframesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SynchronizeCollectionKeyframesSchema}
 */
export interface AssetsSynchronizeCollectionKeyframesSchema {
  asset_ids?: string[] | null;
}
/**
 * Original schema `ThemeColorsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ThemeColorsSchema}
 */
export interface AssetsThemeColorsSchema {
  background?: string | null;
  primary?: string | null;
  secondary?: string | null;
  text?: string | null;
}
/**
 * Original schema `ThemeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ThemeSchema}
 */
export interface AssetsThemeSchema {
  base?: ('light' | 'dark') | null;
  colors?: AssetsThemeColorsSchema | null;
  typography?: AssetsThemeTypography | null;
}
/**
 * Original schema `ThemeTypographySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ThemeTypographySchema}
 */
export interface AssetsThemeTypographySchema {
  font_family?: string | null;
  font_size_base?: string | null;
  heading_font_family?: string | null;
}
/**
 * Original schema `TranscriptionElementTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-TranscriptionElementTypeSchema}
 */
export interface AssetsTranscriptionElementTypeSchema {
  end_ms: number;
  score?: number;
  start_ms: number;
  value: string;
}
/**
 * Original schema `TranscriptionTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-TranscriptionTypeSchema}
 */
export interface AssetsTranscriptionTypeSchema {
  speaker?: number | null;
  /**
   * @minItems 1
   */
  words: AssetsTranscriptionElementTypeSchema[];
}
/**
 * Original schema `UnderstandingTagSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-UnderstandingTagSchema}
 */
export interface AssetsUnderstandingTagSchema {
  label: string;
  level?: string | null;
  score?: number | null;
}
/**
 * Original schema `UploadStorageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-UploadStorageSchema}
 */
export interface AssetsUploadStorageSchema {
  add_uuid_to_filenames: boolean;
  id: string;
  method:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE';
  presign_md5_checksum?: boolean;
}
/**
 * Original schema `UserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-UserSchema}
 */
export interface AssetsUserSchema {
  email?: string;
  first_name?: string;
  id?: string;
  last_name?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
}
/**
 * Original schema `VideoSourceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-VideoSourceSchema}
 */
export interface AssetsVideoSourceSchema {
  /**
   * The iconik file ID to use as the video source for the import.
   */
  file_id?: string;
  /**
   * The mode to use for the import. Only "as-is" is supported for now, which means the file will be used as-is without any transcoding or processing.
   */
  mode?: 'as-is';
}
/**
 * Original schema `_PublicationJobThumbnailSchemaBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-_PublicationJobThumbnailSchemaBase}
 */
export interface Assets_PublicationJobThumbnailSchemaBase {}
/**
 * Original schema `AssetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetsSchema}
 */
export interface AssetsAssetsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsAssetElasticSchemaTypedWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `AssetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchema}
 */
export interface AssetsAssetElasticSchemaWithIdNullable {
  analyze_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[] | null;
  approval?: AssetsApprovalSchemaNullable | null;
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number | null;
  created_by_user?: string | null;
  created_by_user_info?: AssetsUser | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_imported?: string | null;
  date_modified?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  deleted_by_user_info?: AssetsUser | null;
  duration_milliseconds?: number | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  favoured?: boolean | null;
  files?: FilesFileSchemaWithIdNullable[] | null;
  formats?: FilesFormatSchemaWithIdNullable[] | null;
  has_unconfirmed_persons?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_blocked?: boolean | null;
  is_online?: boolean | null;
  keyframes?: FilesKeyframeSchemaWithIdNullable[] | null;
  last_archive_restore_date?: string | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  original_asset_id?: string | null;
  original_segment_id?: string | null;
  original_version_id?: string | null;
  person_ids?: string[] | null;
  position?: number | null;
  proxies?: FilesProxySchemaWithId[] | null;
  relations?: AssetsRelationElastic[] | null;
  site_name?: string | null;
  status?: ('ACTIVE' | 'DELETED') | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  title: string;
  type?:
    | (
        | 'ASSET'
        | 'SEQUENCE'
        | 'NLE_PROJECT'
        | 'PLACEHOLDER'
        | 'CUSTOM'
        | 'LINK'
        | 'SUBCLIP'
      )
    | null;
  updated_by_user?: string | null;
  updated_by_user_info?: AssetsUser | null;
  versions?: AssetsAssetVersion[] | null;
  versions_number?: number | null;
  warning?: string | null;
  format?: string | null;
}
/**
 * Original schema `AssetPostElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostElastic}
 */
export interface AssetsAssetPostElasticWithIdNullable {
  analyze_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[] | null;
  approval?: AssetsApprovalSchemaNullable | null;
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  comments_count?: number | null;
  created_by_user?: string | null;
  created_by_user_info?: AssetsUser | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_imported?: string | null;
  date_modified?: string | null;
  date_published_at?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  deleted_by_user_info?: AssetsUser | null;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  duration_milliseconds?: number | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  favoured?: boolean | null;
  files?: FilesFileSchemaWithIdNullable[] | null;
  formats?: FilesFormatSchemaWithIdNullable[] | null;
  has_unconfirmed_persons?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_blocked?: boolean | null;
  is_online?: boolean | null;
  keyframes?: FilesKeyframeSchemaWithIdNullable[] | null;
  last_archive_restore_date?: string | null;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  original_asset_id?: string | null;
  original_segment_id?: string | null;
  original_version_id?: string | null;
  person_ids?: string[] | null;
  position?: number | null;
  proxies?: FilesProxySchemaWithId[] | null;
  publication_id?: number | null;
  publication_status?:
    | (
        | 'CANCELED'
        | 'FAILED'
        | 'PUBLISHED'
        | 'PUBLISHED_WITH_WARNING'
        | 'RUNNING'
        | 'SCHEDULED'
      )
    | null;
  relations?: AssetsRelationElastic[] | null;
  site_name?: string | null;
  status?: ('ACTIVE' | 'DELETED') | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  title: string;
  type?: 'POST' | null;
  updated_by_user?: string | null;
  updated_by_user_info?: AssetsUser | null;
  versions?: AssetsAssetVersion[] | null;
  versions_number?: number | null;
  views?: number | null;
  warning?: string | null;
  format?: string | null;
}
/**
 * Original schema `AssetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetElasticSchema}
 */
export interface AssetsAssetElasticSchemaWithId {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchemaNullable;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithIdNullable[];
  formats?: FilesFormatSchemaWithIdNullable[];
  has_unconfirmed_persons?: boolean;
  id: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  versions_number?: number;
  warning?: string | null;
  format?: string;
}
/**
 * Original schema `AssetPostElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostElastic}
 */
export interface AssetsAssetPostElasticWithId {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchemaNullable;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithIdNullable[];
  formats?: FilesFormatSchemaWithIdNullable[];
  has_unconfirmed_persons?: boolean;
  id: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  versions_number?: number;
  views?: number | null;
  warning?: string | null;
  format?: string;
}
/**
 * Original schema `AssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchema}
 */
export interface AssetsAssetSchemaWithId {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  warning?: string | null;
}
/**
 * Original schema `AssetPostSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostSchema}
 */
export interface AssetsAssetPostSchemaWithId {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_published_at?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  has_unconfirmed_persons?: boolean;
  id: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  last_archive_restore_date?: string;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | 'CANCELED'
    | 'FAILED'
    | 'PUBLISHED'
    | 'PUBLISHED_WITH_WARNING'
    | 'RUNNING'
    | 'SCHEDULED';
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?: 'POST';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersion[];
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `RecentAssetsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentAssetsSchema}
 */
export interface AssetsRecentAssetsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsRecentAssetElasticSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `RecentAssetElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentAssetElasticSchema}
 */
export interface AssetsRecentAssetElasticSchemaNullable {
  date_viewed?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `RelationTypesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationTypesSchema}
 */
export interface AssetsRelationTypesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsRelationTypeSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `RelationTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationTypeSchema}
 */
export interface AssetsRelationTypeSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  destination_label: string;
  is_directional?: boolean | null;
  is_system?: boolean | null;
  name: string;
  source_label: string;
}
/**
 * Original schema `AssetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetSchema}
 */
export interface AssetsAssetSchemaWithIdNullable {
  analyze_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  created_by_user?: string | null;
  created_by_user_info?: AssetsUser | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_imported?: string | null;
  date_modified?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  deleted_by_user_info?: AssetsUser | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  favoured?: boolean | null;
  has_unconfirmed_persons?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_blocked?: boolean | null;
  is_online?: boolean | null;
  last_archive_restore_date?: string | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string | null;
  original_segment_id?: string | null;
  original_version_id?: string | null;
  person_ids?: string[] | null;
  site_name?: string | null;
  status?: ('ACTIVE' | 'DELETED') | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  title: string;
  type?:
    | (
        | 'ASSET'
        | 'SEQUENCE'
        | 'NLE_PROJECT'
        | 'PLACEHOLDER'
        | 'CUSTOM'
        | 'LINK'
        | 'SUBCLIP'
      )
    | null;
  updated_by_user?: string | null;
  updated_by_user_info?: AssetsUser | null;
  versions?: AssetsAssetVersion[] | null;
  warning?: string | null;
}
/**
 * Original schema `AssetPostSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetPostSchema}
 */
export interface AssetsAssetPostSchemaWithIdNullable {
  analyze_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  category?: string | null;
  clip_aspect_ratio?: string | null;
  clip_duration?: number | null;
  clip_id?: number | null;
  clip_mime_type?: string | null;
  created_by_user?: string | null;
  created_by_user_info?: AssetsUser | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_imported?: string | null;
  date_modified?: string | null;
  date_published_at?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  deleted_by_user_info?: AssetsUser | null;
  destination_icon?: string | null;
  destination_name?: string | null;
  destination_picture?: string | null;
  destination_type?: string | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  favoured?: boolean | null;
  has_unconfirmed_persons?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_blocked?: boolean | null;
  is_online?: boolean | null;
  last_archive_restore_date?: string | null;
  likes?: number | null;
  limit_download_to_groups?: string[] | null;
  original_asset_id?: string | null;
  original_segment_id?: string | null;
  original_version_id?: string | null;
  person_ids?: string[] | null;
  publication_id?: number | null;
  publication_status?:
    | (
        | 'CANCELED'
        | 'FAILED'
        | 'PUBLISHED'
        | 'PUBLISHED_WITH_WARNING'
        | 'RUNNING'
        | 'SCHEDULED'
      )
    | null;
  site_name?: string | null;
  status?: ('ACTIVE' | 'DELETED') | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  title: string;
  type?: 'POST' | null;
  updated_by_user?: string | null;
  updated_by_user_info?: AssetsUser | null;
  versions?: AssetsAssetVersion[] | null;
  views?: number | null;
  warning?: string | null;
}
/**
 * Original schema `AssetHistoryEntitiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryEntitiesSchema}
 */
export interface AssetsAssetHistoryEntitiesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsAssetHistoryElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `AssetHistoryElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryElasticSchema}
 */
export interface AssetsAssetHistoryElasticSchemaWithIdNullable {
  asset_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `AssetHistoryElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistoryElasticSchema}
 */
export interface AssetsAssetHistoryElasticSchemaWithId {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  id: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `AssetHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistorySchema}
 */
export interface AssetsAssetHistorySchemaWithId {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  id: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string;
  user_id?: string;
  version_id?: string;
}
/**
 * Original schema `AssetHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetHistorySchema}
 */
export interface AssetsAssetHistorySchemaWithIdNullable {
  asset_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  job_id?: string | null;
  operation_description?: string | null;
  operation_type:
    | 'EXPORT'
    | 'TRANSCODE'
    | 'ANALYZE'
    | 'ADD_FORMAT'
    | 'DELETE_FORMAT'
    | 'RESTORE_FORMAT'
    | 'DELETE_FILESET'
    | 'DELETE_FILE'
    | 'RESTORE_FILESET'
    | 'MODIFY_FILESET'
    | 'APPROVE'
    | 'REJECT'
    | 'DOWNLOAD'
    | 'METADATA'
    | 'CUSTOM'
    | 'TRANSCRIPTION'
    | 'VERSION_CREATE'
    | 'VERSION_DELETE'
    | 'VERSION_UPDATE'
    | 'VERSION_PROMOTE'
    | 'RESTORE'
    | 'RESTORE_FROM_GLACIER'
    | 'ARCHIVE'
    | 'RESTORE_ARCHIVE'
    | 'DELETE'
    | 'TRANSFER'
    | 'UNLINK_SUBCLIP'
    | 'FACE_RECOGNITION'
    | 'PUBLISH'
    | 'PUBLISH_SCHEDULED'
    | 'PUBLISH_SAVE_DRAFT';
  share_id?: string | null;
  share_user_id?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `RelationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RelationSchema}
 */
export interface AssetsRelationSchemaWithId {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id: string;
  related_to_asset_id: string;
  relation_type: string;
  related_from_asset_id?: string;
}
/**
 * Original schema `SegmentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentsSchema}
 */
export interface AssetsSegmentsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsSegmentElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `SegmentElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentElasticSchema}
 */
export interface AssetsSegmentElasticSchemaWithIdNullable {
  asset_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  has_attachments?: boolean | null;
  has_drawing?: boolean | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  metadata_view_id?: string | null;
  parent_id?: string | null;
  path?: string | null;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean | null;
  segment_color?: string | null;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: ('ACTIVE' | 'DELETED' | 'AWAITED') | null;
  subclip_id?: string | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean | null;
  transcription?: AssetsTranscriptionType | null;
  transcription_id?: string | null;
  user_first_name?: string | null;
  user_id?: string | null;
  user_info?: AssetsUser | null;
  user_last_name?: string | null;
  user_photo?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `SegmentElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentElasticSchema}
 */
export interface AssetsSegmentElasticSchemaWithId {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  has_attachments?: boolean;
  has_drawing?: boolean;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `SegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentSchema}
 */
export interface AssetsSegmentSchemaWithId {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  /**
   * Whether the comment has attachments in iconik_files
   */
  has_attachments?: boolean;
  has_drawing?: boolean;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  metadata_view_id?: string | null;
  parent_id?: string;
  path?: string;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean;
  segment_color?: string;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: 'ACTIVE' | 'DELETED' | 'AWAITED';
  subclip_id?: string;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean;
  transcription?: AssetsTranscriptionType;
  transcription_id?: string | null;
  user_first_name?: string;
  user_id?: string;
  user_info?: AssetsUser;
  user_last_name?: string;
  user_photo?: string;
  version_id?: string;
}
/**
 * Original schema `SegmentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SegmentSchema}
 */
export interface AssetsSegmentSchemaWithIdNullable {
  asset_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  drawing?: AssetsDrawingSchema | null;
  external_id?: string | null;
  face_bounding_boxes?: AssetsFaceBoundingBoxSchema[] | null;
  /**
   * Whether the comment has attachments in iconik_files
   */
  has_attachments?: boolean | null;
  has_drawing?: boolean | null;
  id: string;
  /**
   * If set to true, the segment is only visible to internal iconik users
   */
  is_internal?: boolean | null;
  keyframe_id?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  metadata_view_id?: string | null;
  parent_id?: string | null;
  path?: string | null;
  person_id?: string | null;
  /**
   * ID of a project if the segment is created from a project
   */
  project_id?: string | null;
  segment_checked?: boolean | null;
  segment_color?: string | null;
  segment_text?: string | null;
  segment_track?: string | null;
  segment_type:
    | 'MARKER'
    | 'QC'
    | 'GENERIC'
    | 'COMMENT'
    | 'TAG'
    | 'TRANSCRIPTION'
    | 'SCENE'
    | 'SHOT'
    | 'PERSON'
    | 'SEMANTIC_TRANSCRIPTION';
  semantic_transcription?: AssetsSemanticTranscription | null;
  /**
   * ID of a share if the segment is created from a share
   */
  share_id?: string | null;
  share_session_id?: string | null;
  share_user_email?: string | null;
  shot?: AssetsShot | null;
  status?: ('ACTIVE' | 'DELETED' | 'AWAITED') | null;
  subclip_id?: string | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  top_level?: boolean | null;
  transcription?: AssetsTranscriptionType | null;
  transcription_id?: string | null;
  user_first_name?: string | null;
  user_id?: string | null;
  user_info?: AssetsUser | null;
  user_last_name?: string | null;
  user_photo?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `SharesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SharesElasticSchema}
 */
export interface AssetsSharesElasticSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsShareElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `ShareElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareElasticSchema}
 */
export interface AssetsShareElasticSchemaWithIdNullable {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean | null;
  allow_download: boolean;
  allow_download_proxy?: boolean | null;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean | null;
  allow_user_search_for_mentions?: boolean | null;
  allow_view_transcriptions?: boolean | null;
  allow_view_versions?: boolean | null;
  approval?: {
    [k: string]: unknown;
  } | null;
  automatic_approval_share?: boolean | null;
  date_created?: string | null;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string | null;
  has_password?: boolean | null;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string | null;
  object_title?: string | null;
  object_type?: string | null;
  owner_id?: string | null;
  personal_url?: string | null;
  population_status?: ('POPULATING' | 'FINISHED') | null;
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string | null;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string | null;
  users?: AssetsShareUsersElastic[] | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareElasticSchema}
 */
export interface AssetsShareElasticSchemaWithId {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  approval?: {
    [k: string]: unknown;
  };
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id: string;
  is_approval?: boolean;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_title?: string;
  object_type?: string;
  owner_id?: string;
  personal_url?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string;
  users?: AssetsShareUsersElastic[];
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `AssetTranscriptionsPropertiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionsPropertiesSchema}
 */
export interface AssetsAssetTranscriptionsPropertiesSchemaWithId {
  objects: AssetsAssetTranscriptionPropertiesSchemaWithIdNullable[];
}
/**
 * Original schema `AssetTranscriptionPropertiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionPropertiesSchema}
 */
export interface AssetsAssetTranscriptionPropertiesSchemaWithIdNullable {
  asset_id?: string | null;
  engine_info?: AssetsTranscriptionEngineInfo | null;
  id: string;
  language?: string | null;
  speaker_labels?: {
    [k: string]: string;
  } | null;
  system_domain_id?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `AssetTranscriptionPropertiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-AssetTranscriptionPropertiesSchema}
 */
export interface AssetsAssetTranscriptionPropertiesSchemaWithId {
  asset_id?: string;
  engine_info?: AssetsTranscriptionEngineInfo | null;
  id: string;
  language?: string;
  speaker_labels?: {
    [k: string]: string;
  };
  system_domain_id?: string;
  version_id?: string;
}
/**
 * Original schema `CollectionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionsSchema}
 */
export interface AssetsCollectionsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsCollectionElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `CollectionElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionElasticSchema}
 */
export interface AssetsCollectionElasticSchemaWithIdNullable {
  category?: string | null;
  created_by_user?: string | null;
  custom_keyframe?: string | null;
  custom_order_status?: ('DISABLED' | 'ENABLING' | 'ENABLED') | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  external_id?: string | null;
  favoured?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_root?: boolean | null;
  keyframe_asset_ids?: string[] | null;
  keyframes?: FilesKeyframeSchemaWithIdNullable[] | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  parent_id?: string | null;
  parents?: string[] | null;
  permissions?: string[] | null;
  position?: number | null;
  project_id?: string | null;
  status?: ('ACTIVE' | 'HIDDEN' | 'DELETED') | null;
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionElasticSchema}
 */
export interface AssetsCollectionElasticSchemaWithId {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithIdNullable[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSchema}
 */
export interface AssetsCollectionSchemaWithId {
  category?: string | null;
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_order_status?: 'DISABLED' | 'ENABLING' | 'ENABLED';
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  external_id?: string | null;
  favoured?: boolean;
  id: string;
  in_collections?: string[];
  is_root?: boolean;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  parent_id?: string | null;
  parents?: string[];
  permissions?: string[];
  position?: number;
  project_id?: string;
  status?: 'ACTIVE' | 'HIDDEN' | 'DELETED';
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `RecentCollectionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentCollectionsSchema}
 */
export interface AssetsRecentCollectionsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsRecentCollectionElasticSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `RecentCollectionElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-RecentCollectionElasticSchema}
 */
export interface AssetsRecentCollectionElasticSchemaNullable {
  date_viewed?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `CollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSchema}
 */
export interface AssetsCollectionSchemaWithIdNullable {
  category?: string | null;
  created_by_user?: string | null;
  custom_keyframe?: string | null;
  custom_order_status?: ('DISABLED' | 'ENABLING' | 'ENABLED') | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_modified?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  external_id?: string | null;
  favoured?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_root?: boolean | null;
  keyframe_asset_ids?: string[] | null;
  keyframes?: FilesKeyframeSchemaWithId[] | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  parent_id?: string | null;
  parents?: string[] | null;
  permissions?: string[] | null;
  position?: number | null;
  project_id?: string | null;
  status?: ('ACTIVE' | 'HIDDEN' | 'DELETED') | null;
  storage_id?: string | null;
  title: string;
}
/**
 * Original schema `CollectionContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionContentInfoSchema}
 */
export interface AssetsCollectionContentInfoSchemaNullable {
  assets_count?: number | null;
  collections_count?: number | null;
  storage_info?: AssetsStorageContentInfo[] | null;
  title?: string | null;
  total_duration_milliseconds?: number | null;
  total_proxy_size?: number | null;
  total_size?: number | null;
}
/**
 * Original schema `CollectionSizeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSizeSchema}
 */
export interface AssetsCollectionSizeSchemaWithId {
  id: string;
  size?: number;
  title?: string;
}
/**
 * Original schema `CollectionSizeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CollectionSizeSchema}
 */
export interface AssetsCollectionSizeSchemaWithIdNullable {
  id: string;
  size?: number | null;
  title?: string | null;
}
/**
 * Original schema `CustomActionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionsSchema}
 */
export interface AssetsCustomActionsSchemaWithId {
  objects: AssetsCustomActionSchemaWithIdNullable[];
}
/**
 * Original schema `CustomActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionSchema}
 */
export interface AssetsCustomActionSchemaWithIdNullable {
  app_id?: string | null;
  color?: string | null;
  context:
    | 'ASSET'
    | 'ASSET_SUBCLIP'
    | 'SHARED_ASSET'
    | 'COLLECTION'
    | 'SHARED_COLLECTION'
    | 'BULK'
    | 'SAVED_SEARCH'
    | 'NONE'
    | 'PLAYLIST'
    | 'SHARED_PLAYLIST';
  date_created?: string | null;
  date_modified?: string | null;
  disabled?: boolean | null;
  headers?: {
    [k: string]: string;
  } | null;
  id: string;
  last_error?: string | null;
  last_error_date?: string | null;
  metadata_view?: string | null;
  publish_template_id?: string | null;
  status?: ('FAILING' | 'HEALTHY') | null;
  system_domain_id?: string | null;
  title: string;
  transcoder_id?: string | null;
  type?: ('OPEN' | 'POST' | 'PUBLISH') | null;
  url: string;
}
/**
 * Original schema `CustomActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-CustomActionSchema}
 */
export interface AssetsCustomActionSchemaWithId {
  app_id?: string | null;
  color?: string | null;
  context:
    | 'ASSET'
    | 'ASSET_SUBCLIP'
    | 'SHARED_ASSET'
    | 'COLLECTION'
    | 'SHARED_COLLECTION'
    | 'BULK'
    | 'SAVED_SEARCH'
    | 'NONE'
    | 'PLAYLIST'
    | 'SHARED_PLAYLIST';
  date_created?: string;
  date_modified?: string;
  disabled?: boolean;
  headers?: {
    [k: string]: string;
  };
  id: string;
  last_error?: string;
  last_error_date?: string;
  metadata_view?: string | null;
  publish_template_id?: string | null;
  status?: 'FAILING' | 'HEALTHY';
  system_domain_id?: string;
  title: string;
  transcoder_id?: string | null;
  type?: 'OPEN' | 'POST' | 'PUBLISH';
  url: string;
}
/**
 * Original schema `FavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-FavoritesSchema}
 */
export interface AssetsFavoritesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsAssetOrCollectionSchema;
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `PlaylistsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistsSchema}
 */
export interface AssetsPlaylistsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsPlaylistWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `Playlist`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Playlist}
 */
export interface AssetsPlaylistWithIdNullable {
  created_by_user?: string | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  item_count?: number | null;
  keyframe_asset_ids?: string[] | null;
  keyframes?: FilesKeyframeSchemaWithId[] | null;
  name: string;
  project_id?: string | null;
  status?: 'HIDDEN' | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `Playlist`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-Playlist}
 */
export interface AssetsPlaylistWithId {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id: string;
  item_count?: number;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistSchema}
 */
export interface AssetsPlaylistSchemaWithId {
  created_by_user?: string;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_modified?: string;
  id: string;
  item_count?: number;
  keyframe_asset_ids?: string[];
  keyframes?: FilesKeyframeSchemaWithId[];
  name: string;
  playlist_items?: AssetsPlaylistItemSchema[];
  project_id?: string;
  status?: 'HIDDEN';
  system_domain_id?: string;
}
/**
 * Original schema `PlaylistSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistSchema}
 */
export interface AssetsPlaylistSchemaWithIdNullable {
  created_by_user?: string | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  item_count?: number | null;
  keyframe_asset_ids?: string[] | null;
  keyframes?: FilesKeyframeSchemaWithId[] | null;
  name: string;
  playlist_items?: AssetsPlaylistItemSchema[] | null;
  project_id?: string | null;
  status?: 'HIDDEN' | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `PlaylistItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemsSchema}
 */
export interface AssetsPlaylistItemsSchemaWithId {
  objects: AssetsPlaylistItemElasticSchemaWithIdNullable[];
}
/**
 * Original schema `PlaylistItemElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemElasticSchema}
 */
export interface AssetsPlaylistItemElasticSchemaWithIdNullable {
  analyze_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[] | null;
  approval?: AssetsApprovalSchema | null;
  archive_status?:
    | ('NOT_ARCHIVED' | 'ARCHIVING' | 'FAILED_TO_ARCHIVE' | 'ARCHIVED')
    | null;
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number | null;
  created_by_user?: string | null;
  created_by_user_info?: AssetsUser | null;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string | null;
  date_deleted?: string | null;
  date_imported?: string | null;
  date_modified?: string | null;
  date_viewed?: string | null;
  deleted_by_user?: string | null;
  deleted_by_user_info?: AssetsUser | null;
  duration_milliseconds?: number | null;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | ('N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE')
    | null;
  favoured?: boolean | null;
  files?: FilesFileSchemaWithId[] | null;
  formats?:
    | {
        [k: string]: unknown;
      }[]
    | null;
  has_unconfirmed_persons?: boolean | null;
  id: string;
  in_collections?: string[] | null;
  is_blocked?: boolean | null;
  is_online?: boolean | null;
  keyframes?: FilesKeyframeSchemaWithId[] | null;
  last_archive_restore_date?: string | null;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type?: string | null;
  original_asset_id?: string | null;
  original_segment_id?: string | null;
  original_version_id?: string | null;
  person_ids?: string[] | null;
  position?: number | null;
  proxies?: FilesProxySchemaWithId[] | null;
  relations?: AssetsRelationElastic[] | null;
  site_name?: string | null;
  status?: ('ACTIVE' | 'DELETED') | null;
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  title: string;
  type?:
    | (
        | 'ASSET'
        | 'SEQUENCE'
        | 'NLE_PROJECT'
        | 'PLACEHOLDER'
        | 'CUSTOM'
        | 'LINK'
        | 'SUBCLIP'
      )
    | null;
  updated_by_user?: string | null;
  updated_by_user_info?: AssetsUser | null;
  versions?: AssetsAssetVersionSchema[] | null;
  versions_number?: number | null;
  warning?: string | null;
}
/**
 * Original schema `PlaylistItemElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemElasticSchema}
 */
export interface AssetsPlaylistItemElasticSchemaWithId {
  analyze_status?: 'N/A' | 'REQUESTED' | 'IN_PROGRESS' | 'FAILED' | 'DONE';
  /**
   * Unordered list of all ancestor collection ids
   */
  ancestor_collections?: string[];
  approval?: AssetsApprovalSchema;
  archive_status?:
    | 'NOT_ARCHIVED'
    | 'ARCHIVING'
    | 'FAILED_TO_ARCHIVE'
    | 'ARCHIVED';
  category?: string | null;
  /**
   * ID of the draft clip in the Wildmoka system that is linked to this asset.
   */
  clip_id?: number | null;
  comments_count?: number;
  created_by_user?: string;
  created_by_user_info?: AssetsUser;
  custom_keyframe?: string | null;
  custom_poster?: string | null;
  date_created?: string;
  date_deleted?: string;
  date_imported?: string;
  date_modified?: string;
  date_viewed?: string;
  deleted_by_user?: string;
  deleted_by_user_info?: AssetsUser;
  duration_milliseconds?: number;
  external_id?: string | null;
  external_link?: string | null;
  face_recognition_status?:
    | 'N/A'
    | 'REQUESTED'
    | 'IN_PROGRESS'
    | 'FAILED'
    | 'DONE';
  favoured?: boolean;
  files?: FilesFileSchemaWithId[];
  formats?: {
    [k: string]: unknown;
  }[];
  has_unconfirmed_persons?: boolean;
  id: string;
  in_collections?: string[];
  is_blocked?: boolean;
  is_online?: boolean;
  keyframes?: FilesKeyframeSchemaWithId[];
  last_archive_restore_date?: string;
  limit_download_to_groups?: string[] | null;
  media_type?: string | null;
  metadata?: {
    [k: string]: unknown;
  };
  object_type?: string;
  original_asset_id?: string;
  original_segment_id?: string;
  original_version_id?: string;
  person_ids?: string[];
  position?: number;
  proxies?: FilesProxySchemaWithId[];
  relations?: AssetsRelationElastic[];
  site_name?: string | null;
  status?: 'ACTIVE' | 'DELETED';
  time_end_milliseconds?: number;
  time_start_milliseconds?: number;
  title: string;
  type?:
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP';
  updated_by_user?: string;
  updated_by_user_info?: AssetsUser;
  versions?: AssetsAssetVersionSchema[];
  versions_number?: number;
  warning?: string | null;
}
/**
 * Original schema `PlaylistItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PlaylistItemSchema}
 */
export interface AssetsPlaylistItemSchemaWithId {
  id: string;
  object_id: string;
  object_type: 'assets' | 'sequences';
  time_end_milliseconds?: number | null;
  time_start_milliseconds?: number | null;
  /**
   * Version selector for this playlist item. Accepts: omitted/null/empty (all versions); "latest" (latest version only); a single UUID1; or a comma-separated list of UUID1s (e.g. "uuid1,uuid2,uuid3") with no whitespace and no duplicates.
   */
  version_id?: string | null;
}
/**
 * Original schema `PortalsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalsSchema}
 */
export interface AssetsPortalsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsPortalSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `PortalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalSchema}
 */
export interface AssetsPortalSchemaWithIdNullable {
  config?: AssetsPortalConfigSchema | null;
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  keyframes?: FilesKeyframeSchemaWithId[] | null;
  logo?: string | null;
  logo_storage_id?: string | null;
  name: string;
  playlist_id?: string | null;
  status?: 'ACTIVE' | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `PortalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PortalSchema}
 */
export interface AssetsPortalSchemaWithId {
  config?: AssetsPortalConfigSchema;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id: string;
  keyframes?: FilesKeyframeSchemaWithId[];
  logo?: string;
  logo_storage_id?: string;
  name: string;
  playlist_id?: string;
  status?: 'ACTIVE';
  system_domain_id?: string;
}
/**
 * Original schema `ProjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectsSchema}
 */
export interface AssetsProjectsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsProjectSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `ProjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectSchema}
 */
export interface AssetsProjectSchemaWithIdNullable {
  collection_id: string;
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  name: string;
  status?: 'ACTIVE' | null;
  storage_id?: string | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `ProjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectSchema}
 */
export interface AssetsProjectSchemaWithId {
  collection_id: string;
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id: string;
  name: string;
  status?: 'ACTIVE';
  storage_id?: string | null;
  system_domain_id?: string;
}
/**
 * Original schema `ProjectMembersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMembersSchema}
 */
export interface AssetsProjectMembersSchemaWithId {
  objects: AssetsProjectMemberSchemaWithIdNullable[];
}
/**
 * Original schema `ProjectMemberSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMemberSchema}
 */
export interface AssetsProjectMemberSchemaWithIdNullable {
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  /**
   * User ID in iconik
   */
  id: string;
  project_id?: string | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `ProjectMemberSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ProjectMemberSchema}
 */
export interface AssetsProjectMemberSchemaWithId {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  /**
   * User ID in iconik
   */
  id: string;
  project_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `DestinationItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DestinationItemsSchema}
 */
export interface AssetsDestinationItemsSchemaWithId {
  objects: AssetsDestinationItemSchemaNullable[];
}
/**
 * Original schema `DestinationItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-DestinationItemSchema}
 */
export interface AssetsDestinationItemSchemaNullable {
  label?: string | null;
  value?: string | null;
}
/**
 * Original schema `PublicationDraftSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationDraftSchema}
 */
export interface AssetsPublicationDraftSchemaNullable {
  asset_id?: string | null;
  metadata_overrides?: {
    [k: string]: unknown;
  } | null;
  publish_at_time?: string | null;
  storage_id?: string | null;
  template?: AssetsPublicationTemplate | null;
  thumbnail?: AssetsCreatePublicationJobThumbnailKeyframeSchema | null;
  title?: string | null;
}
/**
 * Original schema `PublicationTemplatesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplatesSchema}
 */
export interface AssetsPublicationTemplatesSchemaWithId {
  objects: AssetsPublicationTemplateSchemaWithIdNullable[];
}
/**
 * Original schema `PublicationTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplateSchema}
 */
export interface AssetsPublicationTemplateSchemaWithIdNullable {
  id: string;
  name?: string | null;
}
/**
 * Original schema `PublicationTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTemplateSchema}
 */
export interface AssetsPublicationTemplateSchemaWithId {
  id: string;
  name?: string;
}
/**
 * Original schema `PublicationTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-PublicationTokenSchema}
 */
export interface AssetsPublicationTokenSchemaNullable {
  api_base_url?: string | null;
  token?: string | null;
  ui_base_url?: string | null;
}
/**
 * Original schema `SequencesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequencesSchema}
 */
export interface AssetsSequencesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsSequenceSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `SequenceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceSchema}
 */
export interface AssetsSequenceSchemaWithIdNullable {
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  name: string;
  system_domain_id?: string | null;
}
/**
 * Original schema `SequenceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceSchema}
 */
export interface AssetsSequenceSchemaWithId {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id: string;
  name: string;
  system_domain_id?: string;
}
/**
 * Original schema `SequenceItemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemsSchema}
 */
export interface AssetsSequenceItemsSchemaWithId {
  objects: AssetsSequenceItemSchemaWithIdNullable[];
}
/**
 * Original schema `SequenceItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemSchema}
 */
export interface AssetsSequenceItemSchemaWithIdNullable {
  id: string;
  object_id: string;
  object_type: 'assets' | 'collections';
  /**
   * Position of the item in the sequence.If not provided, the item will be appended to the end of the sequence
   */
  position?: number | null;
  version_id?: string | null;
}
/**
 * Original schema `SequenceItemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SequenceItemSchema}
 */
export interface AssetsSequenceItemSchemaWithId {
  id: string;
  object_id: string;
  object_type: 'assets' | 'collections';
  /**
   * Position of the item in the sequence.If not provided, the item will be appended to the end of the sequence
   */
  position?: number;
  version_id?: string;
}
/**
 * Original schema `ShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareSchema}
 */
export interface AssetsShareSchemaWithId {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id: string;
  object_type: 'assets' | 'collections' | 'playlists' | 'portals';
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `MagicLinkAllowlistListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistListSchema}
 */
export interface AssetsMagicLinkAllowlistListSchemaWithId {
  objects: AssetsMagicLinkAllowlistEntrySchemaWithIdNullable[];
}
/**
 * Original schema `MagicLinkAllowlistEntrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistEntrySchema}
 */
export interface AssetsMagicLinkAllowlistEntrySchemaWithIdNullable {
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  /**
   * Type of allowlist entry: 'email' for specific addresses, 'domain' for domain wildcards
   */
  entry_type: 'email' | 'domain';
  id: string;
  system_domain_id?: string | null;
  /**
   * The email address or domain to allowlist (e.g., 'user@example.com' or 'example.com')
   */
  value: string;
}
/**
 * Original schema `MagicLinkAllowlistEntrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-MagicLinkAllowlistEntrySchema}
 */
export interface AssetsMagicLinkAllowlistEntrySchemaWithId {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  /**
   * Type of allowlist entry: 'email' for specific addresses, 'domain' for domain wildcards
   */
  entry_type: 'email' | 'domain';
  id: string;
  system_domain_id?: string;
  /**
   * The email address or domain to allowlist (e.g., 'user@example.com' or 'example.com')
   */
  value: string;
}
/**
 * Original schema `ShareTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareTokenSchema}
 */
export interface AssetsShareTokenSchemaNullable {
  app_id: string;
  /**
   * DRM information for the share token, if applicable
   */
  drm: 'none' | 'standard';
  email: string;
  expires: string;
  is_internal_user: boolean;
  object_id: string;
  object_type: string;
  roles: string[];
  share_id: string;
  share_session_id?: string | null;
  share_user_id: string;
  system_domain_id: string;
  token: string;
  user_id: string;
  /**
   * Watermark information for the share token, if applicable
   */
  watermark: 'none' | 'standard';
}
/**
 * Original schema `SyncSessionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SyncSessionSchema}
 */
export interface AssetsSyncSessionSchemaWithId {
  current_dc_url?: string;
  date_created?: string;
  date_modified?: string;
  dc_url?: string;
  id: string;
  node?: string;
}
/**
 * Original schema `SyncSessionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SyncSessionSchema}
 */
export interface AssetsSyncSessionSchemaWithIdNullable {
  current_dc_url?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  dc_url?: string | null;
  id: string;
  node?: string | null;
}
/**
 * Original schema `ApprovalsBySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalsBySchema}
 */
export interface AssetsApprovalsBySchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AssetsApprovalBySchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_after?: unknown[];
  total: number;
}
/**
 * Original schema `ApprovalBySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ApprovalBySchema}
 */
export interface AssetsApprovalBySchemaNullable {
  change_date?: string | null;
  external?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  status?: ('N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED') | null;
  user?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `SharesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-SharesSchema}
 */
export interface AssetsSharesSchemaWithId {
  objects: AssetsShareSchemaWithIdNullable[];
}
/**
 * Original schema `ShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareSchema}
 */
export interface AssetsShareSchemaWithIdNullable {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean | null;
  allow_download: boolean;
  allow_download_proxy?: boolean | null;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean | null;
  allow_user_search_for_mentions?: boolean | null;
  allow_view_transcriptions?: boolean | null;
  allow_view_versions?: boolean | null;
  automatic_approval_share?: boolean | null;
  date_created?: string | null;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string | null;
  has_password?: boolean | null;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id: string | null;
  object_type: ('assets' | 'collections' | 'playlists' | 'portals') | null;
  owner_id?: string | null;
  population_status?: ('POPULATING' | 'FINISHED') | null;
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string | null;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareURLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareURLSchema}
 */
export interface AssetsShareURLSchemaWithId {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage_id?: string | null;
  url?: string;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `GetShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-GetShareSchema}
 */
export interface AssetsGetShareSchemaWithId {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  automatic_approval_share?: boolean;
  date_created?: string;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string;
  has_password?: boolean;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string;
  object_type?: string;
  owner_id?: string;
  population_status?: 'POPULATING' | 'FINISHED';
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string;
  title?: string | null;
  upload_storage?: AssetsUploadStorage;
  upload_storage_id?: string | null;
  upload_storage_presign_md5_checksum?: boolean;
  url?: string | null;
  users?: AssetsShareUser[];
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `GetShareSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-GetShareSchema}
 */
export interface AssetsGetShareSchemaWithIdNullable {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean | null;
  allow_download: boolean;
  allow_download_proxy?: boolean | null;
  allow_setting_approve_status: boolean;
  allow_sync?: boolean | null;
  allow_upload?: boolean | null;
  allow_user_search_for_mentions?: boolean | null;
  allow_view_transcriptions?: boolean | null;
  allow_view_versions?: boolean | null;
  automatic_approval_share?: boolean | null;
  date_created?: string | null;
  /**
   * DRM settings for the share
   */
  drm?: ('none' | 'standard') | null;
  expires?: string | null;
  has_password?: boolean | null;
  id: string;
  is_approval?: boolean | null;
  message?: string | null;
  metadata_views?: string[] | null;
  object_id?: string | null;
  object_type?: string | null;
  owner_id?: string | null;
  population_status?: ('POPULATING' | 'FINISHED') | null;
  /**
   * Project ID if the share is created from a project
   */
  project_id?: string | null;
  review_experience_public_beta?: boolean | null;
  show_existing_comments?: boolean | null;
  show_watermark?: boolean | null;
  system_domain_id?: string | null;
  title?: string | null;
  upload_storage?: AssetsUploadStorage | null;
  upload_storage_id?: string | null;
  upload_storage_presign_md5_checksum?: boolean | null;
  url?: string | null;
  users?: AssetsShareUser[] | null;
  /**
   * Watermark settings for the share
   */
  watermark?: ('none' | 'standard') | null;
}
/**
 * Original schema `ShareUsersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUsersSchema}
 */
export interface AssetsShareUsersSchemaWithId {
  objects: AssetsShareUserSchemaWithIdNullable[];
}
/**
 * Original schema `ShareUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUserSchema}
 */
export interface AssetsShareUserSchemaWithIdNullable {
  access_count?: number | null;
  download_count?: number | null;
  email: string;
  first_name?: string | null;
  id: string;
  internal_user_id?: string | null;
  last_access_date?: string | null;
  last_name?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  password?: string | null;
  photo?: string | null;
  photo_big?: string | null;
  photo_small?: string | null;
  share_id?: string | null;
}
/**
 * Original schema `ShareUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#model-ShareUserSchema}
 */
export interface AssetsShareUserSchemaWithId {
  access_count?: number;
  download_count?: number;
  email: string;
  first_name?: string;
  id: string;
  internal_user_id?: string;
  last_access_date?: string;
  last_name?: string;
  object_id?: string;
  object_type?: string;
  password?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  share_id?: string;
}

/**
 * `POST /v1/approvals/bulk/`
 *
 * Create a job for bulk request & set approval
 *
 * Required roles:
 *  - can_write_approval_status_in_bulk
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_approvals_bulk_}
 */
export const httpPostApprovalsBulk = (
  body: AssetsBulkSetApprovalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostApprovalsBulk,
  method: httpMethod.post,
  url: '/API/assets/v1/approvals/bulk/',

  body,
  headers,
});

/**
 * `POST /v1/approvals/bulk_remove/`
 *
 * Create a job for bulk approval status removal
 *
 * Required roles:
 *  - can_write_approval_status_in_bulk
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_approvals_bulk_remove_}
 */
export const httpPostApprovalsBulkRemove = (
  body: AssetsBulkRemoveApprovalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostApprovalsBulkRemove,
  method: httpMethod.post,
  url: '/API/assets/v1/approvals/bulk_remove/',

  body,
  headers,
});

export interface AssetsHttpGetAssetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * filter by field_name
   */
  field_name?: string;
  /**
   * A user UUID who has favorited the assets
   */
  favoured_by?: string;
  /**
   * A comma separated list of asset types to filter
   */
  types?: string;
}

/**
 * `GET /v1/assets/`
 *
 * Get list of assets
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns a list of asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets_}
 */
export const httpGetAssets = (
  query?: AssetsHttpGetAssetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssets,
  method: httpMethod.get,
  url: '/API/assets/v1/assets/',

  query,
  headers,
});

export type AssetsBulkAssetEditSchemaPartial =
  Partial<AssetsBulkAssetEditSchema>;

/**
 * `PATCH /v1/assets/`
 *
 * Bulk update assets
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 202 - Bulk assets update scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets_}
 */
export const httpPatchAssets = (
  body: AssetsBulkAssetEditSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchAssets,
  method: httpMethod.patch,
  url: '/API/assets/v1/assets/',

  body,
  headers,
});

export interface AssetsHttpPostAssetsQuery {
  /**
   * Adds default ACLs to an asset
   */
  apply_default_acls?: boolean;
  /**
   * Adds containing collection's ACLs to an asset
   */
  apply_collection_acls?: boolean;
  /**
   * Adds the asset to the collection specified in the body
   */
  assign_to_collection?: boolean;
  /**
   * If the asset is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
  /**
   * Adds template ACLs to the created asset
   */
  apply_acl_template_id?: string;
}

/**
 * `POST /v1/assets/`
 *
 * Create a new asset
 *
 * Required roles:
 *  - can_create_assets
 *
 * Responses
 * - 201 - Returns a created asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 *
 * Response {@link AssetsAssetSchemaTypedWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets_}
 */
export const httpPostAssets = (
  body: AssetsAssetCreateSchemaTyped,
  query?: AssetsHttpPostAssetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssets,
  method: httpMethod.post,
  url: '/API/assets/v1/assets/',

  body,
  query,
  headers,
});

/**
 * `PUT /v1/assets/`
 *
 * Bulk update assets
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 202 - Bulk assets update scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets_}
 */
export const httpPutAssets = (
  body: AssetsBulkAssetEditSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssets,
  method: httpMethod.put,
  url: '/API/assets/v1/assets/',

  body,
  headers,
});

export interface AssetsHttpGetAssetsRecentQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A JSON-encoded list of sort values from the previous page's last hit. The page parameter is ignored when `search_after` is provided.
   */
  search_after?: string;
}

/**
 * `GET /v1/assets/recent/`
 *
 * Get list of recently viewed assets
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns a list of recently viewed assets
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsRecentAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets_recent_}
 */
export const httpGetAssetsRecent = (
  query?: AssetsHttpGetAssetsRecentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsRecent,
  method: httpMethod.get,
  url: '/API/assets/v1/assets/recent/',

  query,
  headers,
});

/**
 * `POST /v1/assets/reindex/`
 *
 * Trigger reindexing of all assets
 *
 * Required roles:
 *  - can_reindex_assets
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets_reindex_}
 */
export const httpPostAssetsReindex = (
  body: AssetsReindexAllAssetsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsReindex,
  method: httpMethod.post,
  url: '/API/assets/v1/assets/reindex/',

  body,
  headers,
});

/**
 * `GET /v1/assets/relation_types/`
 *
 * Create a new asset relation type
 *
 * Required roles:
 *  - can_read_asset_relations
 *
 * Responses
 * - 200 - Returns a relation type
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationTypesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets_relation_types_}
 */
export const httpGetAssetsRelationTypes = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpGetAssetsRelationTypes,
  method: httpMethod.get,
  url: '/API/assets/v1/assets/relation_types/',

  headers,
});

/**
 * `POST /v1/assets/relation_types/`
 *
 * Create a new asset relation type
 *
 * Required roles:
 *  - can_write_asset_relation_types
 *
 * Responses
 * - 201 - Returns a created relation type
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationTypeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets_relation_types_}
 */
export const httpPostAssetsRelationTypes = (
  body: AssetsRelationTypeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsRelationTypes,
  method: httpMethod.post,
  url: '/API/assets/v1/assets/relation_types/',

  body,
  headers,
});

/**
 * `DELETE /v1/assets/relation_types/{relation_type}/`
 *
 * Delete an asset relation type
 *
 * Required roles:
 *  - can_delete_asset_relation_types
 *
 * Responses
 * - 204 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets_relation_types__relation_type__}
 */
export const httpDeleteAssetsRelationTypesByRelationType = (
  relationType: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsRelationTypesByRelationType,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/relation_types/${encodeURIComponent(relationType)}/`,
  params: { relationType },
  headers,
});

/**
 * `GET /v1/assets/relation_types/{relation_type}/`
 *
 * Get a relation type
 *
 * Required roles:
 *  - can_read_asset_relations
 *
 * Responses
 * - 200 - Returns a created relation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationTypeSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets_relation_types__relation_type__}
 */
export const httpGetAssetsRelationTypesByRelationType = (
  relationType: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsRelationTypesByRelationType,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/relation_types/${encodeURIComponent(relationType)}/`,
  params: { relationType },
  headers,
});

export type AssetsRelationTypeSchemaPartial = Partial<AssetsRelationTypeSchema>;

/**
 * `PATCH /v1/assets/relation_types/{relation_type}/`
 *
 * Update an asset relation type
 *
 * Required roles:
 *  - can_write_asset_relation_types
 *
 * Responses
 * - 200 - Update successful
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationTypeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets_relation_types__relation_type__}
 */
export const httpPatchAssetsRelationTypesByRelationType = (
  relationType: string,
  body: AssetsRelationTypeSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchAssetsRelationTypesByRelationType,
  method: httpMethod.patch,
  url: `/API/assets/v1/assets/relation_types/${encodeURIComponent(relationType)}/`,
  params: { relationType },
  body,
  headers,
});

/**
 * `PUT /v1/assets/relation_types/{relation_type}/`
 *
 * Update an asset relation type
 *
 * Required roles:
 *  - can_write_asset_relation_types
 *
 * Responses
 * - 200 - Update successful
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationTypeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets_relation_types__relation_type__}
 */
export const httpPutAssetsRelationTypesByRelationType = (
  relationType: string,
  body: AssetsRelationTypeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsRelationTypesByRelationType,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/relation_types/${encodeURIComponent(relationType)}/`,
  params: { relationType },
  body,
  headers,
});

/**
 * `POST /v1/assets/segments/reindex/`
 *
 * Trigger reindexing of all segments
 *
 * Required roles:
 *  - can_reindex_segments
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets_segments_reindex_}
 */
export const httpPostAssetsSegmentsReindex = (
  body: AssetsReindexAllSegmentsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsSegmentsReindex,
  method: httpMethod.post,
  url: '/API/assets/v1/assets/segments/reindex/',

  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/`
 *
 * Delete a particular asset by id
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__}
 */
export const httpDeleteAssetsByAssetId = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetId,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdQuery {
  /**
   * include collection membership
   */
  include_collections?: boolean;
  /**
   * include info about the users who have interacted with this asset
   */
  include_users?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/`
 *
 * Returns a particular asset by id
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns an asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetSchemaTypedWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__}
 */
export const httpGetAssetsByAssetId = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetId,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  query,
  headers,
});

export type AssetsAssetSchemaTypedPartial = Partial<AssetsAssetSchemaTyped>;

export interface AssetsHttpPatchAssetsByAssetIdQuery {
  /**
   * If the asset is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
}

/**
 * `PATCH /v1/assets/{asset_id}/`
 *
 * Update asset
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetSchemaTyped}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets__asset_id__}
 */
export const httpPatchAssetsByAssetId = (
  assetId: string,
  body: AssetsAssetSchemaTypedPartial,
  query?: AssetsHttpPatchAssetsByAssetIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchAssetsByAssetId,
  method: httpMethod.patch,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutAssetsByAssetIdQuery {
  /**
   * If the asset is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
}

/**
 * `PUT /v1/assets/{asset_id}/`
 *
 * Update asset
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetSchemaTyped}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__}
 */
export const httpPutAssetsByAssetId = (
  assetId: string,
  body: AssetsAssetSchemaTyped,
  query?: AssetsHttpPutAssetsByAssetIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetId,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  body,
  query,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdHistoryQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * A comma separated list of fieldnames with order For example - first_name,eq,Vlad;last_name,eq,Gudkov
   */
  filter?: string;
}

/**
 * `GET /v1/assets/{asset_id}/history/`
 *
 * Get list of history entities for asset
 *
 * Required roles:
 *  - can_read_assets_history
 *
 * Responses
 * - 200 - Returns a list of asset history entities
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsAssetHistoryEntitiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__history_}
 */
export const httpGetAssetsByAssetIdHistory = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdHistoryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdHistory,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/history/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/history/`
 *
 * Create an asset history entity
 *
 * Required roles:
 *  - can_write_assets_history
 *
 * Responses
 * - 201 - Returns a created asset history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset Id doesn't exist
 *
 * Response {@link AssetsAssetHistorySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__history_}
 */
export const httpPostAssetsByAssetIdHistory = (
  assetId: string,
  body: AssetsAssetHistorySchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdHistory,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/history/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/history/{history_entity_id}/`
 *
 * Deletes an asset history entity
 *
 * Required roles:
 *  - can_delete_assets_history
 *
 * Responses
 * - 201 - Returns a created asset history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsAssetHistorySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__history__history_entity_id__}
 */
export const httpDeleteAssetsByAssetIdHistoryByHistoryEntityId = (
  assetId: string,
  historyEntityId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdHistoryByHistoryEntityId,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/history/${encodeURIComponent(historyEntityId)}/`,
  params: { assetId, historyEntityId },
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/history/{history_entity_id}/`
 *
 * Get an asset history entity
 *
 * Required roles:
 *  - can_read_assets_history
 *
 * Responses
 * - 201 - Returns a created asset history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsAssetHistorySchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__history__history_entity_id__}
 */
export const httpGetAssetsByAssetIdHistoryByHistoryEntityId = (
  assetId: string,
  historyEntityId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdHistoryByHistoryEntityId,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/history/${encodeURIComponent(historyEntityId)}/`,
  params: { assetId, historyEntityId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/history/{history_entity_id}/reindex/`
 *
 * Reindex asset history entity
 *
 * Required roles:
 *  - can_reindex_assets_history
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Asset history entity does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__history__history_entity_id__reindex_}
 */
export const httpPostAssetsByAssetIdHistoryByHistoryEntityIdReindex = (
  assetId: string,
  historyEntityId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdHistoryByHistoryEntityIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/history/${encodeURIComponent(historyEntityId)}/reindex/`,
  params: { assetId, historyEntityId },
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/purge/`
 *
 * Purges a particular asset by id immediately
 *
 * Required roles:
 *  - can_purge_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__purge_}
 */
export const httpDeleteAssetsByAssetIdPurge = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdPurge,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/purge/`,
  params: { assetId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/reindex/`
 *
 * Reindex asset
 *
 * Required roles:
 *  - can_reindex_assets
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__reindex_}
 */
export const httpPostAssetsByAssetIdReindex = (
  assetId: string,
  body: AssetsReindexAssetSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/reindex/`,
  params: { assetId },
  body,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdRelationsQuery {
  /**
   * Also show assets from recycle bin in relations
   */
  include_deleted?: boolean;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * A JSON-encoded list of sort values from the previous page's last hit. The page parameter is ignored when `search_after` is provided.
   */
  search_after?: string;
}

/**
 * `GET /v1/assets/{asset_id}/relations/`
 *
 * Returns an assets relations
 *
 * Required roles:
 *  - can_read_asset_relations
 *
 * Responses
 * - 200 - Returns a list of assets
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__relations_}
 */
export const httpGetAssetsByAssetIdRelations = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdRelationsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdRelations,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/relations/`
 *
 * Create a new asset relation
 *
 * Required roles:
 *  - can_create_asset_relations
 *
 * Responses
 * - 200 - Returns an existing relation
 * - 201 - Returns a created relation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__relations_}
 */
export const httpPostAssetsByAssetIdRelations = (
  assetId: string,
  body: AssetsRelationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdRelations,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/`,
  params: { assetId },
  body,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdRelationsByRelationTypeQuery {
  /**
   * Also show assets from recycle bin in relations
   */
  include_deleted?: boolean;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A JSON-encoded list of sort values from the previous page's last hit. The page parameter is ignored when `search_after` is provided.
   */
  search_after?: string;
}

/**
 * `GET /v1/assets/{asset_id}/relations/{relation_type}/`
 *
 * Returns assets that has a relation to this asset
 *
 * Required roles:
 *  - can_read_asset_relations
 *
 * Responses
 * - 200 - Returns a list of assets
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__relations__relation_type__}
 */
export const httpGetAssetsByAssetIdRelationsByRelationType = (
  assetId: string,
  relationType: string,
  query?: AssetsHttpGetAssetsByAssetIdRelationsByRelationTypeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdRelationsByRelationType,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/${encodeURIComponent(relationType)}/`,
  params: { assetId, relationType },
  query,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/relations/{relation_type}/{related_to_asset_id}/`
 *
 * Delete a particular asset by id
 *
 * Required roles:
 *  - can_delete_asset_relations
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__relations__relation_type___related_to_asset_id__}
 */
export const httpDeleteAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId =
  (
    assetId: string,
    relationType: string,
    relatedToAssetId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpDeleteAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId,
    method: httpMethod.delete,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/${encodeURIComponent(relationType)}/${encodeURIComponent(relatedToAssetId)}/`,
    params: { assetId, relationType, relatedToAssetId },
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/relations/{relation_type}/{related_to_asset_id}/`
 *
 * Create a new asset relation
 *
 * Required roles:
 *  - can_create_asset_relations
 *
 * Responses
 * - 200 - Returns an existing relation
 * - 201 - Returns a created relation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__relations__relation_type___related_to_asset_id__}
 */
export const httpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId =
  (
    assetId: string,
    relationType: string,
    relatedToAssetId: string,
    body: AssetsRelationSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetId,
    method: httpMethod.post,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/${encodeURIComponent(relationType)}/${encodeURIComponent(relatedToAssetId)}/`,
    params: { assetId, relationType, relatedToAssetId },
    body,
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/relations/{relation_type}/{related_to_asset_id}/reverse/`
 *
 * Reverse a particular asset's relation
 *
 * Required roles:
 *  - can_create_asset_relations
 *
 * Responses
 * - 200 - Update successful
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsRelationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__relations__relation_type___related_to_asset_id__reverse_}
 */
export const httpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetIdReverse =
  (
    assetId: string,
    relationType: string,
    relatedToAssetId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPostAssetsByAssetIdRelationsByRelationTypeByRelatedToAssetIdReverse,
    method: httpMethod.post,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/relations/${encodeURIComponent(relationType)}/${encodeURIComponent(relatedToAssetId)}/reverse/`,
    params: { assetId, relationType, relatedToAssetId },
    headers,
  });

/**
 * `PUT /v1/assets/{asset_id}/restore/`
 *
 * Restore deleted asset by id
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__restore_}
 */
export const httpPutAssetsByAssetIdRestore = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdRestore,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/restore/`,
  params: { assetId },
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/search_document/`
 *
 * Update metadata for asset
 *
 * Required roles:
 *  - can_reindex_assets
 *
 * Responses
 * - 204 - Asset metadata updated
 * - 400 - No metadata supplied
 * - 401 - Token is invalid
 * - 404 - Asset does not exist in search index
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__search_document_}
 * @deprecated
 */
export const httpPutAssetsByAssetIdSearchDocument = (
  assetId: string,
  body: AssetsAssetElasticSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdSearchDocument,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/search_document/`,
  params: { assetId },
  body,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdSegmentsQuery {
  /**
   * Sort on field (Comma separated)
   */
  sort?: string;
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Only include fields (Comma separated)
   */
  includes?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   *
   */
  scroll_id?: string;
  /**
   * Filter segments by transcription_id
   */
  transcription_id?: string;
  /**
   * Filter segments by version_id
   */
  version_id?: string;
  /**
   * Filter segments by segment_type
   */
  segment_type?: string;
  /**
   * Filter segments by segment_color
   */
  segment_color?: string;
  /**
   * Filter segments by time_start_milliseconds
   */
  time_start_milliseconds?: number;
  /**
   * Filter segments by time_end_milliseconds
   */
  time_end_milliseconds?: number;
  /**
   * Get segments with start time greater than or equal to time_start_milliseconds__gte
   *
   */
  time_start_milliseconds__gte?: number;
  /**
   * Get segments with end time less than or equal to time_end_milliseconds__lte
   */
  time_end_milliseconds__lte?: number;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
  /**
   * Filter segments by person_id
   */
  person_id?: string;
  /**
   * Filter segments by share_id
   */
  share_id?: string;
  /**
   * Filter segments by project_id
   */
  project_id?: string;
  /**
   * Include segment's authors info
   */
  include_users?: boolean;
  /**
   * If true return asset's segments for all versions
   */
  include_all_versions?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/segments/`
 *
 * List of segments
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link AssetsSegmentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments_}
 */
export const httpGetAssetsByAssetIdSegments = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegments,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/`,
  params: { assetId },
  query,
  headers,
});

export interface AssetsHttpPostAssetsByAssetIdSegmentsHeader
  extends IconikApiHeaders {
  /**
   * This header is used for shares by URL to identify user. Only valid emails are allowed.
   */
  'Share-User-Email'?: string;
}

/**
 * `POST /v1/assets/{asset_id}/segments/`
 *
 * Create a new segment
 *
 * <br/>Comments are segments with `segment_type` set to `COMMENT`.<br/>A comment can be created directly with status `AWAITED`. When `status` is not<br/>specified the segment is created with status `ACTIVE`.<br/>An `AWAITED` comment is not posted yet: nobody is notified about it, and segment<br/>listings leave it out unless they filter on `status`, until it is updated to `ACTIVE`.<br/><br/>On a subclip, time-based metadata segments (TAG, GENERIC, TRANSCRIPTION, SHOT,<br/>SEMANTIC_TRANSCRIPTION) are created on the subclip's original asset, under the<br/>version the subclip was cut from. A `version_id`, if given, must be that version or<br/>one of the subclip's own; any other is rejected with 400.<br/>Comments are segments with `segment_type` set to `COMMENT`.<br/>A comment can be created directly with status `AWAITED`. When `status` is not<br/>specified the segment is created with status `ACTIVE`.<br/>An `AWAITED` comment is not posted yet: nobody is notified about it, and segment<br/>listings leave it out unless they filter on `status`, until it is updated to `ACTIVE`.<br/><br/>On a subclip, time-based metadata segments (TAG, GENERIC, TRANSCRIPTION, SHOT,<br/>SEMANTIC_TRANSCRIPTION) are created on the subclip's original asset, under the<br/>version the subclip was cut from. A `version_id`, if given, must be that version or<br/>one of the subclip's own; any other is rejected with 400.
 * Required roles:
 *  - can_create_segments
 *
 * Responses
 * - 201 - Returns a created segment
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSegmentSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__segments_}
 */
export const httpPostAssetsByAssetIdSegments = (
  assetId: string,
  body: AssetsSegmentSchema,
  headers?: AssetsHttpPostAssetsByAssetIdSegmentsHeader,
) => ({
  id: AssetsHttpPostAssetsByAssetIdSegments,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/`,
  params: { assetId },
  body,
  headers,
});

export interface AssetsHttpDeleteAssetsByAssetIdSegmentsBulkQuery {
  /**
   * If false, delete segments asynchronously
   */
  immediately?: boolean;
  /**
   * If false, reindex
   */
  ignore_reindexing?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/segments/bulk/`
 *
 * Delete segments with either ids or by type
 *
 * Required roles:
 *  - can_delete_segments
 *
 * Responses
 * - 204 - Without body
 * - 400 - Segment ids or segment type not provided correctly
 * - 401 - Token is invalid
 * - 404 - No segments found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__segments_bulk_}
 */
export const httpDeleteAssetsByAssetIdSegmentsBulk = (
  assetId: string,
  body: AssetsDeleteSegmentsSchema,
  query?: AssetsHttpDeleteAssetsByAssetIdSegmentsBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdSegmentsBulk,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/bulk/`,
  params: { assetId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/segments/bulk/`
 *
 * Create multiple new segments for a single asset
 *
 * <br/>On a subclip, time-based metadata segments (TAG, GENERIC, TRANSCRIPTION, SHOT,<br/>SEMANTIC_TRANSCRIPTION) are created on the subclip's original asset, under the version<br/>the subclip was cut from, as with a single create - and a `version_id` other than that<br/>one or one of the subclip's own is rejected with 400. A batch that mixes those with<br/>other segment types is rejected with 400.<br/>On a subclip, time-based metadata segments (TAG, GENERIC, TRANSCRIPTION, SHOT,<br/>SEMANTIC_TRANSCRIPTION) are created on the subclip's original asset, under the version<br/>the subclip was cut from, as with a single create - and a `version_id` other than that<br/>one or one of the subclip's own is rejected with 400. A batch that mixes those with<br/>other segment types is rejected with 400.
 * Required roles:
 *  - can_create_segments
 *
 * Responses
 * - 201 - Returns ID and status of a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__segments_bulk_}
 */
export const httpPostAssetsByAssetIdSegmentsBulk = (
  assetId: string,
  body: AssetsBulkCreateSegmentsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdSegmentsBulk,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/bulk/`,
  params: { assetId },
  body,
  headers,
});

export interface AssetsHttpPutAssetsByAssetIdSegmentsBulkQuery {
  /**
   * If the segment is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
}

/**
 * `PUT /v1/assets/{asset_id}/segments/bulk/`
 *
 * Edit multiple asset segments
 *
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 201 - Returns ID and status of a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__segments_bulk_}
 */
export const httpPutAssetsByAssetIdSegmentsBulk = (
  assetId: string,
  body: AssetsBulkEditAssetSegmentsSchema,
  query?: AssetsHttpPutAssetsByAssetIdSegmentsBulkQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdSegmentsBulk,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/bulk/`,
  params: { assetId },
  body,
  query,
  headers,
});

/**
 * Returns a list of segments as CSV file
 */
export type AssetsHttpGetAssetsByAssetIdSegmentsCsvResponse = string;

export interface AssetsHttpGetAssetsByAssetIdSegmentsCsvQuery {
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Filter segments by transcription_id
   */
  transcription_id?: string;
  /**
   * Filter segments by version_id
   */
  version_id?: string;
  /**
   * Filter segments by segment_type
   */
  segment_type?: string;
  /**
   * Filter segments by segment_color
   */
  segment_color?: string;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/csv/`
 *
 * List of segments as CSV file
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments as CSV file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link AssetsHttpGetAssetsByAssetIdSegmentsCsvResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments_csv_}
 */
export const httpGetAssetsByAssetIdSegmentsCsv = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsCsvQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsCsv,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/csv/`,
  params: { assetId },
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/segments/reindex/`
 *
 * Reindex assets segments
 *
 * Required roles:
 *  - can_reindex_segments
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__segments_reindex_}
 */
export const httpPostAssetsByAssetIdSegmentsReindex = (
  assetId: string,
  body: AssetsReindexSegmentSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdSegmentsReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/reindex/`,
  params: { assetId },
  body,
  headers,
});

/**
 * Returns a list of segments as SRT file
 */
export type AssetsHttpGetAssetsByAssetIdSegmentsSrtResponse = string;

export interface AssetsHttpGetAssetsByAssetIdSegmentsSrtQuery {
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Filter segments by transcription_id
   */
  transcription_id?: string;
  /**
   * Filter segments by version_id
   */
  version_id?: string;
  /**
   * Filter segments by segment_type
   */
  segment_type?: string;
  /**
   * Filter segments by segment_color
   */
  segment_color?: string;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
  /**
   * Limit the number of words per subtitle line
   */
  words_per_line?: number;
}

/**
 * `GET /v1/assets/{asset_id}/segments/srt/`
 *
 * List of segments as SRT file
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments as SRT file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link AssetsHttpGetAssetsByAssetIdSegmentsSrtResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments_srt_}
 */
export const httpGetAssetsByAssetIdSegmentsSrt = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsSrtQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsSrt,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/srt/`,
  params: { assetId },
  query,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdSegmentsTextQuery {
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Filter segments by transcription_id
   */
  transcription_id?: string;
  /**
   * Filter segments by version_id
   */
  version_id?: string;
  /**
   * Filter segments by segment_type
   */
  segment_type?: string;
  /**
   * Filter segments by segment_color
   */
  segment_color?: string;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/text/`
 *
 * List of segments as text file
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments as text file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments_text_}
 */
export const httpGetAssetsByAssetIdSegmentsText = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsTextQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsText,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/text/`,
  params: { assetId },
  query,
  headers,
});

/**
 * Returns a list of segments as VTT file
 */
export type AssetsHttpGetAssetsByAssetIdSegmentsVttResponse = string;

export interface AssetsHttpGetAssetsByAssetIdSegmentsVttQuery {
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Filter segments by transcription_id
   */
  transcription_id?: string;
  /**
   * Filter segments by version_id
   */
  version_id?: string;
  /**
   * Filter segments by segment_type
   */
  segment_type?: string;
  /**
   * Filter segments by segment_color
   */
  segment_color?: string;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
  /**
   * Limit the number of words per subtitle line
   */
  words_per_line?: number;
}

/**
 * `GET /v1/assets/{asset_id}/segments/vtt/`
 *
 * List of segments as WebVTT file
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments as VTT file
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link AssetsHttpGetAssetsByAssetIdSegmentsVttResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments_vtt_}
 */
export const httpGetAssetsByAssetIdSegmentsVtt = (
  assetId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsVttQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsVtt,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/vtt/`,
  params: { assetId },
  query,
  headers,
});

export interface AssetsHttpDeleteAssetsByAssetIdSegmentsBySegmentIdQuery {
  soft_delete?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/segments/{segment_id}/`
 *
 * Delete a particular segment from an asset by id
 *
 * Required roles:
 *  - can_delete_segments
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 404 - Segment not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__segments__segment_id__}
 */
export const httpDeleteAssetsByAssetIdSegmentsBySegmentId = (
  assetId: string,
  segmentId: string,
  query?: AssetsHttpDeleteAssetsByAssetIdSegmentsBySegmentIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdSegmentsBySegmentId,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/`,
  params: { assetId, segmentId },
  query,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdSegmentsBySegmentIdQuery {
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   *
   */
  scroll_id?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/{segment_id}/`
 *
 * Get a segment by ID
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a segment
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Segment does not exist
 *
 * Response {@link AssetsSegmentSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments__segment_id__}
 */
export const httpGetAssetsByAssetIdSegmentsBySegmentId = (
  assetId: string,
  segmentId: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsBySegmentIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsBySegmentId,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/`,
  params: { assetId, segmentId },
  query,
  headers,
});

export type AssetsEditSegmentSchemaPartial = Partial<AssetsEditSegmentSchema>;

export interface AssetsHttpPatchAssetsByAssetIdSegmentsBySegmentIdQuery {
  /**
   * If the segment is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
  index_immediately?: string;
}

/**
 * `PATCH /v1/assets/{asset_id}/segments/{segment_id}/`
 *
 * Update segment
 *
 * <br/>`status` can only be `AWAITED` for a segment that was created `AWAITED`: changing<br/>any other segment to `AWAITED` is rejected with 400.<br/><br/>`has_attachments` is iconik_files' to set, when a comment<br/>gets its first attachment (true) or loses its last one (false).<br/>iconik_files reports its other attachment changes as a reindex of them.<br/>`status` can only be `AWAITED` for a segment that was created `AWAITED`: changing<br/>any other segment to `AWAITED` is rejected with 400.<br/><br/>`has_attachments` is iconik_files' to set, when a comment<br/>gets its first attachment (true) or loses its last one (false).<br/>iconik_files reports its other attachment changes as a reindex of them.
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 200 - Returns an updated segment
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Segment does not exist
 *
 * Response {@link AssetsSegmentSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets__asset_id__segments__segment_id__}
 */
export const httpPatchAssetsByAssetIdSegmentsBySegmentId = (
  assetId: string,
  segmentId: string,
  body: AssetsEditSegmentSchemaPartial,
  query?: AssetsHttpPatchAssetsByAssetIdSegmentsBySegmentIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchAssetsByAssetIdSegmentsBySegmentId,
  method: httpMethod.patch,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/`,
  params: { assetId, segmentId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutAssetsByAssetIdSegmentsBySegmentIdQuery {
  /**
   * If the segment is a subclip, generate keyframes for it
   */
  generate_subclip_keyframes?: boolean;
  index_immediately?: string;
}

/**
 * `PUT /v1/assets/{asset_id}/segments/{segment_id}/`
 *
 * Update segment
 *
 * <br/>`status` can only be `AWAITED` for a segment that was created `AWAITED`: changing<br/>any other segment to `AWAITED` is rejected with 400.<br/><br/>`has_attachments` is iconik_files' to set, when a comment<br/>gets its first attachment (true) or loses its last one (false).<br/>iconik_files reports its other attachment changes as a reindex of them.<br/>`status` can only be `AWAITED` for a segment that was created `AWAITED`: changing<br/>any other segment to `AWAITED` is rejected with 400.<br/><br/>`has_attachments` is iconik_files' to set, when a comment<br/>gets its first attachment (true) or loses its last one (false).<br/>iconik_files reports its other attachment changes as a reindex of them.
 * Required roles:
 *  - can_write_segments
 *
 * Responses
 * - 200 - Returns an updated segment
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Segment does not exist
 *
 * Response {@link AssetsSegmentSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__segments__segment_id__}
 */
export const httpPutAssetsByAssetIdSegmentsBySegmentId = (
  assetId: string,
  segmentId: string,
  body: AssetsEditSegmentSchema,
  query?: AssetsHttpPutAssetsByAssetIdSegmentsBySegmentIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdSegmentsBySegmentId,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/`,
  params: { assetId, segmentId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/segments/{segment_id}/reindex/`
 *
 * Reindex assets segment
 *
 * Required roles:
 *  - can_reindex_segments
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Asset segment does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__segments__segment_id__reindex_}
 */
export const httpPostAssetsByAssetIdSegmentsBySegmentIdReindex = (
  assetId: string,
  segmentId: string,
  body: AssetsReindexSegmentSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdSegmentsBySegmentIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentId)}/reindex/`,
  params: { assetId, segmentId },
  body,
  headers,
});

export interface AssetsHttpGetAssetsByAssetIdSegmentsBySegmentTypeQuery {
  /**
   * Sort on field (Comma separated)
   */
  sort?: string;
  /**
   * Only include these segments (Comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * Only include fields (Comma separated)
   */
  includes?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   *
   */
  scroll_id?: string;
  /**
   * Filter segments by time_start_milliseconds
   */
  time_start_milliseconds?: number;
  /**
   * Filter segments by time_end_milliseconds
   */
  time_end_milliseconds?: number;
  /**
   * Get segments with start time greater than or equal to time_start_milliseconds__gte
   *
   */
  time_start_milliseconds__gte?: number;
  /**
   * Get segments with end time less than or equal to time_end_milliseconds__lte
   */
  time_end_milliseconds__lte?: number;
  /**
   * Filter segments by status. AWAITED segments are hidden unless a status filter is given
   *
   */
  status?: string;
}

/**
 * `GET /v1/assets/{asset_id}/segments/{segment_type}/`
 *
 * List of segments
 *
 * Required roles:
 *  - can_read_segments
 *
 * Responses
 * - 200 - Returns a list of segments
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link AssetsSegmentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__segments__segment_type__}
 */
export const httpGetAssetsByAssetIdSegmentsBySegmentType = (
  assetId: string,
  segmentType: string,
  query?: AssetsHttpGetAssetsByAssetIdSegmentsBySegmentTypeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSegmentsBySegmentType,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/segments/${encodeURIComponent(segmentType)}/`,
  params: { assetId, segmentType },
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/shares/all/`
 *
 * Get list of asset's shares including all direct and indirect shares that were made by sharing
 *
 * collections and playlists that contain the assetcollections and playlists that contain the asset
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a list of shares
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSharesElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__shares_all_}
 */
export const httpGetAssetsByAssetIdSharesAll = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetAssetsByAssetIdSharesAll,
  method: httpMethod.get,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/shares/all/`,
  params: { assetId },
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/uploads/`
 *
 * Delete a particular asset by id on failed uplaod
 *
 * Required roles:
 *  - can_create_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__uploads_}
 */
export const httpDeleteAssetsByAssetIdUploads = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdUploads,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/uploads/`,
  params: { assetId },
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/versions/`
 *
 * Add asset version
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetVersionsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__versions_}
 */
export const httpPostAssetsByAssetIdVersions = (
  assetId: string,
  body: AssetsCreateAssetVersionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdVersions,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/`,
  params: { assetId },
  body,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/versions/from/assets/{source_asset_id}/`
 *
 * Create a new asset's version from another asset
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 202 - Returns nothing
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Source or destination asset does not exist
 * - 409 - The asset is being transcoded and cannot be set as a new version
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__versions_from_assets__source_asset_id__}
 */
export const httpPostAssetsByAssetIdVersionsFromAssetsBySourceAssetId = (
  assetId: string,
  sourceAssetId: string,
  body: AssetsCreateAssetVersionFromAssetSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdVersionsFromAssetsBySourceAssetId,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/from/assets/${encodeURIComponent(sourceAssetId)}/`,
  params: { assetId, sourceAssetId },
  body,
  headers,
});

/**
 * `POST /v1/assets/{asset_id}/versions/from/versions/{source_version_id}/`
 *
 * Create a new asset's version from another version
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 202 - Returns version id
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Source or destination asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__versions_from_versions__source_version_id__}
 */
export const httpPostAssetsByAssetIdVersionsFromVersionsBySourceVersionId = (
  assetId: string,
  sourceVersionId: string,
  body: AssetsCreateAssetVersionFromVersionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdVersionsFromVersionsBySourceVersionId,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/from/versions/${encodeURIComponent(sourceVersionId)}/`,
  params: { assetId, sourceVersionId },
  body,
  headers,
});

/**
 * `DELETE /v1/assets/{asset_id}/versions/old/`
 *
 * Delete all asset versions except the latest one
 *
 * Required roles:
 *  - can_delete_versions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__versions_old_}
 */
export const httpDeleteAssetsByAssetIdVersionsOld = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdVersionsOld,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/old/`,
  params: { assetId },
  headers,
});

export interface AssetsHttpDeleteAssetsByAssetIdVersionsByVersionIdQuery {
  /**
   * completely remove the version
   */
  hard_delete?: boolean;
}

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/`
 *
 * Delete a particular asset version by id
 *
 * Required roles:
 *  - can_delete_versions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__versions__version_id__}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionId = (
  assetId: string,
  versionId: string,
  query?: AssetsHttpDeleteAssetsByAssetIdVersionsByVersionIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteAssetsByAssetIdVersionsByVersionId,
  method: httpMethod.delete,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
  params: { assetId, versionId },
  query,
  headers,
});

export type AssetsAssetVersionSchemaPartial = Partial<AssetsAssetVersionSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/versions/{version_id}/`
 *
 * Edit asset version
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetVersionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets__asset_id__versions__version_id__}
 */
export const httpPatchAssetsByAssetIdVersionsByVersionId = (
  assetId: string,
  versionId: string,
  body: AssetsAssetVersionSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchAssetsByAssetIdVersionsByVersionId,
  method: httpMethod.patch,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
  params: { assetId, versionId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/versions/{version_id}/`
 *
 * Edit asset version
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetVersionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__versions__version_id__}
 */
export const httpPutAssetsByAssetIdVersionsByVersionId = (
  assetId: string,
  versionId: string,
  body: AssetsAssetVersionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdVersionsByVersionId,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
  params: { assetId, versionId },
  body,
  headers,
});

/**
 * `PUT /v1/assets/{asset_id}/versions/{version_id}/promote/`
 *
 * Promote a particular asset version to a latest version
 *
 * Required roles:
 *  - can_write_versions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__versions__version_id__promote_}
 */
export const httpPutAssetsByAssetIdVersionsByVersionIdPromote = (
  assetId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutAssetsByAssetIdVersionsByVersionIdPromote,
  method: httpMethod.put,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/promote/`,
  params: { assetId, versionId },
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/transcriptions/properties/`
 *
 * Get a list of transcription properties
 *
 * Required roles:
 *  - can_read_transcriptions
 *
 * Responses
 * - 200 - Returns a list of transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription does not exist
 *
 * Response {@link AssetsAssetTranscriptionsPropertiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__versions__version_id__transcriptions_properties_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties =
  (assetId: string, versionId: string, headers?: IconikApiHeaders) => ({
    id: AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties,
    method: httpMethod.get,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/properties/`,
    params: { assetId, versionId },
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/versions/{version_id}/transcriptions/properties/`
 *
 * Add a new transcription properties
 *
 * Required roles:
 *  - can_write_transcriptions
 *
 * Responses
 * - 200 - Returns transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * Response {@link AssetsAssetTranscriptionPropertiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__versions__version_id__transcriptions_properties_}
 */
export const httpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties =
  (
    assetId: string,
    versionId: string,
    body: AssetsAssetTranscriptionPropertiesSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsProperties,
    method: httpMethod.post,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/properties/`,
    params: { assetId, versionId },
    body,
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/versions/{version_id}/transcriptions/subtitles/`
 *
 * Add a new transcription properties
 *
 * Required roles:
 *  - can_write_transcriptions
 *
 * Responses
 * - 200 - Returns transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * Response {@link AssetsAssetTranscriptionPropertiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__versions__version_id__transcriptions_subtitles_}
 */
export const httpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsSubtitles =
  (
    assetId: string,
    versionId: string,
    body: AssetsAssetTranscriptionFromSubtitleSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPostAssetsByAssetIdVersionsByVersionIdTranscriptionsSubtitles,
    method: httpMethod.post,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/subtitles/`,
    params: { assetId, versionId },
    body,
    headers,
  });

/**
 * `DELETE /v1/assets/{asset_id}/versions/{version_id}/transcriptions/{transcription_id}/properties/`
 *
 * Delete transcription properties by ID
 *
 * Required roles:
 *  - can_delete_transcriptions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_assets__asset_id__versions__version_id__transcriptions__transcription_id__properties_}
 */
export const httpDeleteAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  (
    assetId: string,
    versionId: string,
    transcriptionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpDeleteAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties,
    method: httpMethod.delete,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/${encodeURIComponent(transcriptionId)}/properties/`,
    params: { assetId, versionId, transcriptionId },
    headers,
  });

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/transcriptions/{transcription_id}/properties/`
 *
 * Get a transcription properties by ID
 *
 * Required roles:
 *  - can_read_transcriptions
 *
 * Responses
 * - 200 - Returns a transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * Response {@link AssetsAssetTranscriptionPropertiesSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_assets__asset_id__versions__version_id__transcriptions__transcription_id__properties_}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  (
    assetId: string,
    versionId: string,
    transcriptionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpGetAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties,
    method: httpMethod.get,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/${encodeURIComponent(transcriptionId)}/properties/`,
    params: { assetId, versionId, transcriptionId },
    headers,
  });

export type AssetsAssetTranscriptionPropertiesSchemaPartial =
  Partial<AssetsAssetTranscriptionPropertiesSchema>;

/**
 * `PATCH /v1/assets/{asset_id}/versions/{version_id}/transcriptions/{transcription_id}/properties/`
 *
 * Update transcription properties by ID
 *
 * Required roles:
 *  - can_write_transcriptions
 *
 * Responses
 * - 200 - Returns transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * Response {@link AssetsAssetTranscriptionPropertiesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_assets__asset_id__versions__version_id__transcriptions__transcription_id__properties_}
 */
export const httpPatchAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  (
    assetId: string,
    versionId: string,
    transcriptionId: string,
    body: AssetsAssetTranscriptionPropertiesSchemaPartial,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPatchAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties,
    method: httpMethod.patch,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/${encodeURIComponent(transcriptionId)}/properties/`,
    params: { assetId, versionId, transcriptionId },
    body,
    headers,
  });

/**
 * `PUT /v1/assets/{asset_id}/versions/{version_id}/transcriptions/{transcription_id}/properties/`
 *
 * Update transcription properties by ID
 *
 * Required roles:
 *  - can_write_transcriptions
 *
 * Responses
 * - 200 - Returns transcription properties
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Transcription properties do not exist
 *
 * Response {@link AssetsAssetTranscriptionPropertiesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_assets__asset_id__versions__version_id__transcriptions__transcription_id__properties_}
 */
export const httpPutAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties =
  (
    assetId: string,
    versionId: string,
    transcriptionId: string,
    body: AssetsAssetTranscriptionPropertiesSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPutAssetsByAssetIdVersionsByVersionIdTranscriptionsByTranscriptionIdProperties,
    method: httpMethod.put,
    url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/transcriptions/${encodeURIComponent(transcriptionId)}/properties/`,
    params: { assetId, versionId, transcriptionId },
    body,
    headers,
  });

/**
 * `POST /v1/assets/{asset_id}/views/`
 *
 * Mark asset as viewed
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns an updated asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset does not exist
 *
 * Response {@link AssetsAssetSchemaTypedWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_assets__asset_id__views_}
 */
export const httpPostAssetsByAssetIdViews = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostAssetsByAssetIdViews,
  method: httpMethod.post,
  url: `/API/assets/v1/assets/${encodeURIComponent(assetId)}/views/`,
  params: { assetId },
  headers,
});

export interface AssetsHttpGetCollectionsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;is_root,desc
   */
  sort?: string;
  /**
   * Filter by is_root
   */
  is_root?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * A user UUID who has favorited the collections
   */
  favoured_by?: string;
  /**
   * If false, keyframe data and presigned URLs are omitted from the response
   */
  include_keyframes?: boolean;
}

/**
 * `GET /v1/collections/`
 *
 * Get list of collections
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a list of collections
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCollectionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections_}
 */
export const httpGetCollections = (
  query?: AssetsHttpGetCollectionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollections,
  method: httpMethod.get,
  url: '/API/assets/v1/collections/',

  query,
  headers,
});

export interface AssetsHttpPostCollectionsQuery {
  /**
   * Adds default ACLs to a collection
   */
  apply_default_acls?: boolean;
  /**
   * Adds containing collection's ACLs to a collection
   */
  apply_collection_acls?: boolean;
  /**
   * Restricts ACLS to containing collection's ACLs
   */
  restrict_collection_acls?: boolean;
  /**
   * Adds template ACLs to a collection
   */
  apply_acl_template_id?: string;
}

/**
 * `POST /v1/collections/`
 *
 * Create a new collection
 *
 * Required roles:
 *  - can_create_collections
 *
 * Responses
 * - 201 - Returns a created collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCollectionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections_}
 */
export const httpPostCollections = (
  body: AssetsCollectionInputSchema,
  query?: AssetsHttpPostCollectionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollections,
  method: httpMethod.post,
  url: '/API/assets/v1/collections/',

  body,
  query,
  headers,
});

export interface AssetsHttpGetCollectionsRecentQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A JSON-encoded list of sort values from the previous page's last hit. The page parameter is ignored when `search_after` is provided.
   */
  search_after?: string;
}

/**
 * `GET /v1/collections/recent/`
 *
 * Get list of recently viewed collections
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a list of recently viewed collections
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsRecentCollectionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections_recent_}
 */
export const httpGetCollectionsRecent = (
  query?: AssetsHttpGetCollectionsRecentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsRecent,
  method: httpMethod.get,
  url: '/API/assets/v1/collections/recent/',

  query,
  headers,
});

/**
 * `POST /v1/collections/reindex/`
 *
 * Trigger reindexing of all collections
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections_reindex_}
 */
export const httpPostCollectionsReindex = (
  body: AssetsReindexAllCollectionsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsReindex,
  method: httpMethod.post,
  url: '/API/assets/v1/collections/reindex/',

  body,
  headers,
});

/**
 * `DELETE /v1/collections/{collection_id}/`
 *
 * Delete a particular collection by id
 *
 * Required roles:
 *  - can_delete_collections
 *
 * Responses
 * - 202 - Deletion has been scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_collections__collection_id__}
 */
export const httpDeleteCollectionsByCollectionId = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteCollectionsByCollectionId,
  method: httpMethod.delete,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/`,
  params: { collectionId },
  headers,
});

/**
 * `GET /v1/collections/{collection_id}/`
 *
 * Returns a particular collection by id
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCollectionSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__}
 */
export const httpGetCollectionsByCollectionId = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionId,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/`,
  params: { collectionId },
  headers,
});

export type AssetsCollectionInputSchemaPartial =
  Partial<AssetsCollectionInputSchema>;

export interface AssetsHttpPatchCollectionsByCollectionIdQuery {
  /**
   * Set to 'move' or 'copy'. Ignored if 'parent_id' hasn't changed
   */
  change_parent_mode?: string;
}

/**
 * `PATCH /v1/collections/{collection_id}/`
 *
 * Update collection
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 200 - Returns an updated collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_collections__collection_id__}
 */
export const httpPatchCollectionsByCollectionId = (
  collectionId: string,
  body: AssetsCollectionInputSchemaPartial,
  query?: AssetsHttpPatchCollectionsByCollectionIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchCollectionsByCollectionId,
  method: httpMethod.patch,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/`,
  params: { collectionId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutCollectionsByCollectionIdQuery {
  /**
   * Set to 'move' or 'copy'. Ignored if 'parent_id' hasn't changed
   */
  change_parent_mode?: string;
}

/**
 * `PUT /v1/collections/{collection_id}/`
 *
 * Update collection
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 200 - Returns an updated collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_collections__collection_id__}
 */
export const httpPutCollectionsByCollectionId = (
  collectionId: string,
  body: AssetsCollectionInputSchema,
  query?: AssetsHttpPutCollectionsByCollectionIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutCollectionsByCollectionId,
  method: httpMethod.put,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/`,
  params: { collectionId },
  body,
  query,
  headers,
});

/**
 * `GET /v1/collections/{collection_id}/ancestors/`
 *
 * Returns list of ancestors of a collection
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a collections content
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__ancestors_}
 */
export const httpGetCollectionsByCollectionIdAncestors = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdAncestors,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/ancestors/`,
  params: { collectionId },
  headers,
});

export interface AssetsHttpGetCollectionsByCollectionIdContentInfoQuery {
  /**
   * If false, include all the contents
   */
  only_active?: boolean;
  /**
   * Compute total stats including assets from sub-collections
   */
  include_subcollections?: boolean;
  /**
   * Compute total size only for files with the specified format name (default - ORIGINAL)
   */
  format_name?: string;
  /**
   * Group results by storage_id / storage_method
   */
  by_storage_id?: boolean;
  /**
   * Comma separated list of object types to include in counts.
   */
  types?: boolean;
}

/**
 * `GET /v1/collections/{collection_id}/content/info/`
 *
 * Get aggregated information about collection
 *
 * <br/>The returned information includes count of assets and sub-collections,<br/>total size of all assets (in bytes), total size of all asset proxies<br/>(in bytes) and total duration of video and audio assets (in milliseconds).<br/>The returned information includes count of assets and sub-collections,<br/>total size of all assets (in bytes), total size of all asset proxies<br/>(in bytes) and total duration of video and audio assets (in milliseconds).
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns counts, total size, total proxy size, total duration, and optional grouping
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionContentInfoSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__content_info_}
 */
export const httpGetCollectionsByCollectionIdContentInfo = (
  collectionId: string,
  query?: AssetsHttpGetCollectionsByCollectionIdContentInfoQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdContentInfo,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/content/info/`,
  params: { collectionId },
  query,
  headers,
});

export interface AssetsHttpGetCollectionsByCollectionIdContentsQuery {
  /**
   * Comma separated list of content types. Example - assets,collections
   */
  object_types?: string;
  /**
   * Comma separated list of content ids.
   */
  object_ids?: string;
  external_id?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * A comma separated list of fieldnames with order For example - first_name,eq,Vlad;last_name,eq,Gudkov
   */
  filter?: string;
  /**
   * If false, keyframe data and presigned URLs are omitted from the response
   */
  include_keyframes?: boolean;
}

/**
 * `GET /v1/collections/{collection_id}/contents/`
 *
 * Returns contents of a collection by id
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a collections content
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__contents_}
 */
export const httpGetCollectionsByCollectionIdContents = (
  collectionId: string,
  query?: AssetsHttpGetCollectionsByCollectionIdContentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdContents,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/`,
  params: { collectionId },
  query,
  headers,
});

export interface AssetsHttpPostCollectionsByCollectionIdContentsQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/collections/{collection_id}/contents/`
 *
 * Add an object to a collection
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 201 - Content added
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__contents_}
 */
export const httpPostCollectionsByCollectionIdContents = (
  collectionId: string,
  body: AssetsCollectionContentSchema,
  query?: AssetsHttpPostCollectionsByCollectionIdContentsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdContents,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/`,
  params: { collectionId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/collections/{collection_id}/contents/ordering/custom/`
 *
 * Disable custom ordering for a collection's content
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 200 - Disables custom ordering for a collection's content
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_collections__collection_id__contents_ordering_custom_}
 */
export const httpDeleteCollectionsByCollectionIdContentsOrderingCustom = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteCollectionsByCollectionIdContentsOrderingCustom,
  method: httpMethod.delete,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/ordering/custom/`,
  params: { collectionId },
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/contents/ordering/custom/`
 *
 * Enable custom ordering for a collection's content
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 202 - Schedules a background job that will order the collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__contents_ordering_custom_}
 */
export const httpPostCollectionsByCollectionIdContentsOrderingCustom = (
  collectionId: string,
  body: AssetsCreateCollectionContentOrderingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdContentsOrderingCustom,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/ordering/custom/`,
  params: { collectionId },
  body,
  headers,
});

/**
 * `DELETE /v1/collections/{collection_id}/contents/{object_type}/{object_id}/`
 *
 * Delete a particular content object in a collection by id
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Content object not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_collections__collection_id__contents__object_type___object_id__}
 */
export const httpDeleteCollectionsByCollectionIdContentsByObjectTypeByObjectId =
  (
    collectionId: string,
    objectType: string,
    objectId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpDeleteCollectionsByCollectionIdContentsByObjectTypeByObjectId,
    method: httpMethod.delete,
    url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
    params: { collectionId, objectType, objectId },
    headers,
  });

/**
 * `PUT /v1/collections/{collection_id}/contents/{object_type}/{object_id}/`
 *
 * Update an order of a particular content object in a collection
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Content object not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_collections__collection_id__contents__object_type___object_id__}
 */
export const httpPutCollectionsByCollectionIdContentsByObjectTypeByObjectId = (
  collectionId: string,
  objectType: string,
  objectId: string,
  body: AssetsCollectionContentOrderingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutCollectionsByCollectionIdContentsByObjectTypeByObjectId,
  method: httpMethod.put,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { collectionId, objectType, objectId },
  body,
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/contents/{object_type}/{object_id}/reindex/`
 *
 * Reindex collection content
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Collection content does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__contents__object_type___object_id__reindex_}
 */
export const httpPostCollectionsByCollectionIdContentsByObjectTypeByObjectIdReindex =
  (
    collectionId: string,
    objectType: string,
    objectId: string,
    body: AssetsReindexCollectionContentSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPostCollectionsByCollectionIdContentsByObjectTypeByObjectIdReindex,
    method: httpMethod.post,
    url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/contents/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/reindex/`,
    params: { collectionId, objectType, objectId },
    body,
    headers,
  });

/**
 * Full path including all the ancestors / the upload path
 */
export type AssetsHttpGetCollectionsByCollectionIdFullPathResponse = string;

export interface AssetsHttpGetCollectionsByCollectionIdFullPathQuery {
  /**
   * Use to get the upload path instead of the full path
   */
  get_upload_path?: boolean;
}

/**
 * `GET /v1/collections/{collection_id}/full/path/`
 *
 * Gets the full path of the collection
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Full path including all the ancestors / the upload path
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsHttpGetCollectionsByCollectionIdFullPathResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__full_path_}
 */
export const httpGetCollectionsByCollectionIdFullPath = (
  collectionId: string,
  query?: AssetsHttpGetCollectionsByCollectionIdFullPathQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdFullPath,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/full/path/`,
  params: { collectionId },
  query,
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/keyframes/`
 *
 * Pick up to three asset_ids for collection keyframes
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 202 - Transcode job started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__keyframes_}
 */
export const httpPostCollectionsByCollectionIdKeyframes = (
  collectionId: string,
  body: AssetsSynchronizeCollectionKeyframesSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdKeyframes,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/keyframes/`,
  params: { collectionId },
  body,
  headers,
});

/**
 * `DELETE /v1/collections/{collection_id}/purge/`
 *
 * Purges deleted collection by id immediately
 *
 * Required roles:
 *  - can_purge_collections
 *
 * Responses
 * - 202 - Status and job_id
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden - Collection is not empty
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_collections__collection_id__purge_}
 */
export const httpDeleteCollectionsByCollectionIdPurge = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteCollectionsByCollectionIdPurge,
  method: httpMethod.delete,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/purge/`,
  params: { collectionId },
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/reindex/`
 *
 * Reindex collection
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__reindex_}
 */
export const httpPostCollectionsByCollectionIdReindex = (
  collectionId: string,
  body: AssetsReindexCollectionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/reindex/`,
  params: { collectionId },
  body,
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/reindex/contents/`
 *
 * Reindex collection and its content
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__reindex_contents_}
 */
export const httpPostCollectionsByCollectionIdReindexContents = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdReindexContents,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/reindex/contents/`,
  params: { collectionId },
  headers,
});

/**
 * `PUT /v1/collections/{collection_id}/restore/`
 *
 * Restore deleted collection by id
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden - Collection is not empty
 * - 404 - Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_collections__collection_id__restore_}
 */
export const httpPutCollectionsByCollectionIdRestore = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutCollectionsByCollectionIdRestore,
  method: httpMethod.put,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/restore/`,
  params: { collectionId },
  headers,
});

/**
 * `PUT /v1/collections/{collection_id}/search_document/`
 *
 * Update metadata for collection
 *
 * Required roles:
 *  - can_reindex_collections
 *
 * Responses
 * - 204 - Collection metadata updated
 * - 400 - No metadata supplied
 * - 401 - Token is invalid
 * - 404 - Collection does not exist in search index
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_collections__collection_id__search_document_}
 * @deprecated
 */
export const httpPutCollectionsByCollectionIdSearchDocument = (
  collectionId: string,
  body: AssetsCollectionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutCollectionsByCollectionIdSearchDocument,
  method: httpMethod.put,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/search_document/`,
  params: { collectionId },
  body,
  headers,
});

/**
 * `GET /v1/collections/{collection_id}/shares/all/`
 *
 * Get list of collection's shares including all direct and indirect shares that were made by
 *
 * sharing collections that contain the collectionsharing collections that contain the collection
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a list of shares
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSharesElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__shares_all_}
 */
export const httpGetCollectionsByCollectionIdSharesAll = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdSharesAll,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/shares/all/`,
  params: { collectionId },
  headers,
});

export interface AssetsHttpGetCollectionsByCollectionIdSizeQuery {
  /**
   * Compute total size only for files with the specified format name
   */
  format_name?: string;
  /**
   * Compute total size for all files including sub_collections' assets
   */
  include_subcollections?: boolean;
}

/**
 * `GET /v1/collections/{collection_id}/size/`
 *
 * Returns the size of all the collection's assets in bytes
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns the size of all the collection's assets
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionSizeSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_collections__collection_id__size_}
 */
export const httpGetCollectionsByCollectionIdSize = (
  collectionId: string,
  query?: AssetsHttpGetCollectionsByCollectionIdSizeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCollectionsByCollectionIdSize,
  method: httpMethod.get,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/size/`,
  params: { collectionId },
  query,
  headers,
});

export interface AssetsHttpPostCollectionsByCollectionIdSubcollectionsQuery {
  /**
   * Copy collection acls.
   */
  copy_acl?: string;
  /**
   * Copy collection keyframes.
   */
  copy_keyframes?: string;
}

/**
 * `POST /v1/collections/{collection_id}/subcollections/`
 *
 * Copy a collection (recursively) in to another collection
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 201 - Returns an updated collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection not found
 *
 * Response {@link AssetsCollectionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__subcollections_}
 */
export const httpPostCollectionsByCollectionIdSubcollections = (
  collectionId: string,
  body: AssetsCollectionContentSchema,
  query?: AssetsHttpPostCollectionsByCollectionIdSubcollectionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdSubcollections,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/subcollections/`,
  params: { collectionId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/collections/{collection_id}/views/`
 *
 * Mark collection as viewed
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns an updated collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Collection does not exist
 *
 * Response {@link AssetsCollectionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_collections__collection_id__views_}
 */
export const httpPostCollectionsByCollectionIdViews = (
  collectionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCollectionsByCollectionIdViews,
  method: httpMethod.post,
  url: `/API/assets/v1/collections/${encodeURIComponent(collectionId)}/views/`,
  params: { collectionId },
  headers,
});

/**
 * `GET /v1/custom_actions/`
 *
 * Get list of custom actions
 *
 * Required roles:
 *  - can_read_custom_actions
 *
 * Responses
 * - 200 - Returns a list of custom actions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCustomActionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_custom_actions_}
 */
export const httpGetCustomActions = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpGetCustomActions,
  method: httpMethod.get,
  url: '/API/assets/v1/custom_actions/',

  headers,
});

/**
 * `POST /v1/custom_actions/shared/{context}/{action_id}/callback/`
 *
 * Schedules a celery task that will call custom action on shares
 *
 * Required roles:
 *  - can_read_custom_actions
 *
 * Responses
 * - 200 - Returns a custom action reply
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCustomActionCallbackReplySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_custom_actions_shared__context___action_id__callback_}
 */
export const httpPostCustomActionsSharedByContextByActionIdCallback = (
  context: string,
  actionId: string,
  body: AssetsCustomActionCallbackSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCustomActionsSharedByContextByActionIdCallback,
  method: httpMethod.post,
  url: `/API/assets/v1/custom_actions/shared/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/callback/`,
  params: { context, actionId },
  body,
  headers,
});

/**
 * `GET /v1/custom_actions/{context}/`
 *
 * Get list of custom actions by context
 *
 * Required roles:
 *  - can_read_custom_actions
 *
 * Responses
 * - 200 - Returns a list of custom actions by context
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCustomActionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_custom_actions__context__}
 */
export const httpGetCustomActionsByContext = (
  context: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCustomActionsByContext,
  method: httpMethod.get,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/`,
  params: { context },
  headers,
});

/**
 * `POST /v1/custom_actions/{context}/`
 *
 * Create an custom action
 *
 *
 * Responses
 * - 201 - Returns a created custom action
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCustomActionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_custom_actions__context__}
 */
export const httpPostCustomActionsByContext = (
  context: string,
  body: AssetsCustomActionCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCustomActionsByContext,
  method: httpMethod.post,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/`,
  params: { context },
  body,
  headers,
});

/**
 * `DELETE /v1/custom_actions/{context}/{action_id}/`
 *
 * Deletes an custom action
 *
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_custom_actions__context___action_id__}
 */
export const httpDeleteCustomActionsByContextByActionId = (
  context: string,
  actionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteCustomActionsByContextByActionId,
  method: httpMethod.delete,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/`,
  params: { context, actionId },
  headers,
});

/**
 * `GET /v1/custom_actions/{context}/{action_id}/`
 *
 * Get an asset custom action
 *
 * Required roles:
 *  - can_read_custom_actions
 *
 * Responses
 * - 201 - Returns a created asset custom action
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCustomActionSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_custom_actions__context___action_id__}
 */
export const httpGetCustomActionsByContextByActionId = (
  context: string,
  actionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetCustomActionsByContextByActionId,
  method: httpMethod.get,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/`,
  params: { context, actionId },
  headers,
});

export type AssetsCustomActionSchemaPartial = Partial<AssetsCustomActionSchema>;

/**
 * `PATCH /v1/custom_actions/{context}/{action_id}/`
 *
 * Update an custom action
 *
 *
 * Responses
 * - 200 - Returns an created custom action
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCustomActionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_custom_actions__context___action_id__}
 */
export const httpPatchCustomActionsByContextByActionId = (
  context: string,
  actionId: string,
  body: AssetsCustomActionSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchCustomActionsByContextByActionId,
  method: httpMethod.patch,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/`,
  params: { context, actionId },
  body,
  headers,
});

/**
 * `PUT /v1/custom_actions/{context}/{action_id}/`
 *
 * Update an custom action
 *
 *
 * Responses
 * - 200 - Returns an created custom action
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsCustomActionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_custom_actions__context___action_id__}
 */
export const httpPutCustomActionsByContextByActionId = (
  context: string,
  actionId: string,
  body: AssetsCustomActionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutCustomActionsByContextByActionId,
  method: httpMethod.put,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/`,
  params: { context, actionId },
  body,
  headers,
});

/**
 * `POST /v1/custom_actions/{context}/{action_id}/callback/`
 *
 * Schedules a celery task that will call custom action
 *
 * Required roles:
 *  - can_read_custom_actions
 *
 * Responses
 * - 200 - Returns a custom action reply
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCustomActionCallbackReplySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_custom_actions__context___action_id__callback_}
 */
export const httpPostCustomActionsByContextByActionIdCallback = (
  context: string,
  actionId: string,
  body: AssetsCustomActionCallbackSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostCustomActionsByContextByActionIdCallback,
  method: httpMethod.post,
  url: `/API/assets/v1/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/callback/`,
  params: { context, actionId },
  body,
  headers,
});

/**
 * `DELETE /v1/delete_queue/assets/`
 *
 * Delete assets from delete queue (Mark assets as active again)
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_delete_queue_assets_}
 */
export const httpDeleteDeleteQueueAssets = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteDeleteQueueAssets,
  method: httpMethod.delete,
  url: '/API/assets/v1/delete_queue/assets/',

  body,
  headers,
});

export interface AssetsHttpGetDeleteQueueAssetsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * A comma separated list of fieldnames with order For example - first_name,eq,Vlad;last_name,eq,Gudkov
   */
  filter?: string;
}

/**
 * `GET /v1/delete_queue/assets/`
 *
 * Get deleted objects
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns a list of asset
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_delete_queue_assets_}
 */
export const httpGetDeleteQueueAssets = (
  query?: AssetsHttpGetDeleteQueueAssetsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetDeleteQueueAssets,
  method: httpMethod.get,
  url: '/API/assets/v1/delete_queue/assets/',

  query,
  headers,
});

/**
 * `POST /v1/delete_queue/assets/`
 *
 * Add assets to a delete queue (Mark assets as deleted)
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_assets_}
 */
export const httpPostDeleteQueueAssets = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueAssets,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/assets/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/assets/purge/`
 *
 * Purge assets from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_assets
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_assets_purge_}
 */
export const httpPostDeleteQueueAssetsPurge = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueAssetsPurge,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/assets/purge/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/assets/purge/all/`
 *
 * Purge all assets from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_assets_purge_all_}
 */
export const httpPostDeleteQueueAssetsPurgeAll = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueAssetsPurgeAll,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/assets/purge/all/',

  headers,
});

/**
 * `POST /v1/delete_queue/assets/restore/all/`
 *
 * Restore all assets from delete queue
 *
 * Required roles:
 *  - can_write_assets
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_assets_restore_all_}
 */
export const httpPostDeleteQueueAssetsRestoreAll = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueAssetsRestoreAll,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/assets/restore/all/',

  headers,
});

/**
 * `POST /v1/delete_queue/bulk/`
 *
 * Bulk delete objects
 *
 * Required roles:
 *  - can_delete_assets
 *
 * Responses
 * - 202 - Bulk delete was scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_bulk_}
 */
export const httpPostDeleteQueueBulk = (
  body: AssetsBulkDeleteSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueBulk,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/bulk/',

  body,
  headers,
});

/**
 * `DELETE /v1/delete_queue/collections/`
 *
 * Delete collections from delete queue (Mark collections as active again)
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden - Collection is not empty
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_delete_queue_collections_}
 */
export const httpDeleteDeleteQueueCollections = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteDeleteQueueCollections,
  method: httpMethod.delete,
  url: '/API/assets/v1/delete_queue/collections/',

  body,
  headers,
});

export interface AssetsHttpGetDeleteQueueCollectionsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * A comma separated list of fieldnames with order For example - first_name,eq,Vlad;last_name,eq,Gudkov
   */
  filter?: string;
}

/**
 * `GET /v1/delete_queue/collections/`
 *
 * Get list of collections
 *
 * Required roles:
 *  - can_read_collections
 *
 * Responses
 * - 200 - Returns a list of collections
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsCollectionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_delete_queue_collections_}
 */
export const httpGetDeleteQueueCollections = (
  query?: AssetsHttpGetDeleteQueueCollectionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetDeleteQueueCollections,
  method: httpMethod.get,
  url: '/API/assets/v1/delete_queue/collections/',

  query,
  headers,
});

/**
 * `POST /v1/delete_queue/collections/`
 *
 * Add collections to a delete queue (Mark collections as deleted)
 *
 * Required roles:
 *  - can_delete_collections
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden - Collection is not empty
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_collections_}
 */
export const httpPostDeleteQueueCollections = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueCollections,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/collections/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/collections/purge/`
 *
 * Purge collections from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_collections
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden - Collection is not empty
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_collections_purge_}
 */
export const httpPostDeleteQueueCollectionsPurge = (
  body: AssetsDeleteQueueSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueCollectionsPurge,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/collections/purge/',

  body,
  headers,
});

/**
 * `POST /v1/delete_queue/collections/purge/all/`
 *
 * Purge all collections from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_collections
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_collections_purge_all_}
 */
export const httpPostDeleteQueueCollectionsPurgeAll = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueCollectionsPurgeAll,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/collections/purge/all/',

  headers,
});

/**
 * `POST /v1/delete_queue/collections/restore/all/`
 *
 * Restore all collections from delete queue
 *
 * Required roles:
 *  - can_write_collections
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_collections_restore_all_}
 */
export const httpPostDeleteQueueCollectionsRestoreAll = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostDeleteQueueCollectionsRestoreAll,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/collections/restore/all/',

  headers,
});

/**
 * `POST /v1/delete_queue/purge/all/`
 *
 * Purge all assets and collections from delete queue (Permanently delete)
 *
 * Required roles:
 *  - can_purge_assets
 * - can_purge_collections
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - User does not have permission
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_delete_queue_purge_all_}
 */
export const httpPostDeleteQueuePurgeAll = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpPostDeleteQueuePurgeAll,
  method: httpMethod.post,
  url: '/API/assets/v1/delete_queue/purge/all/',

  headers,
});

export interface AssetsHttpDeleteFavoritesQuery {
  index_immediately?: string;
}

/**
 * `DELETE /v1/favorites/`
 *
 * Deletes objects items from a list of favorites
 *
 * Required roles:
 *  - can_delete_favorites
 *
 * Responses
 * - 200 - Returns a list of object IDs that were removed from favorites
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsBulkDeleteFromFavoritesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_favorites_}
 */
export const httpDeleteFavorites = (
  body: AssetsBulkDeleteFromFavoritesSchema,
  query?: AssetsHttpDeleteFavoritesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteFavorites,
  method: httpMethod.delete,
  url: '/API/assets/v1/favorites/',

  body,
  query,
  headers,
});

export interface AssetsHttpGetFavoritesQuery {
  /**
   * The number of objects for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;date_created,desc
   */
  sort?: string;
}

/**
 * `GET /v1/favorites/`
 *
 * Get list of favorite objects
 *
 * Required roles:
 *  - can_read_assets
 *
 * Responses
 * - 200 - Returns list of favorite objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsFavoritesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_favorites_}
 */
export const httpGetFavorites = (
  query?: AssetsHttpGetFavoritesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetFavorites,
  method: httpMethod.get,
  url: '/API/assets/v1/favorites/',

  query,
  headers,
});

export interface AssetsHttpPostFavoritesQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/favorites/`
 *
 * Adds multiple objects to a list of favorites
 *
 * Required roles:
 *  - can_write_favorites
 *
 * Responses
 * - 200 - Returns a list of object IDs that were added to favorites
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsBulkAddToFavoritesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_favorites_}
 */
export const httpPostFavorites = (
  body: AssetsBulkAddToFavoritesSchema,
  query?: AssetsHttpPostFavoritesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostFavorites,
  method: httpMethod.post,
  url: '/API/assets/v1/favorites/',

  body,
  query,
  headers,
});

/**
 * `DELETE /v1/favorites/all/`
 *
 * Removes all assets/collections from the list of favourites
 *
 * Required roles:
 *  - can_delete_favorites
 *
 * Responses
 * - 202 - A background task for deleting all from favourites was scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_favorites_all_}
 */
export const httpDeleteFavoritesAll = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpDeleteFavoritesAll,
  method: httpMethod.delete,
  url: '/API/assets/v1/favorites/all/',

  headers,
});

/**
 * `DELETE /v1/favourites/all/`
 *
 * Removes all assets/collections from the list of favourites
 *
 * Required roles:
 *  - can_delete_favorites
 *
 * Responses
 * - 202 - A background task for deleting all from favourites was scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_favourites_all_}
 * @deprecated
 */
export const httpDeleteFavouritesAll = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpDeleteFavouritesAll,
  method: httpMethod.delete,
  url: '/API/assets/v1/favourites/all/',

  headers,
});

export interface AssetsHttpGetPersonsByPersonIdQuery {
  page?: number;
  per_page?: number;
  asset_id?: string;
}

/**
 * `GET /v1/persons/{person_id}/`
 *
 * Get all assets containing a person_id or specific versions of an asset containing a person_id
 *
 *
 * Responses
 * - 200 - Returns a list of assets containing the person_id or specific versions of an asset containing the person_id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsAssetsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_persons__person_id__}
 */
export const httpGetPersonsByPersonId = (
  personId: string,
  query?: AssetsHttpGetPersonsByPersonIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPersonsByPersonId,
  method: httpMethod.get,
  url: `/API/assets/v1/persons/${encodeURIComponent(personId)}/`,
  params: { personId },
  query,
  headers,
});

export interface AssetsHttpGetPlaylistsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;date_created,desc
   */
  sort?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * A comma separated list of playlist IDs to filter by
   */
  ids?: string;
}

/**
 * `GET /v1/playlists/`
 *
 * Get list of playlists
 *
 * Required roles:
 *  - can_read_playlists
 *
 * Responses
 * - 200 - Returns a list of playlists
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsPlaylistsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_playlists_}
 */
export const httpGetPlaylists = (
  query?: AssetsHttpGetPlaylistsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPlaylists,
  method: httpMethod.get,
  url: '/API/assets/v1/playlists/',

  query,
  headers,
});

export interface AssetsHttpPostPlaylistsQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/playlists/`
 *
 * Create a new playlist
 *
 * Required roles:
 *  - can_create_playlists
 *
 * Responses
 * - 201 - Returns a created playlist
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_playlists_}
 */
export const httpPostPlaylists = (
  body: AssetsPlaylistCreateSchema,
  query?: AssetsHttpPostPlaylistsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPlaylists,
  method: httpMethod.post,
  url: '/API/assets/v1/playlists/',

  body,
  query,
  headers,
});

/**
 * `DELETE /v1/playlists/{playlist_id}/`
 *
 * Delete a particular playlist by id
 *
 * Required roles:
 *  - can_delete_playlists
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_playlists__playlist_id__}
 */
export const httpDeletePlaylistsByPlaylistId = (
  playlistId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeletePlaylistsByPlaylistId,
  method: httpMethod.delete,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/`,
  params: { playlistId },
  headers,
});

/**
 * `GET /v1/playlists/{playlist_id}/`
 *
 * Returns a particular playlist by id
 *
 * Required roles:
 *  - can_read_playlists
 *
 * Responses
 * - 200 - Returns a playlist
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_playlists__playlist_id__}
 */
export const httpGetPlaylistsByPlaylistId = (
  playlistId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPlaylistsByPlaylistId,
  method: httpMethod.get,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/`,
  params: { playlistId },
  headers,
});

export type AssetsPlaylistSchemaPartial = Partial<AssetsPlaylistSchema>;

export interface AssetsHttpPatchPlaylistsByPlaylistIdQuery {
  index_immediately?: string;
}

/**
 * `PATCH /v1/playlists/{playlist_id}/`
 *
 * Update a playlist
 *
 * Required roles:
 *  - can_write_playlists
 *
 * Responses
 * - 200 - Returns an updated playlist
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * Response {@link AssetsPlaylistSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_playlists__playlist_id__}
 */
export const httpPatchPlaylistsByPlaylistId = (
  playlistId: string,
  body: AssetsPlaylistSchemaPartial,
  query?: AssetsHttpPatchPlaylistsByPlaylistIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchPlaylistsByPlaylistId,
  method: httpMethod.patch,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/`,
  params: { playlistId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutPlaylistsByPlaylistIdQuery {
  index_immediately?: string;
}

/**
 * `PUT /v1/playlists/{playlist_id}/`
 *
 * Update a playlist
 *
 * Required roles:
 *  - can_write_playlists
 *
 * Responses
 * - 200 - Returns an updated playlist
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * Response {@link AssetsPlaylistSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_playlists__playlist_id__}
 */
export const httpPutPlaylistsByPlaylistId = (
  playlistId: string,
  body: AssetsPlaylistSchema,
  query?: AssetsHttpPutPlaylistsByPlaylistIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutPlaylistsByPlaylistId,
  method: httpMethod.put,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/`,
  params: { playlistId },
  body,
  query,
  headers,
});

export interface AssetsHttpGetPlaylistsByPlaylistIdItemsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Which page number to fetch
   */
  page?: number;
}

/**
 * `GET /v1/playlists/{playlist_id}/items/`
 *
 * Get list of playlist's items
 *
 * Required roles:
 *  - can_read_playlists
 *
 * Responses
 * - 200 - Returns a list of playlist's items
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsPlaylistItemsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_playlists__playlist_id__items_}
 */
export const httpGetPlaylistsByPlaylistIdItems = (
  playlistId: string,
  query?: AssetsHttpGetPlaylistsByPlaylistIdItemsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPlaylistsByPlaylistIdItems,
  method: httpMethod.get,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/`,
  params: { playlistId },
  query,
  headers,
});

export interface AssetsHttpPostPlaylistsByPlaylistIdItemsQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/playlists/{playlist_id}/items/`
 *
 * Add an item to a playlist
 *
 * Required roles:
 *  - can_add_playlist_items
 *
 * Responses
 * - 201 - Returns a created item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistItemSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_playlists__playlist_id__items_}
 */
export const httpPostPlaylistsByPlaylistIdItems = (
  playlistId: string,
  body: AssetsPlaylistItemSchema,
  query?: AssetsHttpPostPlaylistsByPlaylistIdItemsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPlaylistsByPlaylistIdItems,
  method: httpMethod.post,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/`,
  params: { playlistId },
  body,
  query,
  headers,
});

export interface AssetsHttpDeletePlaylistsByPlaylistIdItemsByItemIdQuery {
  index_immediately?: string;
}

/**
 * `DELETE /v1/playlists/{playlist_id}/items/{item_id}/`
 *
 * Delete a particular playlist item by id
 *
 * Required roles:
 *  - can_delete_playlist_items
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_playlists__playlist_id__items__item_id__}
 */
export const httpDeletePlaylistsByPlaylistIdItemsByItemId = (
  playlistId: string,
  itemId: string,
  query?: AssetsHttpDeletePlaylistsByPlaylistIdItemsByItemIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeletePlaylistsByPlaylistIdItemsByItemId,
  method: httpMethod.delete,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/${encodeURIComponent(itemId)}/`,
  params: { playlistId, itemId },
  query,
  headers,
});

export type AssetsPlaylistItemSchemaPartial = Partial<AssetsPlaylistItemSchema>;

export interface AssetsHttpPatchPlaylistsByPlaylistIdItemsByItemIdQuery {
  index_immediately?: string;
}

/**
 * `PATCH /v1/playlists/{playlist_id}/items/{item_id}/`
 *
 * Update a playlist item
 *
 * Required roles:
 *  - can_update_playlist_items
 *
 * Responses
 * - 201 - Returns an updated item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistItemSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_playlists__playlist_id__items__item_id__}
 */
export const httpPatchPlaylistsByPlaylistIdItemsByItemId = (
  playlistId: string,
  itemId: string,
  body: AssetsPlaylistItemSchemaPartial,
  query?: AssetsHttpPatchPlaylistsByPlaylistIdItemsByItemIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchPlaylistsByPlaylistIdItemsByItemId,
  method: httpMethod.patch,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/${encodeURIComponent(itemId)}/`,
  params: { playlistId, itemId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdQuery {
  index_immediately?: string;
}

/**
 * `PUT /v1/playlists/{playlist_id}/items/{item_id}/`
 *
 * Update a playlist item
 *
 * Required roles:
 *  - can_update_playlist_items
 *
 * Responses
 * - 201 - Returns an updated item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistItemSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_playlists__playlist_id__items__item_id__}
 */
export const httpPutPlaylistsByPlaylistIdItemsByItemId = (
  playlistId: string,
  itemId: string,
  body: AssetsPlaylistItemSchema,
  query?: AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutPlaylistsByPlaylistIdItemsByItemId,
  method: httpMethod.put,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/${encodeURIComponent(itemId)}/`,
  params: { playlistId, itemId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdPositionQuery {
  index_immediately?: string;
}

/**
 * `PUT /v1/playlists/{playlist_id}/items/{item_id}/position/`
 *
 * Update a playlist item position
 *
 * Required roles:
 *  - can_update_playlist_items_position
 *
 * Responses
 * - 201 - Returns an updated item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPlaylistItemSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_playlists__playlist_id__items__item_id__position_}
 */
export const httpPutPlaylistsByPlaylistIdItemsByItemIdPosition = (
  playlistId: string,
  itemId: string,
  body: AssetsPlaylistItemUpdatePositionSchema,
  query?: AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdPositionQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutPlaylistsByPlaylistIdItemsByItemIdPosition,
  method: httpMethod.put,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/items/${encodeURIComponent(itemId)}/position/`,
  params: { playlistId, itemId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/playlists/{playlist_id}/keyframes/`
 *
 * Pick up to three asset_ids for playlist keyframes
 *
 * Required roles:
 *  - can_reindex_playlists
 *
 * Responses
 * - 202 - Transcode job started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_playlists__playlist_id__keyframes_}
 */
export const httpPostPlaylistsByPlaylistIdKeyframes = (
  playlistId: string,
  body: AssetsSynchronizeCollectionKeyframesSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPlaylistsByPlaylistIdKeyframes,
  method: httpMethod.post,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/keyframes/`,
  params: { playlistId },
  body,
  headers,
});

export interface AssetsHttpPostPlaylistsByPlaylistIdReindexQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/playlists/{playlist_id}/reindex/`
 *
 * Reindex the playlist
 *
 * Required roles:
 *  - can_reindex_playlists
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_playlists__playlist_id__reindex_}
 */
export const httpPostPlaylistsByPlaylistIdReindex = (
  playlistId: string,
  body: AssetsReindexPlaylistSchema,
  query?: AssetsHttpPostPlaylistsByPlaylistIdReindexQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPlaylistsByPlaylistIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/playlists/${encodeURIComponent(playlistId)}/reindex/`,
  params: { playlistId },
  body,
  query,
  headers,
});

export interface AssetsHttpGetPortalsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;date_created,desc
   */
  sort?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * A comma separated list of portal IDs to filter by
   */
  ids?: string;
  /**
   * Free text search over the portal name, with wildcard (`*`) support
   */
  query?: string;
}

/**
 * `GET /v1/portals/`
 *
 * Get list of portals
 *
 * Required roles:
 *  - can_read_portals
 *
 * Responses
 * - 200 - Returns a list of portals
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsPortalsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_portals_}
 */
export const httpGetPortals = (
  query?: AssetsHttpGetPortalsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPortals,
  method: httpMethod.get,
  url: '/API/assets/v1/portals/',

  query,
  headers,
});

/**
 * `POST /v1/portals/`
 *
 * Create a new portal
 *
 * Required roles:
 *  - can_create_portals
 *
 * Responses
 * - 201 - Returns a created portal
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPortalSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_portals_}
 */
export const httpPostPortals = (
  body: AssetsPortalCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPortals,
  method: httpMethod.post,
  url: '/API/assets/v1/portals/',

  body,
  headers,
});

/**
 * `DELETE /v1/portals/{portal_id}/`
 *
 * Delete a particular portal by id
 *
 * Required roles:
 *  - can_delete_portals
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_portals__portal_id__}
 */
export const httpDeletePortalsByPortalId = (
  portalId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeletePortalsByPortalId,
  method: httpMethod.delete,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/`,
  params: { portalId },
  headers,
});

/**
 * `GET /v1/portals/{portal_id}/`
 *
 * Returns a particular portal by id
 *
 * Required roles:
 *  - can_read_portals
 *
 * Responses
 * - 200 - Returns a portal
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsPortalSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_portals__portal_id__}
 */
export const httpGetPortalsByPortalId = (
  portalId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPortalsByPortalId,
  method: httpMethod.get,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/`,
  params: { portalId },
  headers,
});

export type AssetsPortalSchemaPartial = Partial<AssetsPortalSchema>;

/**
 * `PATCH /v1/portals/{portal_id}/`
 *
 * Update a portal
 *
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 200 - Returns an updated portal
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * Response {@link AssetsPortalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_portals__portal_id__}
 */
export const httpPatchPortalsByPortalId = (
  portalId: string,
  body: AssetsPortalSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchPortalsByPortalId,
  method: httpMethod.patch,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/`,
  params: { portalId },
  body,
  headers,
});

/**
 * `PUT /v1/portals/{portal_id}/`
 *
 * Update a portal
 *
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 200 - Returns an updated portal
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * Response {@link AssetsPortalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_portals__portal_id__}
 */
export const httpPutPortalsByPortalId = (
  portalId: string,
  body: AssetsPortalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutPortalsByPortalId,
  method: httpMethod.put,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/`,
  params: { portalId },
  body,
  headers,
});

/**
 * `DELETE /v1/portals/{portal_id}/logo/`
 *
 * Delete the portal logo
 *
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_portals__portal_id__logo_}
 */
export const httpDeletePortalsByPortalIdLogo = (
  portalId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeletePortalsByPortalIdLogo,
  method: httpMethod.delete,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/logo/`,
  params: { portalId },
  headers,
});

/**
 * `POST /v1/portals/{portal_id}/logo/`
 *
 * Upload a portal logo image
 *
 * Required roles:
 *  - can_write_portals
 *
 * Responses
 * - 201 - Returns the portal with its logo URL
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * Response {@link AssetsPortalSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_portals__portal_id__logo_}
 */
export const httpPostPortalsByPortalIdLogo = (
  portalId: string,
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPortalsByPortalIdLogo,
  method: httpMethod.post,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/logo/`,
  params: { portalId },
  body: formData,
  headers,
});

/**
 * `POST /v1/portals/{portal_id}/reindex/`
 *
 * Reindex the portal
 *
 * Required roles:
 *  - can_reindex_portals
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Portal does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_portals__portal_id__reindex_}
 */
export const httpPostPortalsByPortalIdReindex = (
  portalId: string,
  body: AssetsReindexPortalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPortalsByPortalIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/portals/${encodeURIComponent(portalId)}/reindex/`,
  params: { portalId },
  body,
  headers,
});

export interface AssetsHttpGetProjectsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;date_created,desc
   */
  sort?: string;
  /**
   * Filter by status
   */
  status?: string;
}

/**
 * `GET /v1/projects/`
 *
 * Get list of projects
 *
 * Required roles:
 *  - can_read_projects
 *
 * Responses
 * - 200 - Returns a list of projects
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsProjectsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_projects_}
 */
export const httpGetProjects = (
  query?: AssetsHttpGetProjectsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetProjects,
  method: httpMethod.get,
  url: '/API/assets/v1/projects/',

  query,
  headers,
});

/**
 * `POST /v1/projects/`
 *
 * Create a new project
 *
 * Required roles:
 *  - can_create_projects
 *
 * Responses
 * - 201 - Returns a created project
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsProjectSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_projects_}
 */
export const httpPostProjects = (
  body: AssetsProjectCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostProjects,
  method: httpMethod.post,
  url: '/API/assets/v1/projects/',

  body,
  headers,
});

/**
 * `DELETE /v1/projects/{project_id}/`
 *
 * Delete a particular project by id
 *
 * Required roles:
 *  - can_delete_projects
 *
 * Responses
 * - 202 - Deletion has been scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Project does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_projects__project_id__}
 */
export const httpDeleteProjectsByProjectId = (
  projectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteProjectsByProjectId,
  method: httpMethod.delete,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/`,
  params: { projectId },
  headers,
});

export interface AssetsHttpGetProjectsByProjectIdQuery {
  /**
   * include info about the users who have interacted with this project
   */
  include_users?: boolean;
}

/**
 * `GET /v1/projects/{project_id}/`
 *
 * Returns a particular project by id
 *
 * Required roles:
 *  - can_read_projects
 *
 * Responses
 * - 200 - Returns a project
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsProjectSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_projects__project_id__}
 */
export const httpGetProjectsByProjectId = (
  projectId: string,
  query?: AssetsHttpGetProjectsByProjectIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetProjectsByProjectId,
  method: httpMethod.get,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/`,
  params: { projectId },
  query,
  headers,
});

export type AssetsProjectSchemaPartial = Partial<AssetsProjectSchema>;

/**
 * `PATCH /v1/projects/{project_id}/`
 *
 * Update project
 *
 * Required roles:
 *  - can_write_projects
 *
 * Responses
 * - 200 - Returns an updated project
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Project does not exist
 *
 * Response {@link AssetsProjectSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_projects__project_id__}
 */
export const httpPatchProjectsByProjectId = (
  projectId: string,
  body: AssetsProjectSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchProjectsByProjectId,
  method: httpMethod.patch,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/`,
  params: { projectId },
  body,
  headers,
});

/**
 * `PUT /v1/projects/{project_id}/`
 *
 * Update project
 *
 * Required roles:
 *  - can_write_projects
 *
 * Responses
 * - 200 - Returns an updated project
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Project does not exist
 *
 * Response {@link AssetsProjectSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_projects__project_id__}
 */
export const httpPutProjectsByProjectId = (
  projectId: string,
  body: AssetsProjectSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutProjectsByProjectId,
  method: httpMethod.put,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/`,
  params: { projectId },
  body,
  headers,
});

/**
 * `GET /v1/projects/{project_id}/members/`
 *
 * Get list of project's members
 *
 * Required roles:
 *  - can_read_projects
 *
 * Responses
 * - 200 - Returns a list of project members
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsProjectMembersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_projects__project_id__members_}
 */
export const httpGetProjectsByProjectIdMembers = (
  projectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetProjectsByProjectIdMembers,
  method: httpMethod.get,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/members/`,
  params: { projectId },
  headers,
});

export type AssetsProjectMemberCreateSchemaOptionalId = PartialBy<
  AssetsProjectMemberCreateSchema,
  'id'
>;

/**
 * `POST /v1/projects/{project_id}/members/`
 *
 * Add a member to a project
 *
 * Required roles:
 *  - can_add_project_members
 *
 * Responses
 * - 201 - Returns a created member
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsProjectMemberSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_projects__project_id__members_}
 */
export const httpPostProjectsByProjectIdMembers = (
  projectId: string,
  body: AssetsProjectMemberCreateSchemaOptionalId,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostProjectsByProjectIdMembers,
  method: httpMethod.post,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/members/`,
  params: { projectId },
  body,
  headers,
});

/**
 * `DELETE /v1/projects/{project_id}/members/{member_id}/`
 *
 * Delete a particular project member by id
 *
 * Required roles:
 *  - can_delete_project_members
 *
 * Responses
 * - 204 - Deleted successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Project does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_projects__project_id__members__member_id__}
 */
export const httpDeleteProjectsByProjectIdMembersByMemberId = (
  projectId: string,
  memberId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteProjectsByProjectIdMembersByMemberId,
  method: httpMethod.delete,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/members/${encodeURIComponent(memberId)}/`,
  params: { projectId, memberId },
  headers,
});

/**
 * `GET /v1/projects/{project_id}/members/{member_id}/`
 *
 * Returns a particular project member by id
 *
 * Required roles:
 *  - can_read_projects
 *
 * Responses
 * - 200 - Returns a project member
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsProjectMemberSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_projects__project_id__members__member_id__}
 */
export const httpGetProjectsByProjectIdMembersByMemberId = (
  projectId: string,
  memberId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetProjectsByProjectIdMembersByMemberId,
  method: httpMethod.get,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/members/${encodeURIComponent(memberId)}/`,
  params: { projectId, memberId },
  headers,
});

/**
 * `POST /v1/projects/{project_id}/reindex/`
 *
 * Reindex the project
 *
 * Required roles:
 *  - can_reindex_projects
 *
 * Responses
 * - 201 - Without body
 * - 401 - Token is invalid
 * - 404 - Project does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_projects__project_id__reindex_}
 */
export const httpPostProjectsByProjectIdReindex = (
  projectId: string,
  body: AssetsReindexProjectSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostProjectsByProjectIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/projects/${encodeURIComponent(projectId)}/reindex/`,
  params: { projectId },
  body,
  headers,
});

/**
 * `GET /v1/publications/destinations/accounts/`
 *
 * Returns the destination accounts the caller is allowed to publish to
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns a list of destination accounts.
 * - 400 - Wildmoka settings are incomplete
 * - 401 - Token is invalid
 * - 403 - User is not allowed to fetch destination accounts from Wildmoka
 * - 422 - Publishing is not configured
 * - 502 - Failed to reach Wildmoka
 *
 * Response {@link AssetsDestinationItemsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_publications_destinations_accounts_}
 */
export const httpGetPublicationsDestinationsAccounts = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPublicationsDestinationsAccounts,
  method: httpMethod.get,
  url: '/API/assets/v1/publications/destinations/accounts/',

  headers,
});

/**
 * `GET /v1/publications/destinations/platforms/`
 *
 * Returns the distinct destination platforms the caller can publish to
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns a list of destination platforms.
 * - 400 - Wildmoka settings are incomplete
 * - 401 - Token is invalid
 * - 403 - User is not allowed to fetch destination accounts from Wildmoka
 * - 422 - Publishing is not configured
 * - 502 - Failed to reach Wildmoka
 *
 * Response {@link AssetsDestinationItemsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_publications_destinations_platforms_}
 */
export const httpGetPublicationsDestinationsPlatforms = (
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPublicationsDestinationsPlatforms,
  method: httpMethod.get,
  url: '/API/assets/v1/publications/destinations/platforms/',

  headers,
});

/**
 * `GET /v1/publications/drafts/{asset_id}/`
 *
 * ⚠️ Beta: Returns the iconik-native fields of a saved draft so the panel can be pre-filled
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns the iconik-native fields saved for the draft.
 * - 401 - Token is invalid
 * - 403 - User is not allowed to fetch the draft from Wildmoka
 * - 404 - No draft exists for the asset
 * - 422 - Publishing is not configured
 * - 502 - Failed to reach Wildmoka
 *
 * Response {@link AssetsPublicationDraftSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_publications_drafts__asset_id__}
 */
export const httpGetPublicationsDraftsByAssetId = (
  assetId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetPublicationsDraftsByAssetId,
  method: httpMethod.get,
  url: `/API/assets/v1/publications/drafts/${encodeURIComponent(assetId)}/`,
  params: { assetId },
  headers,
});

/**
 * `POST /v1/publications/jobs/`
 *
 * ⚠️ Beta: Schedules publishing for an asset to a list of destinations based on template_id
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 202 - Schedules publishing.
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_publications_jobs_}
 */
export const httpPostPublicationsJobs = (
  body: AssetsCreatePublicationJobSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPublicationsJobs,
  method: httpMethod.post,
  url: '/API/assets/v1/publications/jobs/',

  body,
  headers,
});

/**
 * `GET /v1/publications/templates/`
 *
 * Returns publication templates that can be used for publishing
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns a list of publication templates.
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsPublicationTemplatesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_publications_templates_}
 */
export const httpGetPublicationsTemplates = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpGetPublicationsTemplates,
  method: httpMethod.get,
  url: '/API/assets/v1/publications/templates/',

  headers,
});

/**
 * `GET /v1/publications/token/`
 *
 * Returns publication token that can be used for loading publication panel
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns a token.
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsPublicationTokenSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_publications_token_}
 */
export const httpGetPublicationsToken = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpGetPublicationsToken,
  method: httpMethod.get,
  url: '/API/assets/v1/publications/token/',

  headers,
});

/**
 * `POST /v1/publications/{publication_id}/cancel/`
 *
 * ⚠️ Beta: Cancels the scheduled publication of a post asset
 *
 * Required roles:
 *  - can_publish
 *
 * Responses
 * - 200 - Returns the outcome of the cancellation and the resulting status.
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Asset or publication does not exist
 * - 422 - Publishing is not configured
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_publications__publication_id__cancel_}
 */
export const httpPostPublicationsByPublicationIdCancel = (
  publicationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostPublicationsByPublicationIdCancel,
  method: httpMethod.post,
  url: `/API/assets/v1/publications/${encodeURIComponent(publicationId)}/cancel/`,
  params: { publicationId },
  headers,
});

/**
 * `POST /v1/reindex/bulk/`
 *
 * Create a job for bulk reindexing of assets
 *
 * Required roles:
 *  - can_reindex_assets
 *
 * Responses
 * - 200 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_reindex_bulk_}
 */
export const httpPostReindexBulk = (
  body: AssetsReindexBulkActionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostReindexBulk,
  method: httpMethod.post,
  url: '/API/assets/v1/reindex/bulk/',

  body,
  headers,
});

/**
 * `POST /v1/segments/reindex/`
 *
 * Trigger reindexing of specific segment ids
 *
 * Required roles:
 *  - can_reindex_segments
 *
 * Responses
 * - 201 - ID and status of the job
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_segments_reindex_}
 */
export const httpPostSegmentsReindex = (
  body: AssetsReindexSegmentsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSegmentsReindex,
  method: httpMethod.post,
  url: '/API/assets/v1/segments/reindex/',

  body,
  headers,
});

export interface AssetsHttpGetSequencesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;date_created,desc
   */
  sort?: string;
  /**
   * Filter by status
   */
  status?: string;
}

/**
 * `GET /v1/sequences/`
 *
 * Get list of sequences
 *
 * Required roles:
 *  - can_read_sequences
 *
 * Responses
 * - 200 - Returns a list of sequences
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSequencesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_sequences_}
 */
export const httpGetSequences = (
  query?: AssetsHttpGetSequencesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSequences,
  method: httpMethod.get,
  url: '/API/assets/v1/sequences/',

  query,
  headers,
});

/**
 * `POST /v1/sequences/`
 *
 * Create a new sequence
 *
 * Required roles:
 *  - can_create_sequences
 *
 * Responses
 * - 201 - Returns a created sequence
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSequenceSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_sequences_}
 */
export const httpPostSequences = (
  body: AssetsSequenceCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSequences,
  method: httpMethod.post,
  url: '/API/assets/v1/sequences/',

  body,
  headers,
});

/**
 * `DELETE /v1/sequences/{sequence_id}/`
 *
 * Delete a particular sequence by id
 *
 * Required roles:
 *  - can_delete_sequences
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Sequence does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_sequences__sequence_id__}
 */
export const httpDeleteSequencesBySequenceId = (
  sequenceId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSequencesBySequenceId,
  method: httpMethod.delete,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/`,
  params: { sequenceId },
  headers,
});

/**
 * `GET /v1/sequences/{sequence_id}/`
 *
 * Returns a particular sequence by id
 *
 * Required roles:
 *  - can_read_sequences
 *
 * Responses
 * - 200 - Returns a sequence
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSequenceSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_sequences__sequence_id__}
 */
export const httpGetSequencesBySequenceId = (
  sequenceId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSequencesBySequenceId,
  method: httpMethod.get,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/`,
  params: { sequenceId },
  headers,
});

export type AssetsSequenceSchemaPartial = Partial<AssetsSequenceSchema>;

/**
 * `PATCH /v1/sequences/{sequence_id}/`
 *
 * Update a sequence
 *
 * Required roles:
 *  - can_write_sequences
 *
 * Responses
 * - 200 - Returns an updated sequence
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Sequence does not exist
 *
 * Response {@link AssetsSequenceSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_sequences__sequence_id__}
 */
export const httpPatchSequencesBySequenceId = (
  sequenceId: string,
  body: AssetsSequenceSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchSequencesBySequenceId,
  method: httpMethod.patch,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/`,
  params: { sequenceId },
  body,
  headers,
});

/**
 * `PUT /v1/sequences/{sequence_id}/`
 *
 * Update a sequence
 *
 * Required roles:
 *  - can_write_sequences
 *
 * Responses
 * - 200 - Returns an updated sequence
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Sequence does not exist
 *
 * Response {@link AssetsSequenceSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_sequences__sequence_id__}
 */
export const httpPutSequencesBySequenceId = (
  sequenceId: string,
  body: AssetsSequenceSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutSequencesBySequenceId,
  method: httpMethod.put,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/`,
  params: { sequenceId },
  body,
  headers,
});

export interface AssetsHttpGetSequencesBySequenceIdItemsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
}

/**
 * `GET /v1/sequences/{sequence_id}/items/`
 *
 * Get list of sequence's items
 *
 * Required roles:
 *  - can_read_sequences
 *
 * Responses
 * - 200 - Returns a list of sequences
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSequenceItemsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_sequences__sequence_id__items_}
 */
export const httpGetSequencesBySequenceIdItems = (
  sequenceId: string,
  query?: AssetsHttpGetSequencesBySequenceIdItemsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSequencesBySequenceIdItems,
  method: httpMethod.get,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/items/`,
  params: { sequenceId },
  query,
  headers,
});

/**
 * `POST /v1/sequences/{sequence_id}/items/`
 *
 * Add an item to a sequence
 *
 * Required roles:
 *  - can_add_sequence_items
 *
 * Responses
 * - 201 - Returns a created item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSequenceItemSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_sequences__sequence_id__items_}
 */
export const httpPostSequencesBySequenceIdItems = (
  sequenceId: string,
  body: AssetsSequenceItemSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSequencesBySequenceIdItems,
  method: httpMethod.post,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/items/`,
  params: { sequenceId },
  body,
  headers,
});

/**
 * `DELETE /v1/sequences/{sequence_id}/items/{item_id}/`
 *
 * Delete a particular sequence item by id
 *
 * Required roles:
 *  - can_delete_sequence_items
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Sequence does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_sequences__sequence_id__items__item_id__}
 */
export const httpDeleteSequencesBySequenceIdItemsByItemId = (
  sequenceId: string,
  itemId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSequencesBySequenceIdItemsByItemId,
  method: httpMethod.delete,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/items/${encodeURIComponent(itemId)}/`,
  params: { sequenceId, itemId },
  headers,
});

/**
 * `PUT /v1/sequences/{sequence_id}/items/{item_id}/position/`
 *
 * Update a sequence item position
 *
 * Required roles:
 *  - can_add_sequence_items
 *
 * Responses
 * - 201 - Returns an updated item
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSequenceItemSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_sequences__sequence_id__items__item_id__position_}
 */
export const httpPutSequencesBySequenceIdItemsByItemIdPosition = (
  sequenceId: string,
  itemId: string,
  body: AssetsSequenceItemUpdatePositionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutSequencesBySequenceIdItemsByItemIdPosition,
  method: httpMethod.put,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/items/${encodeURIComponent(itemId)}/position/`,
  params: { sequenceId, itemId },
  body,
  headers,
});

/**
 * `POST /v1/sequences/{sequence_id}/reindex/`
 *
 * Reindex the sequence
 *
 * Required roles:
 *  - can_reindex_sequences
 *
 * Responses
 * - 201 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Sequence does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_sequences__sequence_id__reindex_}
 */
export const httpPostSequencesBySequenceIdReindex = (
  sequenceId: string,
  body: AssetsReindexSequenceSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSequencesBySequenceIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/sequences/${encodeURIComponent(sequenceId)}/reindex/`,
  params: { sequenceId },
  body,
  headers,
});

/**
 * `POST /v1/share/{object_type}/`
 *
 * Create a new share of multiple objects (currently only assets are supported)
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 201 - Returns a created share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Shares are restricted by system administator
 *
 * Response {@link AssetsShareSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_share__object_type__}
 */
export const httpPostShareByObjectType = (
  objectType: string,
  body: AssetsBulkShareCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostShareByObjectType,
  method: httpMethod.post,
  url: `/API/assets/v1/share/${encodeURIComponent(objectType)}/`,
  params: { objectType },
  body,
  headers,
});

export interface AssetsHttpGetSharesQuery {
  /**
   * Filter by title
   */
  title?: string;
  /**
   * Filter by object_type
   */
  object_type?: string;
  /**
   * Filter by object_id
   */
  object_id?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Filter by title with wildcard support
   */
  query?: string;
  /**
   * Filter shares that have all fields specified in _exists_ (comma separated)
   */
  _exists_?: string;
  /**
   * Filter by date_created. Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: 2018-01-01T10:00:00Z;2018-01-01T15:00:00Z
   */
  date_created?: string;
  /**
   * Filter by date_modified Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  date_modified?: string;
  /**
   * Filter by expires Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  expires?: string;
  /**
   * Include shares created by the current user
   */
  include_created_by_me?: boolean;
  /**
   * Include shares where the current user is a member of the share
   */
  include_member_of?: boolean;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;object_type,desc
   */
  sort?: string;
}

/**
 * `GET /v1/shares/`
 *
 * Get a list of user's shares
 *
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a list of shares
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSharesElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_shares_}
 */
export const httpGetShares = (
  query?: AssetsHttpGetSharesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetShares,
  method: httpMethod.get,
  url: '/API/assets/v1/shares/',

  query,
  headers,
});

export interface AssetsHttpGetSharesAllQuery {
  /**
   * Filter by title
   */
  title?: string;
  /**
   * Filter by object_type
   */
  object_type?: string;
  /**
   * Filter by object_id
   */
  object_id?: string;
  /**
   * Filter by owner_id
   */
  owner_id?: string;
  /**
   * Filter by member_id
   */
  member_id?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Filter by other parameter with wildcard support
   */
  query?: string;
  /**
   * Filter shares that have all fields specified in _exists_ (comma separated)
   */
  _exists_?: string;
  /**
   * Filter by date_created. Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: 2018-01-01T10:00:00Z;2018-01-01T15:00:00Z
   */
  date_created?: string;
  /**
   * Filter by date_modified Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  date_modified?: string;
  /**
   * Filter by expires Can either be a single ISO8601 timestamp or two timestamps separated by a semicolon `;`. The timestamp can also be expressed as number of milliseconds since Jan 1 1970 (epoch). Either timestamp can also be replaced with an asterisk `*` to make the query open ended.
   * For example: *;1544450400
   */
  expires?: string;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - title,asc;object_type,desc
   */
  sort?: string;
}

/**
 * `GET /v1/shares/all/`
 *
 * Get a list of all domain shares
 *
 * Required roles:
 *  - can_manage_all_shares
 *
 * Responses
 * - 200 - Returns a list of shares
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSharesElasticSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_shares_all_}
 */
export const httpGetSharesAll = (
  query?: AssetsHttpGetSharesAllQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSharesAll,
  method: httpMethod.get,
  url: '/API/assets/v1/shares/all/',

  query,
  headers,
});

/**
 * `GET /v1/shares/allowlist/entries/`
 *
 * Get all magic link allowlist entries.
 *
 *
 * Responses
 * - 200 - List of allowlist entries
 * - 403 - Forbidden
 *
 * Response {@link AssetsMagicLinkAllowlistListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_shares_allowlist_entries_}
 */
export const httpGetSharesAllowlistEntries = (headers?: IconikApiHeaders) => ({
  id: AssetsHttpGetSharesAllowlistEntries,
  method: httpMethod.get,
  url: '/API/assets/v1/shares/allowlist/entries/',

  headers,
});

/**
 * `POST /v1/shares/allowlist/entries/`
 *
 * Create a new magic link allowlist entry.
 *
 *
 * Responses
 * - 201 - Allowlist entry created
 * - 400 - Bad request / Validation error
 * - 403 - Forbidden
 * - 409 - Entry already exists
 *
 * Response {@link AssetsMagicLinkAllowlistEntrySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_shares_allowlist_entries_}
 */
export const httpPostSharesAllowlistEntries = (
  body: AssetsMagicLinkAllowlistCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSharesAllowlistEntries,
  method: httpMethod.post,
  url: '/API/assets/v1/shares/allowlist/entries/',

  body,
  headers,
});

/**
 * `DELETE /v1/shares/allowlist/entries/{entry_id}/`
 *
 * Delete an allowlist entry.
 *
 *
 * Responses
 * - 204 - Entry deleted successfully
 * - 400 - Bad request
 * - 403 - Forbidden
 * - 404 - Entry not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_shares_allowlist_entries__entry_id__}
 */
export const httpDeleteSharesAllowlistEntriesByEntryId = (
  entryId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSharesAllowlistEntriesByEntryId,
  method: httpMethod.delete,
  url: `/API/assets/v1/shares/allowlist/entries/${encodeURIComponent(entryId)}/`,
  params: { entryId },
  headers,
});

/**
 * `GET /v1/shares/allowlist/entries/{entry_id}/`
 *
 * Get a single allowlist entry by ID.
 *
 *
 * Responses
 * - 200 - Allowlist entry details
 * - 400 - Bad request
 * - 403 - Forbidden
 * - 404 - Entry not found
 *
 * Response {@link AssetsMagicLinkAllowlistEntrySchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_shares_allowlist_entries__entry_id__}
 */
export const httpGetSharesAllowlistEntriesByEntryId = (
  entryId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSharesAllowlistEntriesByEntryId,
  method: httpMethod.get,
  url: `/API/assets/v1/shares/allowlist/entries/${encodeURIComponent(entryId)}/`,
  params: { entryId },
  headers,
});

/**
 * `PUT /v1/shares/allowlist/entries/{entry_id}/`
 *
 * Update an allowlist entry.
 *
 *
 * Responses
 * - 200 - Updated allowlist entry
 * - 400 - Bad request
 * - 403 - Forbidden
 * - 404 - Entry not found
 * - 409 - New value conflicts with existing entry
 *
 * Response {@link AssetsMagicLinkAllowlistEntrySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_shares_allowlist_entries__entry_id__}
 */
export const httpPutSharesAllowlistEntriesByEntryId = (
  entryId: string,
  body: AssetsMagicLinkAllowlistUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutSharesAllowlistEntriesByEntryId,
  method: httpMethod.put,
  url: `/API/assets/v1/shares/allowlist/entries/${encodeURIComponent(entryId)}/`,
  params: { entryId },
  body,
  headers,
});

/**
 * `POST /v1/shares/auth/login/`
 *
 * Login for share
 *
 *
 * Responses
 * - 200 - Returns a token
 * - 400 - Bad request
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_shares_auth_login_}
 */
export const httpPostSharesAuthLogin = (
  body: AssetsShareLoginSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSharesAuthLogin,
  method: httpMethod.post,
  url: '/API/assets/v1/shares/auth/login/',

  body,
  headers,
});

export interface AssetsHttpGetSharesAuthTokenHeader extends IconikApiHeaders {
  'Share-Auth-Token': string;
}

/**
 * `GET /v1/shares/auth/token/`
 *
 * Check if a token is valid
 *
 *
 * Responses
 * - 200 - Returns an updated share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareTokenSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_shares_auth_token_}
 */
export const httpGetSharesAuthToken = (
  headers: AssetsHttpGetSharesAuthTokenHeader,
) => ({
  id: AssetsHttpGetSharesAuthToken,
  method: httpMethod.get,
  url: '/API/assets/v1/shares/auth/token/',

  headers,
});

export interface AssetsHttpPutSharesAuthTokenHeader extends IconikApiHeaders {
  'Share-Auth-Token': string;
}

/**
 * `PUT /v1/shares/auth/token/`
 *
 * Refreshes a token for share
 *
 *
 * Responses
 * - 200 - Returns a newly generated token
 * - 400 - Bad request
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_shares_auth_token_}
 */
export const httpPutSharesAuthToken = (
  headers: AssetsHttpPutSharesAuthTokenHeader,
) => ({
  id: AssetsHttpPutSharesAuthToken,
  method: httpMethod.put,
  url: '/API/assets/v1/shares/auth/token/',

  headers,
});

/**
 * `DELETE /v1/shares/bulk/`
 *
 * Delete current user's multiple shares by ids
 *
 * Required roles:
 *  - can_delete_object_shares
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_shares_bulk_}
 */
export const httpDeleteSharesBulk = (
  body: AssetsBulkShareDeleteSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSharesBulk,
  method: httpMethod.delete,
  url: '/API/assets/v1/shares/bulk/',

  body,
  headers,
});

/**
 * `DELETE /v1/shares/bulk/all/`
 *
 * Delete multiple shares by ids
 *
 * Required roles:
 *  - can_manage_all_shares
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_shares_bulk_all_}
 */
export const httpDeleteSharesBulkAll = (
  body: AssetsBulkShareDeleteSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSharesBulkAll,
  method: httpMethod.delete,
  url: '/API/assets/v1/shares/bulk/all/',

  body,
  headers,
});

/**
 * Magic link creation is enabled
 */
export interface AssetsHttpPostSharesMagicLinkEnabledResponse {
  system_domain_id?: string;
}

/**
 * `POST /v1/shares/magic_link/enabled/`
 *
 * Check if magic link authentication is enabled for the share's system domain.
 *
 *
 * Responses
 * - 200 - Magic link creation is enabled
 * - 400 - Magic link not enabled
 * - 404 - Share not found
 * - 429 - Rate limit exceeded
 *
 * Response {@link AssetsHttpPostSharesMagicLinkEnabledResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_shares_magic_link_enabled_}
 */
export const httpPostSharesMagicLinkEnabled = (
  body: AssetsMagicLinkCheckSettingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSharesMagicLinkEnabled,
  method: httpMethod.post,
  url: '/API/assets/v1/shares/magic_link/enabled/',

  body,
  headers,
});

/**
 * Magic link sent successfully
 */
export interface AssetsHttpPostSharesByShareIdMagicLinkRequestResponse {
  expires_in_minutes?: number;
  message?: string;
}

/**
 * `POST /v1/shares/{share_id}/magic_link/request/`
 *
 * Request a magic link for share access.
 *
 * <br/>Creates a ShareUser and generates a magic link token for the recipient.
 *
 * Responses
 * - 200 - Magic link sent successfully
 * - 400 - Bad request
 * - 404 - Share not found
 * - 429 - Rate limit exceeded
 *
 * Response {@link AssetsHttpPostSharesByShareIdMagicLinkRequestResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_shares__share_id__magic_link_request_}
 */
export const httpPostSharesByShareIdMagicLinkRequest = (
  shareId: string,
  body: AssetsMagicLinkRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSharesByShareIdMagicLinkRequest,
  method: httpMethod.post,
  url: `/API/assets/v1/shares/${encodeURIComponent(shareId)}/magic_link/request/`,
  params: { shareId },
  body,
  headers,
});

/**
 * `POST /v1/shares/{share_id}/magic_link/validate/`
 *
 * Validates the email and single-use hash, and returns a share authorization token.
 *
 * <br/>The hash is consumed upon first use and cannot be reused.
 *
 * Responses
 * - 200 - Token validated successfully
 * - 400 - Bad request or invalid token
 * - 404 - Share not found
 * - 429 - Rate limit exceeded
 *
 * Response {@link AssetsShareTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_shares__share_id__magic_link_validate_}
 */
export const httpPostSharesByShareIdMagicLinkValidate = (
  shareId: string,
  body: AssetsMagicLinkValidateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSharesByShareIdMagicLinkValidate,
  method: httpMethod.post,
  url: `/API/assets/v1/shares/${encodeURIComponent(shareId)}/magic_link/validate/`,
  params: { shareId },
  body,
  headers,
});

/**
 * `POST /v1/sync/sessions/`
 *
 * Create a new sync session
 *
 *
 * Responses
 * - 201 - Returns a created sync session
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSyncSessionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1_sync_sessions_}
 */
export const httpPostSyncSessions = (
  body: AssetsSyncSessionCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostSyncSessions,
  method: httpMethod.post,
  url: '/API/assets/v1/sync/sessions/',

  body,
  headers,
});

/**
 * `DELETE /v1/sync/sessions/{sync_session_id}/`
 *
 * Delete a particular sync session by id
 *
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Playlist does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1_sync_sessions__sync_session_id__}
 */
export const httpDeleteSyncSessionsBySyncSessionId = (
  syncSessionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteSyncSessionsBySyncSessionId,
  method: httpMethod.delete,
  url: `/API/assets/v1/sync/sessions/${encodeURIComponent(syncSessionId)}/`,
  params: { syncSessionId },
  headers,
});

/**
 * `GET /v1/sync/sessions/{sync_session_id}/`
 *
 * Returns a particular sync session by id. If a session with such id doesn't exist,
 *
 * a new one is created
 *
 * Responses
 * - 200 - Returns an existing sync session
 * - 201 - Returns a newly created sync session
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSyncSessionSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1_sync_sessions__sync_session_id__}
 */
export const httpGetSyncSessionsBySyncSessionId = (
  syncSessionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetSyncSessionsBySyncSessionId,
  method: httpMethod.get,
  url: `/API/assets/v1/sync/sessions/${encodeURIComponent(syncSessionId)}/`,
  params: { syncSessionId },
  headers,
});

export type AssetsSyncSessionSchemaPartial = Partial<AssetsSyncSessionSchema>;

export interface AssetsHttpPatchSyncSessionsBySyncSessionIdQuery {
  /**
   * Update only if the field is not set (set to None) in the database
   */
  update_if_none?: boolean;
}

/**
 * `PATCH /v1/sync/sessions/{sync_session_id}/`
 *
 * Edit a sync session. If the session doesn't exist, a new one is created
 *
 *
 * Responses
 * - 200 - Returns an updated sync session
 * - 201 - Returns a newly created sync session
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSyncSessionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1_sync_sessions__sync_session_id__}
 */
export const httpPatchSyncSessionsBySyncSessionId = (
  syncSessionId: string,
  body: AssetsSyncSessionSchemaPartial,
  query?: AssetsHttpPatchSyncSessionsBySyncSessionIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchSyncSessionsBySyncSessionId,
  method: httpMethod.patch,
  url: `/API/assets/v1/sync/sessions/${encodeURIComponent(syncSessionId)}/`,
  params: { syncSessionId },
  body,
  query,
  headers,
});

export interface AssetsHttpPutSyncSessionsBySyncSessionIdQuery {
  /**
   * Update only if the field is not set (set to None) in the database
   */
  update_if_none?: boolean;
}

/**
 * `PUT /v1/sync/sessions/{sync_session_id}/`
 *
 * Edit a sync session. If the session doesn't exist, a new one is created
 *
 *
 * Responses
 * - 200 - Returns an updated sync session
 * - 201 - Returns a newly created sync session
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AssetsSyncSessionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1_sync_sessions__sync_session_id__}
 */
export const httpPutSyncSessionsBySyncSessionId = (
  syncSessionId: string,
  body: AssetsSyncSessionSchema,
  query?: AssetsHttpPutSyncSessionsBySyncSessionIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutSyncSessionsBySyncSessionId,
  method: httpMethod.put,
  url: `/API/assets/v1/sync/sessions/${encodeURIComponent(syncSessionId)}/`,
  params: { syncSessionId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/approvals/`
 *
 * Deletes an objects approval status
 *
 *
 * Responses
 * - 204 - Empty body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__approvals_}
 */
export const httpDeleteByObjectTypeByObjectIdApprovals = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteByObjectTypeByObjectIdApprovals,
  method: httpMethod.delete,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/`,
  params: { objectType, objectId },
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/approvals/`
 *
 * Returns an objects approval request
 *
 * Required roles:
 *  - can_read_approval_request
 *
 * Responses
 * - 200 - Returns an objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalsBySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__approvals_}
 */
export const httpGetByObjectTypeByObjectIdApprovals = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdApprovals,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/`,
  params: { objectType, objectId },
  headers,
});

/**
 * `PUT /v1/{object_type}/{object_id}/approvals/`
 *
 * Adds the approval by user and returns an objects approval status
 *
 * Required roles:
 *  - can_write_approval_status
 *
 * Responses
 * - 200 - Returns an objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalBySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1__object_type___object_id__approvals_}
 */
export const httpPutByObjectTypeByObjectIdApprovals = (
  objectType: string,
  objectId: string,
  body: AssetsApprovalBySchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutByObjectTypeByObjectIdApprovals,
  method: httpMethod.put,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/approvals/external/{email}/`
 *
 * Deletes an objects approval status by user_id
 *
 * Required roles:
 *  - can_delete_approval_status
 *
 * Responses
 * - 204 - Empty body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__approvals_external__email__}
 */
export const httpDeleteByObjectTypeByObjectIdApprovalsExternalByEmail = (
  objectType: string,
  objectId: string,
  email: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteByObjectTypeByObjectIdApprovalsExternalByEmail,
  method: httpMethod.delete,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/external/${encodeURIComponent(email)}/`,
  params: { objectType, objectId, email },
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/approvals/request/`
 *
 * Deletes an objects approval request
 *
 * Required roles:
 *  - can_delete_approval_request
 *
 * Responses
 * - 200 - Returns a objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__approvals_request_}
 */
export const httpDeleteByObjectTypeByObjectIdApprovalsRequest = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteByObjectTypeByObjectIdApprovalsRequest,
  method: httpMethod.delete,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/request/`,
  params: { objectType, objectId },
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/approvals/request/`
 *
 * Returns an objects approval request
 *
 * Required roles:
 *  - can_read_approval_request
 *
 * Responses
 * - 200 - Returns a objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__approvals_request_}
 */
export const httpGetByObjectTypeByObjectIdApprovalsRequest = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdApprovalsRequest,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/request/`,
  params: { objectType, objectId },
  headers,
});

export type AssetsApprovalSchemaPartial = Partial<AssetsApprovalSchema>;

/**
 * `PATCH /v1/{object_type}/{object_id}/approvals/request/`
 *
 * Edits an approval request
 *
 * Required roles:
 *  - can_write_approval_request
 *
 * Responses
 * - 200 - Returns a assets approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1__object_type___object_id__approvals_request_}
 */
export const httpPatchByObjectTypeByObjectIdApprovalsRequest = (
  objectType: string,
  objectId: string,
  body: AssetsApprovalSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPatchByObjectTypeByObjectIdApprovalsRequest,
  method: httpMethod.patch,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/request/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `POST /v1/{object_type}/{object_id}/approvals/request/`
 *
 * Creates an objects approval request
 *
 * Required roles:
 *  - can_write_approval_request
 *
 * Responses
 * - 201 - Returns a created approval
 * - 202 - Returns a job_id of the background approval request
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1__object_type___object_id__approvals_request_}
 */
export const httpPostByObjectTypeByObjectIdApprovalsRequest = (
  objectType: string,
  objectId: string,
  body: AssetsApprovalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostByObjectTypeByObjectIdApprovalsRequest,
  method: httpMethod.post,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/request/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `PUT /v1/{object_type}/{object_id}/approvals/request/`
 *
 * Edits an approval request
 *
 * Required roles:
 *  - can_write_approval_request
 *
 * Responses
 * - 200 - Returns a assets approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1__object_type___object_id__approvals_request_}
 */
export const httpPutByObjectTypeByObjectIdApprovalsRequest = (
  objectType: string,
  objectId: string,
  body: AssetsApprovalSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutByObjectTypeByObjectIdApprovalsRequest,
  method: httpMethod.put,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/request/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/approvals/user/{user_id}/`
 *
 * Deletes an objects approval status by user_id
 *
 * Required roles:
 *  - can_delete_approval_status
 *
 * Responses
 * - 204 - Empty body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__approvals_user__user_id__}
 */
export const httpDeleteByObjectTypeByObjectIdApprovalsUserByUserId = (
  objectType: string,
  objectId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteByObjectTypeByObjectIdApprovalsUserByUserId,
  method: httpMethod.delete,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/approvals/user/${encodeURIComponent(userId)}/`,
  params: { objectType, objectId, userId },
  headers,
});

export interface AssetsHttpGetByObjectTypeByObjectIdSharesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
}

/**
 * `GET /v1/{object_type}/{object_id}/shares/`
 *
 * Get list of object shares
 *
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a list of share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsSharesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__shares_}
 */
export const httpGetByObjectTypeByObjectIdShares = (
  objectType: string,
  objectId: string,
  query?: AssetsHttpGetByObjectTypeByObjectIdSharesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdShares,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/`,
  params: { objectType, objectId },
  query,
  headers,
});

/**
 * `POST /v1/{object_type}/{object_id}/shares/`
 *
 * Create a new share.
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 202 - Returns a created share; the URL field will be null as a notification email has been sent to the specified email addresses with the share URLs embedded in it
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Shares are restricted by system administator
 *
 * Response {@link AssetsShareSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1__object_type___object_id__shares_}
 */
export const httpPostByObjectTypeByObjectIdShares = (
  objectType: string,
  objectId: string,
  body: AssetsShareCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostByObjectTypeByObjectIdShares,
  method: httpMethod.post,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `POST /v1/{object_type}/{object_id}/shares/url/`
 *
 * Generates a URL for the shared object
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 200 - Returns a URL link in the body of the response that can be shared and used to access the object
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Shares are restricted by system administator
 *
 * Response {@link AssetsShareURLSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1__object_type___object_id__shares_url_}
 */
export const httpPostByObjectTypeByObjectIdSharesUrl = (
  objectType: string,
  objectId: string,
  body: AssetsShareURLCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostByObjectTypeByObjectIdSharesUrl,
  method: httpMethod.post,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/url/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/shares/{share_id}/`
 *
 * Delete a particular share by id
 *
 * Required roles:
 *  - can_delete_object_shares
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__shares__share_id__}
 */
export const httpDeleteByObjectTypeByObjectIdSharesByShareId = (
  objectType: string,
  objectId: string,
  shareId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareId,
  method: httpMethod.delete,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/`,
  params: { objectType, objectId, shareId },
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/shares/{share_id}/`
 *
 * Returns a particular share by id
 *
 *
 * Responses
 * - 200 - Returns a share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsGetShareSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__shares__share_id__}
 */
export const httpGetByObjectTypeByObjectIdSharesByShareId = (
  objectType: string,
  objectId: string,
  shareId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdSharesByShareId,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/`,
  params: { objectType, objectId, shareId },
  headers,
});

export interface AssetsHttpPutByObjectTypeByObjectIdSharesByShareIdQuery {
  index_immediately?: string;
}

/**
 * `PUT /v1/{object_type}/{object_id}/shares/{share_id}/`
 *
 * Update share
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 200 - Returns an updated share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1__object_type___object_id__shares__share_id__}
 */
export const httpPutByObjectTypeByObjectIdSharesByShareId = (
  objectType: string,
  objectId: string,
  shareId: string,
  body: AssetsShareSchema,
  query?: AssetsHttpPutByObjectTypeByObjectIdSharesByShareIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutByObjectTypeByObjectIdSharesByShareId,
  method: httpMethod.put,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/`,
  params: { objectType, objectId, shareId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/{object_type}/{object_id}/shares/{share_id}/reindex/`
 *
 * Reindex the share
 *
 * Required roles:
 *  - can_reindex_shares
 *
 * Responses
 * - 201 - Without body
 * - 401 - Token is invalid
 * - 404 - Asset share does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1__object_type___object_id__shares__share_id__reindex_}
 */
export const httpPostByObjectTypeByObjectIdSharesByShareIdReindex = (
  objectType: string,
  objectId: string,
  shareId: string,
  body: AssetsReindexShareSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdReindex,
  method: httpMethod.post,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/reindex/`,
  params: { objectType, objectId, shareId },
  body,
  headers,
});

export interface AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
}

/**
 * `GET /v1/{object_type}/{object_id}/shares/{share_id}/users/`
 *
 * Get list of share users
 *
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a list of share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsShareUsersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__shares__share_id__users_}
 */
export const httpGetByObjectTypeByObjectIdSharesByShareIdUsers = (
  objectType: string,
  objectId: string,
  shareId: string,
  query?: AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsers,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/`,
  params: { objectType, objectId, shareId },
  query,
  headers,
});

/**
 * `POST /v1/{object_type}/{object_id}/shares/{share_id}/users/`
 *
 * Add a new share_user to a share
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 201 - Returns a created share user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission denied
 *
 * Response {@link AssetsShareUserSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/post_v1__object_type___object_id__shares__share_id__users_}
 */
export const httpPostByObjectTypeByObjectIdSharesByShareIdUsers = (
  objectType: string,
  objectId: string,
  shareId: string,
  body: AssetsShareUserSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPostByObjectTypeByObjectIdSharesByShareIdUsers,
  method: httpMethod.post,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/`,
  params: { objectType, objectId, shareId },
  body,
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/shares/{share_id}/users/{share_user_id}/`
 *
 * Delete a particular share_user user by id
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/delete_v1__object_type___object_id__shares__share_id__users__share_user_id__}
 */
export const httpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  (
    objectType: string,
    objectId: string,
    shareId: string,
    shareUserId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId,
    method: httpMethod.delete,
    url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/${encodeURIComponent(shareUserId)}/`,
    params: { objectType, objectId, shareId, shareUserId },
    headers,
  });

/**
 * `GET /v1/{object_type}/{object_id}/shares/{share_id}/users/{share_user_id}/`
 *
 * Returns a particular share user by id
 *
 * Required roles:
 *  - can_read_shares
 *
 * Responses
 * - 200 - Returns a share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareUserSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__shares__share_id__users__share_user_id__}
 */
export const httpGetByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId = (
  objectType: string,
  objectId: string,
  shareId: string,
  shareUserId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/${encodeURIComponent(shareUserId)}/`,
  params: { objectType, objectId, shareId, shareUserId },
  headers,
});

export type AssetsShareUserSchemaPartial = Partial<AssetsShareUserSchema>;

/**
 * `PATCH /v1/{object_type}/{object_id}/shares/{share_id}/users/{share_user_id}/`
 *
 * Update share user
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 200 - Returns an updated share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/patch_v1__object_type___object_id__shares__share_id__users__share_user_id__}
 */
export const httpPatchByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId =
  (
    objectType: string,
    objectId: string,
    shareId: string,
    shareUserId: string,
    body: AssetsShareUserSchemaPartial,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpPatchByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId,
    method: httpMethod.patch,
    url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/${encodeURIComponent(shareUserId)}/`,
    params: { objectType, objectId, shareId, shareUserId },
    body,
    headers,
  });

/**
 * `PUT /v1/{object_type}/{object_id}/shares/{share_id}/users/{share_user_id}/`
 *
 * Update share user
 *
 * Required roles:
 *  - can_write_shares
 *
 * Responses
 * - 200 - Returns an updated share
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Share does not exist
 *
 * Response {@link AssetsShareUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/put_v1__object_type___object_id__shares__share_id__users__share_user_id__}
 */
export const httpPutByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId = (
  objectType: string,
  objectId: string,
  shareId: string,
  shareUserId: string,
  body: AssetsShareUserSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpPutByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId,
  method: httpMethod.put,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/shares/${encodeURIComponent(shareId)}/users/${encodeURIComponent(shareUserId)}/`,
  params: { objectType, objectId, shareId, shareUserId },
  body,
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/versions/{version_id}/approvals/`
 *
 * Returns an objects approval request by version
 *
 * Required roles:
 *  - can_read_approval_request
 *
 * Responses
 * - 200 - Returns a objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalsBySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__versions__version_id__approvals_}
 */
export const httpGetByObjectTypeByObjectIdVersionsByVersionIdApprovals = (
  objectType: string,
  objectId: string,
  versionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovals,
  method: httpMethod.get,
  url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/versions/${encodeURIComponent(versionId)}/approvals/`,
  params: { objectType, objectId, versionId },
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/versions/{version_id}/approvals/request/`
 *
 * Returns an objects approval request by version
 *
 * Required roles:
 *  - can_read_approval_request
 *
 * Responses
 * - 200 - Returns a objects approval
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AssetsApprovalSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/assets/spec/#/default/get_v1__object_type___object_id__versions__version_id__approvals_request_}
 */
export const httpGetByObjectTypeByObjectIdVersionsByVersionIdApprovalsRequest =
  (
    objectType: string,
    objectId: string,
    versionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AssetsHttpGetByObjectTypeByObjectIdVersionsByVersionIdApprovalsRequest,
    method: httpMethod.get,
    url: `/API/assets/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/versions/${encodeURIComponent(versionId)}/approvals/request/`,
    params: { objectType, objectId, versionId },
    headers,
  });
